const COMBINED_COLOR = "#eab308";
const COLORS = ["#215de1", "#10b981", "#FF0044", "#6600FF", "#E4FF04", "#06B6D4", "#D946EF", "#00FFAA", "#8b5cf6"];
const MONTH_WEIGHTS_DE = [0.029, 0.047, 0.078, 0.107, 0.127, 0.134, 0.131, 0.118, 0.088, 0.065, 0.043, 0.033];
const MONTH_LABELS = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];
const DAYS_IN_MONTH_DE = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const LS_KEY = "solarVorhersageTeslaV4";
const DEFAULT_ANNUAL_CONSUMPTION_KWH = 2750;
const EV_SINGLE_PHASE_MIN_KW = 1.38;
const EV_THREE_PHASE_MIN_KW = 4.14;
const EV_SINGLE_PHASE_MAX_KW = 4.6;
const BATTERY_EXTENSION_LIMIT = 14;
const DEFAULTS = Object.freeze({
  theme: "light",
  locationName: "Frankfurt am Main",
  locationSource: "manual",
  countryHint: "Deutschland",
  lat: 49.38,
  lon: 8.66,
  tz: "Europe/Berlin",
  selectedDayIndex: 1,
  inverterLimitEnabled: false,
  plugSolarLimit: false,
  inverterPower: 0.8,
  systemCost: 0,
  batterySystemCost: 0,
  electricityPrice: 0.374,
  expertMode: false,
  feedInTariff: 0.0778,
  selfConsumption: null,
  performanceRatio: null,
  inverterAdvancedEnabled: false,
  inverterType: "micro",
  inverterMpptCount: null,
  inverterDcAcRatio: null,
  inverterShadeEnabled: false,
  inverterShadeLevel: "light",
  priceIncrease: true,
  annualSource: "auto",
  pvgisProxy: "",
  batteryMode: false,
  batteryPreset: "custom",
  annualConsumptionKwh: DEFAULT_ANNUAL_CONSUMPTION_KWH,
  annualConsumptionHouseKwh: DEFAULT_ANNUAL_CONSUMPTION_KWH,
  annualConsumptionEdited: false,
  batteryBaseCapacityKwh: 2.7,
  batteryCapacityKwh: 2.7,
  batteryChargeKw: 1.2,
  batteryDischargeKw: 1.2,
  batteryOutputKw: 1.2,
  batteryType: "all_in_one",
  batteryEfficiencyPct: 91,
  batteryPlugIn: false,
  batterySocMinPct: 5,
  batterySocMaxPct: 100,
  batteryExtensionsEnabled: false,
  batteryExtensionMode: "same",
  batteryExtensionCount: 0,
  batteryExtensionCapacityKwh: 2.7,
  batteryExtensionModules: [],
  smartMeterInstalled: false,
  evMode: false,
  evAnnualKm: 10000,
  evKwhPer100Km: 18,
  evScheduleMode: "daily",
  evTypicalTime: "evening",
  evWeeklyDays: [1, 3, 5],
  evChargeSpeedKw: 11,
  evChargingType: "ac",
  evPhaseMode: "hybrid",
  evBatteryKwh: 60,
  evTypicalChargeLimitPct: 90,
  evAddOnTop: true,
  evAnnualKwh: 2040,
  evEfficiencyPct: 88,
  evPromptKey: "",
  loadProfile: "berufstaetig",
  loadCurveVisible: true,
  savingsForecastMode: "day",
  mainChartMode: "yearly",
  yearlyChartMode: "average",
  showEnergyFlow: false
});

function createDefaultState() {
  return {
    ...DEFAULTS,
    evWeeklyDays: [...DEFAULTS.evWeeklyDays],
    batteryExtensionModules: [...DEFAULTS.batteryExtensionModules],
    activeSeries: { combined: true, areas: [] },
    areas: [
      { name: "Ost", azimuth: 90, tilt: 35, kwp: 1.0, color: COLORS[0] },
      { name: "West", azimuth: 270, tilt: 35, kwp: 1.0, color: COLORS[1] }
    ]
  };
}
const BATTERY_PRESETS = {
  custom: null,
  anker_solix_2_pro: { capacityKwh: 1.6, chargeKw: 1, dischargeKw: 1, outputKw: 1.0, type: "all_in_one", efficiencyPct: 90, plugIn: false },
  anker_solix_3_pro: { capacityKwh: 2.7, chargeKw: 2.0, dischargeKw: 2.0, outputKw: 1.2, type: "all_in_one", efficiencyPct: 92, plugIn: false },
  ecoflow_stream_ultra: { capacityKwh: 1.92, chargeKw: 2.0, dischargeKw: 2.0, outputKw: 1.2, type: "all_in_one", efficiencyPct: 91, plugIn: false },
  "marstek_venus-e-gen3": { capacityKwh: 5.12, chargeKw: 2.5, dischargeKw: 2.5, outputKw: 2.5, type: "ac", efficiencyPct: 85, plugIn: false }
};
const LOCATION_ICON = "https://cdn.shopify.com/s/files/1/0868/2169/9918/files/my_location.svg";
const LOAD_PROFILES = {
  berufstaetig: [0.03, 0.025, 0.02, 0.018, 0.02, 0.03, 0.05, 0.06, 0.04, 0.03, 0.028, 0.03, 0.032, 0.035, 0.04, 0.045, 0.055, 0.075, 0.09, 0.085, 0.07, 0.055, 0.04, 0.032],
  familie: [0.03, 0.028, 0.024, 0.022, 0.024, 0.035, 0.055, 0.07, 0.065, 0.045, 0.04, 0.042, 0.045, 0.047, 0.05, 0.055, 0.06, 0.075, 0.085, 0.08, 0.065, 0.055, 0.045, 0.036],
  homeoffice: [0.032, 0.03, 0.026, 0.024, 0.026, 0.034, 0.045, 0.05, 0.052, 0.05, 0.048, 0.047, 0.046, 0.046, 0.048, 0.05, 0.055, 0.065, 0.075, 0.072, 0.06, 0.052, 0.045, 0.04],
  rentner: [0.035, 0.033, 0.03, 0.028, 0.03, 0.035, 0.042, 0.048, 0.052, 0.055, 0.056, 0.055, 0.053, 0.052, 0.052, 0.054, 0.058, 0.065, 0.072, 0.07, 0.06, 0.052, 0.046, 0.04],
  schichtdienst: [0.05, 0.045, 0.04, 0.035, 0.03, 0.03, 0.03, 0.035, 0.04, 0.042, 0.04, 0.038, 0.036, 0.034, 0.036, 0.04, 0.045, 0.052, 0.06, 0.067, 0.07, 0.064, 0.056, 0.05],
  single: [0.026, 0.024, 0.022, 0.02, 0.02, 0.024, 0.03, 0.034, 0.03, 0.024, 0.022, 0.022, 0.023, 0.024, 0.026, 0.03, 0.038, 0.05, 0.07, 0.072, 0.06, 0.046, 0.035, 0.03],
};
const LOAD_PROFILE_HINTS = {
  berufstaetig: "Höherer Verbrauch morgens/abends, tagsüber reduziert.",
  familie: "Zwei Lastspitzen: morgens und abends, tagsüber mittel.",
  homeoffice: "Relativ gleichmäßig mit leichtem Abendanstieg.",
  rentner: "Konstantere Tageslast mit moderatem Abendpeak.",
  schichtdienst: "Unregelmäßigere Last mit höherem Nacht-/Spätanteil.",
  single: "Niedrige Grundlast, klarer Verbrauchsschwerpunkt am Abend.",
};
const INVERTER_SHADE_FACTORS = Object.freeze({
  micro: { light: 0.97, medium: 0.9, strong: 0.8 },
  aio: { light: 0.95, medium: 0.85, strong: 0.72 },
  string: { light: 0.93, medium: 0.78, strong: 0.6 },
  hybrid: { light: 0.94, medium: 0.82, strong: 0.66 }
});

let state = createDefaultState();
let pendingAreaRemovalIndex = null;

const configState = state;
const uiState = state;
const runtimeState = {
  rawForecast: null,
  rawAnnual: null,
  derivedModels: null,
  derivedKey: "",
  invalidationVersion: 0,
  pendingScopes: new Set(),
  renderScheduled: false,
  renderCallback: null,
  persistTimer: null,
  refreshTimer: null,
  lastRefreshToken: 0,
  refreshNonce: 0,
  chartRenderNonce: 0,
  lastSeriesTapKey: "",
  lastSeriesTapAt: 0,
  flowCache: new Map(),
  wasIntegratedInverter: false,
  previousPlugSolarLimit: null,
  previousInverterPower: null,
  currentForecastStatus: "idle",
  currentForecastMessage: "",
  areaEditorDrafts: [],
  areaEditorOpen: new Set()
};
runtimeState.lastCostComponentEdited = "battery";

function loadStoredState() {
  const raw = localStorage.getItem(LS_KEY);
  if (!raw) return false;
  try {
    const saved = JSON.parse(raw);
    const merged = saved?.configState || saved?.uiState
      ? { ...(saved.configState || {}), ...(saved.uiState || {}) }
      : { ...(saved || {}) };
    const savedActiveSeries = merged.activeSeries;
    delete merged.activeSeries;
    if (saved?.configState || saved?.uiState) {
      Object.assign(state, merged);
    } else {
      Object.assign(state, merged);
    }
    if (!Number.isFinite(state.annualConsumptionHouseKwh)) {
      state.annualConsumptionHouseKwh = Math.max(0, Number(state.annualConsumptionKwh || 0));
    }
    if (!["gps", "manual"].includes(state.locationSource)) state.locationSource = "manual";
    if (savedActiveSeries) {
      state.activeSeries.combined = savedActiveSeries.combined !== false;
      state.activeSeries.areas = Array.isArray(savedActiveSeries.areas) ? [...savedActiveSeries.areas] : [];
    }
    if (Array.isArray(state.areas)) {
      state.areas.splice(0, state.areas.length, ...state.areas.map((area, index) => ({ ...area, color: COLORS[index % COLORS.length] })));
    }
    if (!state.activeSeries) state.activeSeries = { combined: true, areas: [] };
    return true;
  } catch {
    return false;
  }
}

function persistState() {
  localStorage.setItem(LS_KEY, JSON.stringify(state));
}

function schedulePersist(delay = 250) {
  clearTimeout(runtimeState.persistTimer);
  runtimeState.persistTimer = setTimeout(() => {
    runtimeState.persistTimer = null;
    persistState();
  }, delay);
}

function invalidate() {
  runtimeState.invalidationVersion += 1;
  runtimeState.derivedModels = null;
  runtimeState.derivedKey = "";
  runtimeState.flowCache = new Map();
}

function setRenderScheduler(callback) {
  runtimeState.renderCallback = callback;
}

function scheduleRender(scopes = ["all"]) {
  const list = Array.isArray(scopes) ? scopes : [scopes];
  list.filter(Boolean).forEach((scope) => runtimeState.pendingScopes.add(scope));
  if (runtimeState.renderScheduled) return;
  runtimeState.renderScheduled = true;
  const flush = () => {
    runtimeState.renderScheduled = false;
    const pending = new Set(runtimeState.pendingScopes);
    runtimeState.pendingScopes.clear();
    if (runtimeState.renderCallback) runtimeState.renderCallback(pending);
  };
  if (typeof requestAnimationFrame === "function") requestAnimationFrame(flush);
  else setTimeout(flush, 0);
}

function updateUi(patch) {
  Object.assign(state, patch);
}

function createRemoteService(fetchImpl = fetch) {
  const forecastCache = new Map();
  const annualCache = new Map();
  const locationCache = new Map();
  const suggestionCache = new Map();
  let refreshController = null;
  let suggestionController = null;
  let refreshToken = 0;
  const stableKey = (parts) => JSON.stringify(parts);
  const fetchJsonCached = async (cache, key, loader) => {
    if (cache.has(key)) return cache.get(key);
    const promise = loader().catch((error) => {
      cache.delete(key);
      throw error;
    });
    cache.set(key, promise);
    return promise;
  };
  async function loadAreaForecast(config, area, signal) {
    const key = stableKey(["forecast", config.lat, config.lon, config.tz, area.azimuth, area.tilt]);
    return fetchJsonCached(forecastCache, key, async () => {
      const url = new URL("https://api.open-meteo.com/v1/forecast");
      url.search = new URLSearchParams({
        latitude: config.lat,
        longitude: config.lon,
        timezone: config.tz,
        past_days: 1,
        forecast_days: 7,
        hourly: "global_tilted_irradiance,temperature_2m,cloud_cover",
        daily: "sunrise,sunset,sunshine_duration,shortwave_radiation_sum",
        tilt: area.tilt,
        azimuth: openMeteoAzimuth(area.azimuth)
      }).toString();
      const response = await fetchImpl(url.toString(), { signal });
      if (!response.ok) throw new Error(`Open‑Meteo ${response.status}`);
      return response.json();
    });
  }
  async function loadAnnual(config, areas, signal) {
    if (!config.pvgisProxy) throw new Error("Kein PVGIS Weiterleitung eingetragen.");
    const loss = Math.max(0, 100 - (inverterPerformanceFactor(config) * 100));
    const areaMonthly = areas.map(() => Array(12).fill(0));
    await Promise.all(areas.map(async (area) => {
      const areaIndex = areas.indexOf(area);
      const key = stableKey(["annual", config.pvgisProxy, config.lat, config.lon, area.azimuth, area.tilt, area.kwp, loss]);
      const json = await fetchJsonCached(annualCache, key, async () => {
        const target = new URL("https://re.jrc.ec.europa.eu/api/v5_3/PVcalc");
        target.search = new URLSearchParams({
          lat: config.lat,
          lon: config.lon,
          peakpower: area.kwp,
          loss,
          angle: area.tilt,
          aspect: openMeteoAzimuth(area.azimuth),
          outputformat: "json"
        }).toString();
        const proxied = config.pvgisProxy + encodeURIComponent(target.toString());
        const response = await fetchImpl(proxied, { signal });
        if (!response.ok) throw new Error(`PVGIS ${response.status}`);
        return response.json();
      });
      const rows = json?.outputs?.monthly?.fixed || [];
      rows.forEach((row, index) => {
        areaMonthly[areaIndex][index] += Number(row.E_m || (row.E_d * 30) || 0);
      });
    }));
    const monthly = MONTH_LABELS.map((_, index) => sum(areaMonthly.map((series) => series[index] || 0)));
    return { source: "PVGIS PVcalc", monthly, yearly: monthly.reduce((acc, value) => acc + value, 0), areaMonthly };
  }
  return {
    async refreshAnnualData(config, areas) {
      refreshToken += 1;
      if (refreshController) refreshController.abort();
      refreshController = new AbortController();
      const signal = refreshController.signal;
      let rawAnnual = null;
      if (config.annualSource !== "estimate") {
        try {
          rawAnnual = await loadAnnual(config, areas, signal);
        } catch (error) {
          if (config.annualSource === "pvgis") throw error;
          rawAnnual = { error: error.message };
        }
      }
      return { requestId: refreshToken, rawAnnual };
    },
    async refreshForecastData(config, areas) {
      refreshToken += 1;
      if (refreshController) refreshController.abort();
      refreshController = new AbortController();
      const signal = refreshController.signal;
      const rawForecast = await Promise.all(areas.map(async (area) => ({ area, json: await loadAreaForecast(config, area, signal) })));
      return { requestId: refreshToken, rawForecast };
    },
    async searchLocation(query) {
      const trimmed = String(query || "").trim();
      if (!trimmed) return null;
      const key = stableKey(["location", trimmed]);
      return fetchJsonCached(locationCache, key, async () => {
        const url = new URL("https://nominatim.openstreetmap.org/search");
        url.search = new URLSearchParams({ format: "jsonv2", q: trimmed, limit: 1, addressdetails: 1 }).toString();
        const response = await fetchImpl(url.toString(), { headers: { "Accept-Language": "de" } });
        if (!response.ok) throw new Error(`Geocoding ${response.status}`);
        const json = await response.json();
        return json?.[0] || null;
      });
    },
    async fetchLocationSuggestions(query) {
      const trimmed = String(query || "").trim();
      if (!trimmed) return [];
      if (suggestionController) suggestionController.abort();
      suggestionController = new AbortController();
      const key = stableKey(["suggestions", trimmed]);
      return fetchJsonCached(suggestionCache, key, async () => {
        const url = new URL("https://nominatim.openstreetmap.org/search");
        url.search = new URLSearchParams({ format: "jsonv2", q: trimmed, limit: 5, addressdetails: 1 }).toString();
        const response = await fetchImpl(url.toString(), {
          signal: suggestionController.signal,
          headers: { "Accept-Language": "de" }
        });
        if (!response.ok) throw new Error(`Geocoding ${response.status}`);
        return response.json();
      });
    }
  };
}

let forecast = null;
let annual = null;
let measuringAreaIndex = null;
let measuredAzimuth = null;
let measuredTilt = null;
let sunriseAzimuth = 90;
let sunsetAzimuth = 270;
let sunAzimuthNow = 180;
let sunElevationNow = 45;
let livePhoneHeading = null;
let liveCompassRotation = null;
let sensorActive = false;
let measurementTimer = null;
let sensorWarmupTimer = null;
let sensorHasData = false;
let draggingCompass = false;
let draggingTilt = false;
let measurementPhase = "manual";
let measurementSessionId = 0;
let lastHapticAt = 0;
let lastHapticAzimuth = null;
let lastHapticTilt = null;
const MEASURE_ICON_PLAY = "https://cdn.shopify.com/s/files/1/0868/2169/9918/files/motion_play.svg";
const MEASURE_ICON_SPINNER = "https://cdn.shopify.com/s/files/1/0868/2169/9918/files/automatic_meassure.svg";
const MEASURE_ICON_FROZEN = "https://cdn.shopify.com/s/files/1/0868/2169/9918/files/motion_freeze.svg";
const activeSeries = uiState.activeSeries;
const remoteService = createRemoteService();
let locationSuggestTimer = null;

const $ = (id) => document.getElementById(id);
function on(id, event, handler, options) {
  const el = $(id);
  if (!el) return false;
  el.addEventListener(event, handler, options);
  return true;
}
function setValue(id, value) {
  const el = $(id);
  if (el) el.value = value;
}
function setChecked(id, value) {
  const el = $(id);
  if (el) el.checked = value;
}
function setText(id, value) {
  const el = $(id);
  if (el) el.textContent = value;
}

function de(n, d = 1) { return Number(n || 0).toLocaleString("de-DE", { minimumFractionDigits: d, maximumFractionDigits: d }); }
function deMax(n, d = 3) { return Number(n || 0).toLocaleString("de-DE", { maximumFractionDigits: d }); }
function de0(n) { return Number(n || 0).toLocaleString("de-DE", { maximumFractionDigits: 0 }); }
function euro(n, d = 2) { return `${de(n, d)} €`; }
function euroHtml(n, d = 2) { return `${de(n, d)} <span class="oce-currency">€</span>`; }
function formatCoordinate(value, axis, digits = 4) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return "";
  const abs = Math.abs(numeric);
  const suffix = axis === "lat"
    ? (numeric < 0 ? "S" : "N")
    : (numeric < 0 ? "W" : "E");
  return `${de(abs, digits)}° ${suffix}`;
}
function localeNumber(v, fallback = 0) {
  if (typeof v === "number") return Number.isFinite(v) ? v : fallback;
  const raw = String(v ?? "").trim().replace(/\s+/g, "");
  let normalized = raw;
  if (raw.includes(",")) {
    // de-DE style: "." as thousands separator, "," as decimal separator
    normalized = raw.replace(/\./g, "").replace(",", ".");
  } else {
    // de-DE integers may contain single-dot thousands groups, e.g. "2.750".
    if (/^0\.\d+$/.test(raw)) {
      normalized = raw;
    } else if (/^[1-9]\d{0,2}(\.\d{3})+$/.test(raw)) {
      normalized = raw.replace(/\./g, "");
    } else {
      const dotCount = (raw.match(/\./g) || []).length;
      if (dotCount > 1) normalized = raw.replace(/\./g, "");
    }
  }
  const n = Number(normalized);
  return Number.isFinite(n) ? n : fallback;
}
function clamp(n, min, max) { return Math.max(min, Math.min(max, localeNumber(n, 0))); }
function sum(arr) { return arr.reduce((a, b) => a + (Number(b) || 0), 0); }
function totalKwp() { return sum(state.areas.map((a) => a.kwp)); }
function evEnabled() { return state.expertMode && state.evMode; }
function annualInputConsumptionKwh() { return Math.max(0, Number(state.annualConsumptionKwh || 0)); }
function annualEvConsumptionKwh() { return evEnabled() ? Math.max(0, Number(state.evAnnualKwh || 0)) : 0; }
function annualHouseConsumptionKwh() {
  return Math.max(0, Number((state.annualConsumptionHouseKwh ?? state.annualConsumptionKwh) || 0));
}
function annualTotalConsumptionKwh() { return annualHouseConsumptionKwh() + annualEvConsumptionKwh(); }
function batteryExtensionCapacities() {
  if (!state.batteryExtensionsEnabled) return [];
  return (Array.isArray(state.batteryExtensionModules) ? state.batteryExtensionModules : [])
    .slice(0, BATTERY_EXTENSION_LIMIT)
    .map((value) => Math.max(0, localeNumber(value, 0)));
}
function batteryModuleCapacities() {
  const base = Math.max(0.1, Number(state.batteryBaseCapacityKwh || state.batteryCapacityKwh || 0));
  return [base, ...batteryExtensionCapacities()];
}
function batterySocMinFraction() { return clamp(state.batterySocMinPct, 0, 99) / 100; }
function batterySocMaxFraction() { return clamp(state.batterySocMaxPct, Math.max(1, state.batterySocMinPct + 1), 100) / 100; }
function batterySocMinKwh(cap = state.batteryCapacityKwh) { return Math.max(0, Number(cap || 0) * batterySocMinFraction()); }
function batterySocMaxKwh(cap = state.batteryCapacityKwh) { return Math.max(batterySocMinKwh(cap), Number(cap || 0) * batterySocMaxFraction()); }
function batteryInitialSocKwh(cap = state.batteryCapacityKwh) {
  return clamp(Math.max(0, Number(cap || 0)) * 0.35, batterySocMinKwh(cap), batterySocMaxKwh(cap));
}
function normalizeBatteryConfig() {
  const fallbackCapacity = Math.max(0.1, Number(state.batteryCapacityKwh || DEFAULTS.batteryCapacityKwh || 0.1));
  state.batteryBaseCapacityKwh = Math.max(0.1, localeNumber(state.batteryBaseCapacityKwh, fallbackCapacity));
  state.batterySocMinPct = clamp(localeNumber(state.batterySocMinPct, DEFAULTS.batterySocMinPct), 0, 95);
  state.batterySocMaxPct = clamp(localeNumber(state.batterySocMaxPct, DEFAULTS.batterySocMaxPct), state.batterySocMinPct + 1, 100);
  state.batteryExtensionsEnabled = Boolean(state.batteryExtensionsEnabled);
  state.batteryExtensionMode = "individual";
  state.batteryExtensionCount = Math.max(0, Math.min(BATTERY_EXTENSION_LIMIT, Math.round(localeNumber(state.batteryExtensionCount, 0))));
  state.batteryExtensionCapacityKwh = Math.max(0.1, localeNumber(state.batteryExtensionCapacityKwh, state.batteryBaseCapacityKwh));
  const modules = Array.isArray(state.batteryExtensionModules) ? state.batteryExtensionModules : [];
  state.batteryExtensionModules = modules
    .slice(0, BATTERY_EXTENSION_LIMIT)
    .map((value) => Math.max(0.1, localeNumber(value, state.batteryExtensionCapacityKwh)));
  state.batteryExtensionCount = state.batteryExtensionModules.length;
  if (state.batteryExtensionModules.length) state.batteryExtensionCapacityKwh = state.batteryExtensionModules[state.batteryExtensionModules.length - 1];
  state.batteryCapacityKwh = sum(batteryModuleCapacities());
}
function normalizeAnnualConsumptionState() {
  let house = Number(state.annualConsumptionHouseKwh);
  if (!Number.isFinite(house)) {
    house = Number(state.annualConsumptionKwh);
  }
  if (!Number.isFinite(house) || house <= 0) {
    house = DEFAULT_ANNUAL_CONSUMPTION_KWH;
  }
  state.annualConsumptionHouseKwh = Math.max(0, house);
  state.annualConsumptionKwh = (evEnabled() && state.evAddOnTop)
    ? state.annualConsumptionHouseKwh + annualEvConsumptionKwh()
    : state.annualConsumptionHouseKwh;
}
function validAreas() {
  return state.areas.filter((a) => Number.isFinite(a.kwp) && a.kwp > 0);
}
function batteryTypeNormalized() { return state.batteryType === "ac" || state.batteryType === "dc" || state.batteryType === "all_in_one" ? state.batteryType : "all_in_one"; }
function usesBatteryIntegratedInverter() { return state.batteryMode && batteryTypeNormalized() === "all_in_one"; }
function configuredInverterLimitWatts() { return state.plugSolarLimit ? 800 : Math.max(100, Number(state.inverterPower || 0) * 1000); }
function configuredBatteryOutputWatts() { return Math.max(100, Number(state.batteryPlugIn ? 0.8 : state.batteryOutputKw || 0) * 1000); }
function configuredBatteryChargeWatts() { return Math.max(100, Number(state.batteryChargeKw || 0) * 1000); }
function configuredBatteryDischargeWatts() { return Math.max(100, Number(state.batteryDischargeKw || 0) * 1000); }
function batteryOutputLimitWatts() { return configuredBatteryOutputWatts(); }
function batteryChargeLimitWatts() { return configuredBatteryChargeWatts(); }
function batteryDischargeLimitWatts() { return Math.min(configuredBatteryDischargeWatts(), batteryOutputLimitWatts()); }
function batteryCanRecoverClipping() { return state.batteryMode && batteryTypeNormalized() !== "ac"; }
function batterySharesOutputPath() { return batteryTypeNormalized() !== "ac"; }
function batteryChargeHeadroomWatts() { return batteryCanRecoverClipping() ? batteryChargeLimitWatts() : 0; }
function inverterLimitWatts() {
  return usesBatteryIntegratedInverter()
    ? configuredBatteryOutputWatts()
    : configuredInverterLimitWatts();
}
function inverterLimitLabel() {
  const watts = inverterLimitWatts();
  return watts >= 1000 ? `${de(watts / 1000, 1)} kW` : `${de(watts, 0)} W`;
}
function systemLimitDescriptor() { return usesBatteryIntegratedInverter() ? "Systemlimit" : "Wechselrichter‑Limit"; }
function batteryTypeLabel() { return batteryTypeNormalized() === "ac" ? "AC" : batteryTypeNormalized() === "dc" ? "DC" : "All in One"; }
function batteryEfficiencyModel() {
  const etaRt = clamp(state.batteryEfficiencyPct, 70, 99) / 100;
  const root = Math.sqrt(etaRt);
  if (batteryTypeNormalized() === "ac") return { etaRt, etaIn: root, etaOut: root };
  const chargeBias = batteryTypeNormalized() === "all_in_one" ? 0.04 : 0.025;
  const etaIn = Math.min(0.997, root + chargeBias);
  const etaOut = Math.max(0.7, Math.min(0.997, etaRt / Math.max(0.0001, etaIn)));
  return { etaRt, etaIn, etaOut };
}
function activeSelfConsumption() {
  if (!state.expertMode) return 1;
  if (!Number.isFinite(state.selfConsumption)) return 1;
  return state.selfConsumption / 100;
}
function activeFeedInTariff() { return state.expertMode ? state.feedInTariff : 0; }
function inverterTypeNormalized(value = state.inverterType) {
  return ["micro", "aio", "string", "hybrid"].includes(value) ? value : "micro";
}
function inverterShadeLevelNormalized(value = state.inverterShadeLevel) {
  return ["light", "medium", "strong"].includes(value) ? value : "light";
}
function inverterPerformanceFactor(config = state) {
  if (!config?.inverterAdvancedEnabled) return 1;
  let factor = 1;
  if (Number.isFinite(config.performanceRatio)) factor *= clamp(config.performanceRatio, 1, 200) / 100;
  if (config.inverterShadeEnabled) {
    const inverterType = inverterTypeNormalized(config.inverterType);
    const shadeLevel = inverterShadeLevelNormalized(config.inverterShadeLevel);
    factor *= INVERTER_SHADE_FACTORS[inverterType]?.[shadeLevel] ?? 1;
  }
  return factor;
}
function enforceAioInverterBatteryCoupling() {
  if (state.inverterType !== "aio") return;
  state.batteryMode = true;
  state.batteryPreset = "custom";
  state.batteryType = "all_in_one";
}
function activePerformanceRatio() {
  return inverterPerformanceFactor(state);
}
function valuePerKwh() { const self = activeSelfConsumption(); return self * state.electricityPrice + (1 - self) * activeFeedInTariff(); }
function activeSystemKw() {
  if (usesBatteryIntegratedInverter()) return Number(state.batteryPlugIn ? 0.8 : (state.batteryOutputKw || 0));
  return Number(state.plugSolarLimit ? 0.8 : (state.inverterPower || 0));
}
function plugIconMarkup() { return `<img class="oce-subtitle-inline-icon" src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/plug.svg" alt="" aria-hidden="true" draggable="false">`; }
function locationIconMarkup() { return `<img class="oce-subtitle-inline-icon" src="${LOCATION_ICON}" alt="" aria-hidden="true" draggable="false">`; }
function subtitleInverterMarkup() { return `${(state.plugSolarLimit || (usesBatteryIntegratedInverter() && state.batteryPlugIn)) ? plugIconMarkup() : ""}${escapeHtml(`${de(activeSystemKw(), 1)} kW`)}`; }
function locationSummaryMarkup() {
  const gpsActive = state.locationSource === "gps" && Number.isFinite(state.lat) && Number.isFinite(state.lon);
  const text = gpsActive
    ? `GPS (${de(state.lat, 2)} · ${de(state.lon, 2)})`
    : state.locationName;
  return `<button id="subtitleLocationTrigger" class="oce-subtitle-location-trigger" type="button" aria-label="Aktuellen Standort verwenden">${locationIconMarkup()}</button><span class="oce-subtitle-location-text">${escapeHtml(text || "Standort")}</span>`;
}
function renderSystemSummary() {
  const limText = state.inverterLimitEnabled ? inverterLimitLabel() : "";
  const battText = state.batteryMode ? ` · Speicher ${de(state.batteryCapacityKwh, 1)} kWh` : "";
  const evText = state.evMode ? " · EV" : "";
  const subtitle = $("subtitle");
  if (subtitle) subtitle.innerHTML = `${locationSummaryMarkup()} · ${escapeHtml(de(totalKwp(), 2))} kWp · ${escapeHtml(String(state.areas.length))} Flächen · ${subtitleInverterMarkup()}${limText ? ` · Limit ${escapeHtml(limText)}` : ""}${battText}${evText}`;
  const summaryParts = [`${de(totalKwp(), 2)} kWp`, `${state.areas.length} Flächen`, `${de(activeSystemKw(), 1)} kW`];
  if (state.batteryMode) summaryParts.push(`Speicher ${de(state.batteryCapacityKwh, 1)} kWh · ${batteryTypeLabel()}`);
  if (state.evMode) summaryParts.push("EV");
  const modalSummary = $("modalSummary");
  if (modalSummary) modalSummary.textContent = summaryParts.join(" · ");
  const subtitleLocationTrigger = $("subtitleLocationTrigger");
  if (subtitleLocationTrigger) subtitleLocationTrigger.addEventListener("click", requestCurrentLocation);
  renderEnergyFlowPanel();
}
function openMeteoAzimuth(northClockwise) { return ((((Number(northClockwise) - 180) % 360) + 540) % 360) - 180; }
function normalizeCompassDegrees(deg) { return (((deg % 360) + 360) % 360); }
function angleDeltaDegrees(a, b) {
  if (!Number.isFinite(a) || !Number.isFinite(b)) return 0;
  let delta = Math.abs(a - b) % 360;
  if (delta > 180) delta = 360 - delta;
  return delta;
}
function vibrateOnce(pattern) {
  if (typeof navigator === "undefined" || typeof navigator.vibrate !== "function") return;
  const now = Date.now();
  if (now - lastHapticAt < 60) return;
  lastHapticAt = now;
  navigator.vibrate(pattern);
}
function triggerMeasureHaptic(channel, value, source = "manual") {
  if (!Number.isFinite(value)) return;
  if (channel === "azimuth") {
    if (lastHapticAzimuth == null) {
      lastHapticAzimuth = value;
      return;
    }
    const threshold = source === "live" ? 8 : 6;
    if (angleDeltaDegrees(value, lastHapticAzimuth) < threshold) return;
    lastHapticAzimuth = value;
    vibrateOnce(10);
    return;
  }
  if (lastHapticTilt == null) {
    lastHapticTilt = value;
    return;
  }
  const threshold = source === "live" ? 4 : 3;
  if (Math.abs(value - lastHapticTilt) < threshold) return;
  lastHapticTilt = value;
  vibrateOnce([8, 30, 8]);
}
function resetMeasureHaptics() {
  lastHapticAt = 0;
  lastHapticAzimuth = Number.isFinite(measuredAzimuth) ? measuredAzimuth : null;
  lastHapticTilt = Number.isFinite(measuredTilt) ? measuredTilt : null;
}
function compassLabel(deg) { const labels = ["N", "NO", "O", "SO", "S", "SW", "W", "NW"]; return labels[Math.round((((deg % 360) + 360) % 360) / 45) % 8]; }
function escapeHtml(s) { return String(s).replace(/[&<>'"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" })[c]); }
function pad2(n) { return String(n).padStart(2, "0"); }
function parseIsoDateParts(isoDate) {
  const text = String(isoDate || "");
  const [year, month, day] = text.split("-").map((value) => Number(value));
  return { year, month, day };
}
function isoDateFromParts(year, month, day) {
  return `${year}-${pad2(month)}-${pad2(day)}`;
}
function utcDateFromIsoDate(isoDate, hour = 12) {
  const { year, month, day } = parseIsoDateParts(isoDate);
  return new Date(Date.UTC(year, Math.max(0, month - 1), day, hour));
}
function addDaysIso(isoDate, days) {
  const date = utcDateFromIsoDate(isoDate);
  date.setUTCDate(date.getUTCDate() + days);
  return isoDateFromParts(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
}
function weekdayFromIsoDate(isoDate) {
  return utcDateFromIsoDate(isoDate).getUTCDay();
}
function weekdayLabelFromIsoDate(isoDate) {
  return utcDateFromIsoDate(isoDate).toLocaleDateString("de-DE", { weekday: "short", timeZone: "UTC" });
}
function isoWeekStart(isoDate) {
  const date = utcDateFromIsoDate(isoDate);
  const day = date.getUTCDay() || 7;
  date.setUTCDate(date.getUTCDate() - day + 1);
  return isoDateFromParts(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
}
function isoWeekNumberFromIsoDate(isoDate) {
  const value = utcDateFromIsoDate(isoDate);
  const day = value.getUTCDay() || 7;
  value.setUTCDate(value.getUTCDate() + 4 - day);
  const yearStart = new Date(Date.UTC(value.getUTCFullYear(), 0, 1));
  return Math.ceil((((value - yearStart) / 86400000) + 1) / 7);
}

function requestCurrentLocation() {
  if (!navigator.geolocation) { setStatus("Geolocation wird in diesem Browser nicht unterstützt."); return; }
  navigator.geolocation.getCurrentPosition((pos) => {
    state.lat = Number(pos.coords.latitude.toFixed(4));
    state.lon = Number(pos.coords.longitude.toFixed(4));
    state.locationName = "Mein Standort";
    state.locationSource = "gps";
    state.tz = Intl.DateTimeFormat().resolvedOptions().timeZone || state.tz;
    state.countryHint = "Deutschland";
    syncInputs();
    refresh();
  }, () => setStatus("Standort konnte nicht gelesen werden."));
}
function zonedNowParts(date = new Date(), timeZone = state.tz || "Europe/Berlin") {
  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  });
  const parts = formatter.formatToParts(date).reduce((acc, part) => {
    if (part.type !== "literal") acc[part.type] = part.value;
    return acc;
  }, {});
  return {
    year: Number(parts.year),
    month: Number(parts.month),
    day: Number(parts.day),
    isoDate: `${parts.year}-${parts.month}-${parts.day}`
  };
}
function dateContext(value = new Date()) {
  if (typeof value === "string") {
    const dateIso = value.includes("T") ? value.slice(0, 10) : value;
    const hour = value.includes("T") ? Number(value.slice(11, 13)) : null;
    const { year, month, day } = parseIsoDateParts(dateIso);
    return { dateIso, hour, year, month, day, monthIndex: Math.max(0, month - 1), weekday: weekdayFromIsoDate(dateIso) };
  }
  const date = value instanceof Date ? value : new Date(value);
  return {
    dateIso: isoDateFromParts(date.getFullYear(), date.getMonth() + 1, date.getDate()),
    hour: date.getHours(),
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
    monthIndex: date.getMonth(),
    weekday: date.getDay()
  };
}
function forecastCurrentDayIndex(days = forecast?.days || []) {
  if (!Array.isArray(days) || !days.length) return 0;
  const todayIso = zonedNowParts().isoDate;
  const todayIndex = days.findIndex((day) => day?.date === todayIso);
  if (todayIndex >= 0) return todayIndex;
  const nonPastIndex = days.findIndex((day) => day?.date && day.date >= todayIso);
  if (nonPastIndex >= 0) return nonPastIndex;
  return clamp(state.selectedDayIndex, 0, Math.max(0, days.length - 1));
}
function forecastCurrentDay(days = forecast?.days || []) {
  if (!Array.isArray(days) || !days.length) return null;
  return days[forecastCurrentDayIndex(days)] || days[0] || null;
}
function forecastCurrentWeekDays(days = forecast?.days || []) {
  if (!Array.isArray(days) || !days.length) return [];
  const todayIso = zonedNowParts().isoDate;
  const weekStart = isoWeekStart(todayIso);
  const weekEnd = addDaysIso(weekStart, 6);
  return [...days]
    .filter((day) => day?.date && day.date >= weekStart && day.date <= weekEnd)
    .sort((a, b) => a.date.localeCompare(b.date));
}
function hasCurrentForecastData() {
  return Array.isArray(runtimeState.rawForecast) && runtimeState.rawForecast.length > 0;
}
function markCurrentForecastStale(message = "Aktuelle Erträge laden") {
  runtimeState.rawForecast = null;
  forecast = null;
  setCurrentForecastStatus("idle", message);
}
function setCurrentForecastStatus(status, message = "") {
  runtimeState.currentForecastStatus = status;
  runtimeState.currentForecastMessage = message;
}
function estimateAreaAnnualKwh(area) {
  const kwp = Math.max(0, Number(area?.kwp || 0));
  const azimuth = normalizeCompassDegrees(Number(area?.azimuth || 180));
  const tilt = Math.max(0, Math.min(90, Number(area?.tilt || 35)));
  const southDeviation = Math.min(180, Math.abs(azimuth - 180));
  const orientationFactor = 1 - (southDeviation / 180) * 0.38;
  const tiltFactor = 1 - Math.min(0.18, Math.abs(tilt - 35) / 90 * 0.18);
  const latFactor = 1 - Math.min(0.12, Math.abs(Number(state.lat || 50) - 50) / 25 * 0.12);
  const specificYield = Math.max(520, 980 * orientationFactor * tiltFactor * latFactor * activePerformanceRatio());
  return kwp * specificYield;
}
function renderCurrentDataLoading(message = "Daten werden geladen …") {
  const info = $("selectedDayInfo");
  const title = $("mainChartTitle");
  const subtitle = $("mainChartSubtitle");
  if (title) title.textContent = "PV‑Leistung";
  if (subtitle) subtitle.textContent = "Aktuelle Erträge werden erst geladen, wenn diese Ansicht geöffnet wird.";
  if (info) info.textContent = message;
  if ($("powerChart")) {
    $("powerChart").innerHTML = `<div class="oce-data-loading"><div class="oce-data-loading-spinner" aria-hidden="true"></div><div class="oce-data-loading-text">${escapeHtml(message)}</div></div>`;
  }
  renderChartLegend($("powerChartLegend"), []);
}
function renderCurrentDataIdle(message = "Aktuelle Erträge laden") {
  const info = $("selectedDayInfo");
  const title = $("mainChartTitle");
  const subtitle = $("mainChartSubtitle");
  if (title) title.textContent = "PV‑Leistung";
  if (subtitle) subtitle.textContent = "Aktuelle Erträge werden erst nach Auswahl dieser Ansicht geladen.";
  if (info) info.textContent = message;
  if ($("powerChart")) {
    $("powerChart").innerHTML = `<div class="oce-data-loading"><div class="oce-data-loading-icon" aria-hidden="true"></div><div class="oce-data-loading-text">${escapeHtml(message)}</div></div>`;
  }
  renderChartLegend($("powerChartLegend"), []);
}
function setStatus(msg) { $("apiStatus").textContent = msg; }
function saveLocal() { persistState(); }
function saveLocalDebounced(delay = 250) { schedulePersist(delay); }
function sanitizeEvWeekdays(value) {
  const arr = Array.isArray(value)
    ? value
    : String(value ?? "")
        .split(",")
        .map((v) => Number(v.trim()));
  const days = [...new Set(arr.filter((n) => Number.isInteger(n) && n >= 0 && n <= 6))];
  return days.length ? days : [1, 3, 5];
}
function evPhaseModeVisible() {
  return Number(state.evChargeSpeedKw || 0) > EV_SINGLE_PHASE_MAX_KW;
}
function effectiveEvChargeSpeedKw() {
  const kw = Math.max(0, Number(state.evChargeSpeedKw || 0));
  if (state.evPhaseMode === "single") return Math.min(kw, EV_SINGLE_PHASE_MAX_KW);
  return kw;
}
function evSmartChargeSurplusFloorKw() {
  if (state.evPhaseMode === "three") return EV_THREE_PHASE_MIN_KW;
  return EV_SINGLE_PHASE_MIN_KW;
}
function evSmartChargeCapKw(surplusKw) {
  const cap = effectiveEvChargeSpeedKw();
  if (state.evPhaseMode === "hybrid" && surplusKw < EV_THREE_PHASE_MIN_KW) {
    return Math.min(cap, EV_SINGLE_PHASE_MAX_KW);
  }
  return cap;
}
function evSmartChargeFromSurplus(surplusKw, remainingKwh) {
  const surplus = Math.max(0, Number(surplusKw || 0));
  const remaining = Math.max(0, Number(remainingKwh || 0));
  if (surplus <= 0 || remaining <= 0) return 0;
  if (surplus < evSmartChargeSurplusFloorKw()) return 0;
  return Math.min(surplus, evSmartChargeCapKw(surplus), remaining);
}
function normalizeEvConfig() {
  if (!["daily", "weekly"].includes(state.evScheduleMode)) state.evScheduleMode = "daily";
  if (!["morning", "midday", "evening", "night", "smart"].includes(state.evTypicalTime)) state.evTypicalTime = "evening";
  if (!state.smartMeterInstalled && state.evTypicalTime === "smart") state.evTypicalTime = "evening";
  if (!["single", "three", "hybrid"].includes(state.evPhaseMode)) state.evPhaseMode = "hybrid";
  if (!evPhaseModeVisible()) state.evPhaseMode = "hybrid";
  state.evWeeklyDays = sanitizeEvWeekdays(state.evWeeklyDays);
  state.evTypicalChargeLimitPct = clamp(state.evTypicalChargeLimitPct, 50, 100);
}
function normalizeYearlyChartMode() {
  if (state.yearlyChartMode === "highest") state.yearlyChartMode = "summer";
  if (state.yearlyChartMode === "lowest") state.yearlyChartMode = "winter";
  if (!["average", "summer", "winter"].includes(state.yearlyChartMode)) state.yearlyChartMode = "average";
}
function normalizeInverterAdvancedConfig() {
  state.inverterAdvancedEnabled = Boolean(state.inverterAdvancedEnabled);
  state.inverterType = inverterTypeNormalized(state.inverterType);
  state.inverterShadeEnabled = Boolean(state.inverterShadeEnabled);
  state.inverterShadeLevel = inverterShadeLevelNormalized(state.inverterShadeLevel);
  state.inverterMpptCount = Number.isFinite(localeNumber(state.inverterMpptCount, null))
    ? Math.max(1, Math.round(localeNumber(state.inverterMpptCount, 1)))
    : null;
  state.inverterDcAcRatio = Number.isFinite(localeNumber(state.inverterDcAcRatio, null))
    ? Math.max(0.1, localeNumber(state.inverterDcAcRatio, 1))
    : null;
}
function loadLocal() {
  loadStoredState();
  normalizeYearlyChartMode();
  normalizeInverterAdvancedConfig();
  normalizeBatteryConfig();
  normalizeEvConfig();
  normalizeAnnualConsumptionState();
  ensureSeriesState();
}
function applyTheme() {
  document.documentElement.dataset.theme = state.theme === "dark" ? "dark" : "light";
  $("themeBtn").textContent = state.theme === "dark" ? "☀" : "◐";
}
function ensureSeriesState() {
  normalizeAreaColors();
  activeSeries.areas = state.areas.map((_, i) => activeSeries.areas[i] === true);
  if (!activeSeries.combined && !activeSeries.areas.some(Boolean)) activeSeries.combined = true;
}

function buildForecastModel(rawForecast = runtimeState.rawForecast) {
  if (!Array.isArray(rawForecast) || !rawForecast.length) return null;
  const areaResults = rawForecast.map(({ area, json }) => {
    const gti = (json?.hourly?.global_tilted_irradiance || []).map((v) => Math.max(0, Number(v) || 0));
    const pr = activePerformanceRatio();
    return {
      area,
      json,
      time: json.hourly.time,
      gti,
      dcPower: gti.map((v) => v * area.kwp * pr),
      dcEnergy: gti.map((v) => v * area.kwp * pr / 1000)
    };
  });
  const base = areaResults[0].json;
  const time = base.hourly.time;
  const combinedDcPower = time.map((_, idx) => sum(areaResults.map((r) => r.dcPower[idx] || 0)));
  const limit = inverterLimitWatts();
  const chargeHeadroom = batteryChargeHeadroomWatts();
  const combinedPowerBase = combinedDcPower.map((v) => Math.min(v, limit));
  const combinedPowerBattery = combinedDcPower.map((v) => Math.min(v, limit + chargeHeadroom));
  const combinedPower = state.batteryMode ? combinedPowerBattery : combinedPowerBase;
  const limitRatio = combinedDcPower.map((v, i) => v > 0 ? combinedPower[i] / v : 1);
  areaResults.forEach((result) => {
    result.power = result.dcPower.map((v, i) => v * limitRatio[i]);
    result.energy = result.power.map((v) => v / 1000);
  });
  const combinedEnergy = combinedPower.map((v) => v / 1000);
  const days = groupByDay(time, combinedEnergy, areaResults, base).slice(0, 8);
  return { time, areaResults, combinedDcPower, combinedPowerBase, combinedPowerBattery, combinedPower, combinedEnergy, days, weather: base.hourly, daily: base.daily };
}

function buildAnnualModel(rawAnnual = runtimeState.rawAnnual, forecastModel = buildForecastModel()) {
  if (rawAnnual && !rawAnnual.error) return rawAnnual;
  if (forecastModel) {
    const weekly = sum(forecastModel.days.slice(0, 7).map((day) => day.energy));
    const weeklyAnnualized = weekly * 52.14;
    const areaWeekly = forecastModel.areaResults.map((result) => sum(forecastModel.days.slice(0, 7).flatMap((day) => day.idxs).map((idx) => result.energy[idx] || 0)));
    const areaMonthly = areaWeekly.map((value) => MONTH_WEIGHTS_DE.map((weight) => (value * 52.14) * weight));
    const monthly = MONTH_WEIGHTS_DE.map((weight) => weeklyAnnualized * weight);
    return { source: "Open‑Meteo‑Schätzung", monthly, yearly: sum(monthly), approximate: true, areaMonthly };
  }
  const areaMonthly = state.areas.map((area) => {
    const annualKwh = estimateAreaAnnualKwh(area);
    return MONTH_WEIGHTS_DE.map((weight) => annualKwh * weight);
  });
  const monthly = MONTH_LABELS.map((_, index) => sum(areaMonthly.map((series) => series[index] || 0)));
  return { source: "Heuristische Jahresabschätzung", monthly, yearly: sum(monthly), approximate: true, areaMonthly };
}

function buildEnergyFlowModel(forecastModel, annualModel) {
  if (!forecastModel) return { batteryMetrics: null };
  const days = forecastCurrentWeekDays(forecastModel.days);
  const weekIdxs = days.flatMap((day) => day.idxs);
  const basePowerSeries = forecastModel.combinedPowerBase || forecastModel.combinedPower;
  const todayDay = forecastCurrentDay(forecastModel.days);
  const baselineDay = simulateEnergyFlow(todayDay?.idxs || forecastModel.days[0].idxs, basePowerSeries, false, forecastModel.combinedDcPower, forecastModel);
  const week = simulateEnergyFlow(weekIdxs, forecastModel.combinedPower, state.batteryMode, forecastModel.combinedDcPower, forecastModel);
  const baselineWeek = simulateEnergyFlow(weekIdxs, basePowerSeries, false, forecastModel.combinedDcPower, forecastModel);
  const day = simulateEnergyFlow(todayDay?.idxs || forecastModel.days[0].idxs, forecastModel.combinedPower, state.batteryMode, forecastModel.combinedDcPower, forecastModel);
  const annualWithBattery = annualModel ? monthlyBatteryEstimate(annualModel, true) : null;
  const annualWithoutBattery = annualModel ? monthlyBatteryEstimate(annualModel, false) : null;
  const annualScale = 365 / Math.max(1, days.length);
  const annualGrid = annualWithBattery ? annualWithBattery.gridImport : week.gridImport * annualScale;
  const annualExtraValue = annualWithBattery && annualWithoutBattery
    ? annualWithBattery.totalValue - annualWithoutBattery.totalValue
    : (week.totalValue - baselineWeek.totalValue) * annualScale;
  return {
    baselineMetrics: {
      day: baselineDay,
      week: baselineWeek,
      annualFlow: annualWithoutBattery
    },
    batteryMetrics: {
      day,
      week,
      baselineWeek,
      annualFlow: annualWithBattery,
      autarkyPct: week.autarky * 100,
      selfConsumptionPct: week.selfConsumption * 100,
      annualGridImportKwh: annualGrid,
      annualExtraSavings: annualExtraValue,
      annualTotalValue: annualWithBattery?.totalValue ?? null,
      annualSavedValue: annualWithBattery ? ((annualWithBattery.selfUsed || 0) * state.electricityPrice) : null,
      annualFeedValue: annualWithBattery ? ((annualWithBattery.exportKwh || 0) * activeFeedInTariff()) : null,
      annualSelfConsumptionPct: annualWithBattery ? (annualWithBattery.selfConsumption * 100) : null,
      annualAutarkyPct: annualWithBattery ? (annualWithBattery.autarky * 100) : null
    }
  };
}

function buildFinanceModelLocal(forecastModel, annualModel, energyFlowModel) {
  const batteryMetricsValue = energyFlowModel?.batteryMetrics || null;
  const baselineMetricsValue = energyFlowModel?.baselineMetrics || null;
  const useLoadValuation = state.batteryMode || state.annualConsumptionEdited || evEnabled();
  const annualBatteryValuesReady = state.batteryMode && batteryMetricsValue && Number.isFinite(batteryMetricsValue.annualTotalValue);
  const annualFlow = !state.batteryMode && useLoadValuation ? baselineMetricsValue?.annualFlow : null;
  const effectiveAnnualFlow = state.batteryMode ? batteryMetricsValue?.annualFlow : annualFlow;
  const currentMonth = zonedNowParts().month - 1;
  const yearKwh = effectiveAnnualFlow && Number.isFinite(effectiveAnnualFlow.pvTotal) ? Number(effectiveAnnualFlow.pvTotal) : (annualModel ? annualModel.yearly : 0);
  const annualFlowValuesReady = annualFlow && Number.isFinite(annualFlow.totalValue);
  const self = annualBatteryValuesReady && Number.isFinite(batteryMetricsValue.annualSelfConsumptionPct)
    ? (batteryMetricsValue.annualSelfConsumptionPct / 100)
    : state.batteryMode && batteryMetricsValue
      ? (batteryMetricsValue.selfConsumptionPct / 100)
      : annualFlowValuesReady && Number.isFinite(annualFlow.selfConsumption)
        ? annualFlow.selfConsumption
        : activeSelfConsumption();
  const feedTariff = activeFeedInTariff();
  const yearlySaved = state.batteryMode && annualBatteryValuesReady
    ? Math.max(0, Number(batteryMetricsValue.annualSavedValue || 0))
    : annualFlowValuesReady
      ? Math.max(0, Number(annualFlow.selfUsed || 0) * state.electricityPrice)
    : yearKwh * self * state.electricityPrice;
  const yearlyFeed = state.batteryMode && annualBatteryValuesReady
    ? Math.max(0, Number(batteryMetricsValue.annualFeedValue || 0))
    : annualFlowValuesReady
      ? Math.max(0, Number(annualFlow.exportKwh || 0) * feedTariff)
    : yearKwh * (1 - self) * feedTariff;
  const yearlyTotal = state.batteryMode && annualBatteryValuesReady
    ? Math.max(0, Number(batteryMetricsValue.annualTotalValue || 0))
    : annualFlowValuesReady
      ? Math.max(0, Number(annualFlow.totalValue || 0))
    : yearlySaved + yearlyFeed;
  const todayDay = forecastCurrentDay(forecastModel?.days || []);
  const currentWeekDays = forecastCurrentWeekDays(forecastModel?.days || []);
  const dayKwh = todayDay?.energy || 0;
  const weekKwh = sum(currentWeekDays.map((d) => d.energy || 0));
  const monthKwh = effectiveAnnualFlow?.monthly?.[currentMonth]?.monthPv ?? (annualModel ? annualModel.monthly[currentMonth] : weekKwh * 4.345);
  const vpk = self * state.electricityPrice + (1 - self) * feedTariff;
  const accum = (years) => {
    let total = 0;
    let current = yearlyTotal;
    for (let i = 0; i < years; i++) {
      total += current;
      if (state.priceIncrease) current *= 1.04;
    }
    return total;
  };
  const activeDayFlow = state.batteryMode ? batteryMetricsValue?.day : baselineMetricsValue?.day;
  const activeWeekFlow = state.batteryMode ? batteryMetricsValue?.week : baselineMetricsValue?.week;
  const currentMonthFlow = effectiveAnnualFlow?.monthly?.[currentMonth] || null;
  const saveToday = activeDayFlow ? activeDayFlow.totalValue : dayKwh * vpk;
  const saveWeek = activeWeekFlow ? activeWeekFlow.totalValue : weekKwh * vpk;
  const saveMonth = currentMonthFlow && Number.isFinite(currentMonthFlow.totalValue) ? currentMonthFlow.totalValue : (monthKwh * vpk);
  return { yearKwh, yearlySaved, yearlyFeed, yearlyTotal, monthlyTotal: yearlyTotal / 12, dayKwh, weekKwh, monthKwh, saveToday, saveWeek, saveMonth, accum, battery: batteryMetricsValue, baseline: baselineMetricsValue };
}

function buildChartModel(forecastModel, energyFlowModel, annualModel) {
  if (!forecastModel) return null;
  const selectedDay = forecastModel.days[state.selectedDayIndex] || forecastModel.days[0];
  const weekIdxs = forecastCurrentWeekDays(forecastModel.days).flatMap((day) => day.idxs);
  const dayLoss = lossFromIdxs(selectedDay.idxs);
  const weekLoss = lossFromIdxs(weekIdxs);
  const weekLossRatio = weekLoss.raw > 0 ? weekLoss.loss / weekLoss.raw : 0;
  return {
    selectedDay,
    weekIdxs,
    dayLoss,
    weekLoss,
    yearLossEst: annualModel ? annualModel.yearly * weekLossRatio : 0,
    yearLossPctEst: weekLossRatio * 100,
    batteryMetrics: energyFlowModel?.batteryMetrics || null
  };
}

function getDerivedModel() {
  const key = JSON.stringify({
    version: runtimeState.invalidationVersion,
    refresh: runtimeState.refreshNonce,
    config: {
      batteryMode: state.batteryMode,
      batteryBaseCapacityKwh: state.batteryBaseCapacityKwh,
      batteryCapacityKwh: state.batteryCapacityKwh,
      batteryChargeKw: state.batteryChargeKw,
      batteryDischargeKw: state.batteryDischargeKw,
      batteryOutputKw: state.batteryOutputKw,
      batteryType: state.batteryType,
      batteryEfficiencyPct: state.batteryEfficiencyPct,
      batteryPlugIn: state.batteryPlugIn,
      batterySocMinPct: state.batterySocMinPct,
      batterySocMaxPct: state.batterySocMaxPct,
      batteryExtensionsEnabled: state.batteryExtensionsEnabled,
      batteryExtensionMode: state.batteryExtensionMode,
      batteryExtensionCount: state.batteryExtensionCount,
      batteryExtensionCapacityKwh: state.batteryExtensionCapacityKwh,
      batteryExtensionModules: state.batteryExtensionModules,
      electricityPrice: state.electricityPrice,
      expertMode: state.expertMode,
      feedInTariff: state.feedInTariff,
      selfConsumption: state.selfConsumption,
      performanceRatio: state.performanceRatio,
      priceIncrease: state.priceIncrease,
      annualConsumptionKwh: state.annualConsumptionKwh,
      annualConsumptionHouseKwh: state.annualConsumptionHouseKwh,
      annualConsumptionEdited: state.annualConsumptionEdited,
      annualSource: state.annualSource,
      inverterLimitEnabled: state.inverterLimitEnabled,
      plugSolarLimit: state.plugSolarLimit,
      inverterPower: state.inverterPower,
      batterySystemCost: state.batterySystemCost,
      evMode: state.evMode,
      evAddOnTop: state.evAddOnTop,
      evAnnualKm: state.evAnnualKm,
      evKwhPer100Km: state.evKwhPer100Km,
      evAnnualKwh: state.evAnnualKwh,
      evScheduleMode: state.evScheduleMode,
      evTypicalTime: state.evTypicalTime,
      evWeeklyDays: state.evWeeklyDays,
      evChargeSpeedKw: state.evChargeSpeedKw,
      evChargingType: state.evChargingType,
      evPhaseMode: state.evPhaseMode,
      evBatteryKwh: state.evBatteryKwh,
      evTypicalChargeLimitPct: state.evTypicalChargeLimitPct,
      smartMeterInstalled: state.smartMeterInstalled,
      loadProfile: state.loadProfile,
      areas: state.areas,
      lat: state.lat,
      tz: state.tz
    },
    ui: {
      selectedDayIndex: state.selectedDayIndex,
      savingsForecastMode: state.savingsForecastMode,
      loadCurveVisible: state.loadCurveVisible,
      theme: state.theme
    }
  });
  if (runtimeState.derivedKey === key && runtimeState.derivedModels) return runtimeState.derivedModels;
  runtimeState.flowCache = new Map();
  const forecastModel = buildForecastModel();
  const annualModel = buildAnnualModel(runtimeState.rawAnnual, forecastModel);
  const energyFlowModel = buildEnergyFlowModel(forecastModel, annualModel);
  const financeModel = buildFinanceModelLocal(forecastModel, annualModel, energyFlowModel);
  const chartModel = buildChartModel(forecastModel, energyFlowModel, annualModel);
  runtimeState.derivedKey = key;
  runtimeState.derivedModels = { forecastModel, annualModel, energyFlowModel, financeModel, chartModel };
  return runtimeState.derivedModels;
}

function requestRender(scopes, options = {}) {
  const invalidateScopes = Array.isArray(options.invalidate) ? options.invalidate : (options.invalidate ? [options.invalidate] : []);
  if (invalidateScopes.some((scope) => ["remote", "forecast", "annual", "energy"].includes(scope))) {
    markCurrentForecastStale();
  }
  if (options.invalidate) invalidate(options.invalidate);
  scheduleRender(scopes);
}

function scheduleDataRefresh(delay = 350) {
  clearTimeout(runtimeState.refreshTimer);
  runtimeState.refreshTimer = setTimeout(() => {
    runtimeState.refreshTimer = null;
    refresh();
  }, delay);
}

function flushRenderScopes(scopeSet) {
  const scopes = scopeSet instanceof Set ? scopeSet : new Set(scopeSet);
  const models = getDerivedModel();
  forecast = models.forecastModel;
  annual = models.annualModel;
  renderSystemSummary();
  if (scopes.has("all") || scopes.has("dataRefresh")) {
    renderAll(scopes.has("dataRefresh"));
    return;
  }
  if (scopes.has("theme")) {
    applyTheme();
    if (forecast || annual) {
      renderCharts();
      renderSavingsYearsChart();
      renderPaybackChart();
    }
  }
  if (scopes.has("chipsOnly")) renderChips();
  if (scopes.has("tabsOnly")) renderDayTabs();
  if (!forecast && !annual) {
    renderEmpty();
    return;
  }
  if (scopes.has("daySelection")) {
    renderDayTabs();
    renderTopSavings();
    renderCharts();
    renderHourStrip();
  }
  if (scopes.has("chartOnly")) {
    renderCharts();
    renderTopSavings();
  }
  if (scopes.has("financeOnly")) {
    renderTopSavings();
    renderSavingsForecast();
    renderFinance();
    renderSavingsYearsChart();
    renderPaybackChart();
  }
  if (scopes.has("hourOnly")) renderHourStrip();
}

setRenderScheduler(flushRenderScopes);

function monthlyLoadFactor(monthIndex) {
  const m = Math.max(0, Math.min(11, monthIndex));
  return MONTH_WEIGHTS_DE[m] * 365 / DAYS_IN_MONTH_DE[m];
}

function evChargeEfficiencyPct(speedKw, chargingType) {
  const kw = Math.max(0, Number(speedKw) || 0);
  const type = chargingType === "dc" ? "dc" : "ac";
  if (type === "dc") {
    if (kw <= 11) return 94;
    if (kw <= 25) return 95;
    if (kw <= 75) return 96;
    return 97;
  }
  if (kw <= 2.3) return 84;
  if (kw <= 3.7) return 87;
  if (kw <= 7.4) return 90;
  if (kw <= 11) return 92;
  if (kw <= 22) return 94;
  return 95;
}

function evSmartModeActive() {
  return evEnabled() && state.smartMeterInstalled && state.evTypicalTime === "smart";
}

function evDailyEnergyTargetKwh(date = new Date()) {
  if (!evEnabled()) return 0;
  if (!isEvChargingDay(date)) return 0;
  const annualKwh = Math.max(0, Number(state.evAnnualKwh || 0));
  const perDayByDistance = annualKwh / evChargingDaysPerYear();
  const sessionCap = Math.max(0.1, Number(state.evBatteryKwh || 0)) * (Math.max(50, Math.min(100, Number(state.evTypicalChargeLimitPct || 90))) / 100);
  return Math.min(perDayByDistance, sessionCap);
}

function evPatternShares(date = new Date()) {
  const base = Array(24).fill(0.01);
  const add = (hours, weight) => hours.forEach((h) => { base[h] += weight; });
  if (state.evTypicalTime === "morning") add([6, 7, 8], 0.2);
  else if (state.evTypicalTime === "midday") add([11, 12, 13], 0.25);
  else if (state.evTypicalTime === "evening") add([18, 19, 20], 0.28);
  else if (state.evTypicalTime === "night") add([22, 23, 0, 1, 2, 3, 4, 5], 0.14);
  else {
    const pvShape = dailyPvShape(date, state.lat);
    const solarHours = pvShape
      .map((v, hour) => ({ v, hour }))
      .sort((a, b) => b.v - a.v)
      .slice(0, 5)
      .map((x) => x.hour);
    const topHours = solarHours.length ? solarHours : [11, 12, 13, 14];
    add(topHours, 0.25 / topHours.length);
    add([6, 7, 8], 0.08);
    add([18, 19, 20], 0.08);
    add([22, 23, 0, 1, 2, 3, 4, 5], 0.05);
  }
  const s = Math.max(0.0001, sum(base));
  return base.map((v) => v / s);
}

function evPriorityHours(date = new Date()) {
  if (state.evTypicalTime === "morning") return [6, 7, 8];
  if (state.evTypicalTime === "midday") return [11, 12, 13];
  if (state.evTypicalTime === "evening") return [18, 19, 20];
  if (state.evTypicalTime === "night") return [22, 23, 0, 1, 2, 3, 4, 5];
  const pvShape = dailyPvShape(date, state.lat);
  return pvShape
    .map((v, hour) => ({ v, hour }))
    .sort((a, b) => b.v - a.v)
    .slice(0, 6)
    .map((x) => x.hour);
}

function isEvChargingDay(date = new Date()) {
  if (state.evScheduleMode !== "weekly") return true;
  const days = sanitizeEvWeekdays(state.evWeeklyDays);
  return days.includes(dateContext(date).weekday);
}

function evChargingDaysPerYear() {
  if (state.evScheduleMode !== "weekly") return 365;
  const days = sanitizeEvWeekdays(state.evWeeklyDays);
  return Math.max(1, days.length * 52.142857);
}

function evHourlyLoadSeries(date = new Date()) {
  if (!evEnabled()) return Array(24).fill(0);
  if (evSmartModeActive()) return Array(24).fill(0);
  if (!isEvChargingDay(date)) return Array(24).fill(0);
  const shares = evPatternShares(date);
  const priority = evPriorityHours(date);
  const prioritySet = new Set(priority);
  const others = Array.from({ length: 24 }, (_, h) => h).filter((h) => !prioritySet.has(h));
  others.sort((a, b) => (shares[b] || 0) - (shares[a] || 0));
  let remaining = evDailyEnergyTargetKwh(date);
  const speedCap = Math.max(0.1, effectiveEvChargeSpeedKw());
  const hourly = Array(24).fill(0);

  // Phase 1: Fokusfenster zuerst mit Peaks bis zur Ladeleistungsgrenze.
  for (const h of priority) {
    if (remaining <= 0) break;
    const add = Math.min(speedCap, remaining);
    hourly[h] += add;
    remaining -= add;
  }
  // Falls Fokusfenster noch Kapazität hat, zweite Runde durch Fokusfenster.
  if (remaining > 0) {
    for (const h of priority) {
      if (remaining <= 0) break;
      const room = Math.max(0, speedCap - hourly[h]);
      if (room <= 0) continue;
      const add = Math.min(room, remaining);
      hourly[h] += add;
      remaining -= add;
    }
  }
  // Phase 2: Rest in übrige Stunden (gewichtete Reihenfolge) verteilen, weiter mit Cap.
  if (remaining > 0) {
    for (const h of others) {
      if (remaining <= 0) break;
      const add = Math.min(speedCap, remaining);
      hourly[h] += add;
      remaining -= add;
    }
  }
  return hourly;
}

function annualConsumptionLabel() {
  if (!evEnabled()) return "Jahresverbrauch (kWh)";
  return state.evAddOnTop ? "Jahresverbrauch (Haus) + EV" : "Jahresverbrauch (inkl. EV)";
}

function updateAnnualConsumptionUi() {
  const label = $("annualConsumptionLabelText");
  if (label) label.textContent = annualConsumptionLabel();
  const hint = $("annualConsumptionHint");
  if (hint) {
    hint.hidden = !state.evMode;
    if (!state.evMode) {
      hint.textContent = "";
      return;
    }
    const house = annualHouseConsumptionKwh();
    const ev = annualEvConsumptionKwh();
    const input = annualInputConsumptionKwh();
    const total = annualTotalConsumptionKwh();
    hint.textContent = state.evAddOnTop
      ? `Jahresverbrauch = ${de0(house)} kWh Hausverbrauch + ${de0(ev)} kWh EV-Verbrauch = ${de0(total)} kWh`
      : `${de0(input)} kWh gesamt (inkl. EV ${de0(ev)} kWh, Hausanteil ${de0(house)} kWh)`;
    if (evSmartModeActive()) {
      const phaseModeLabel = state.evPhaseMode === "single" ? "1‑phasig" : state.evPhaseMode === "three" ? "3‑phasig" : "Smart Hybrid";
      hint.textContent += ` · EV-Smart: Laden nur bei PV-Überschuss (${phaseModeLabel} ab ${de(evSmartChargeSurplusFloorKw(), 2)} kW).`;
    }
  }
  const ratio = $("evShareInfo");
  if (ratio) {
    const ev = annualEvConsumptionKwh();
    const total = Math.max(0.0001, annualTotalConsumptionKwh());
    ratio.value = evEnabled() ? `${de((ev / total) * 100, 1)}%` : "";
  }
}

function updateEvDerivedValues() {
  const prevAddOnTop = Boolean(state.evAddOnTop);
  const currentAnnualInput = Math.max(0, localeNumber($("annualConsumption")?.value, state.annualConsumptionKwh));
  const houseBase = Math.max(0, Number(state.annualConsumptionHouseKwh || currentAnnualInput || DEFAULT_ANNUAL_CONSUMPTION_KWH));
  const annualKm = Math.max(0, localeNumber($("evAnnualKm")?.value, state.evAnnualKm));
  const kwhPer100 = Math.max(0, localeNumber($("evKwhPer100Km")?.value, state.evKwhPer100Km));
  const driveKwh = annualKm * kwhPer100 / 100;
  state.evAnnualKm = annualKm;
  state.evKwhPer100Km = kwhPer100;
  state.evScheduleMode = $("evScheduleMode")?.value || state.evScheduleMode;
  state.evTypicalTime = $("evTypicalTime")?.value || state.evTypicalTime;
  state.evChargeSpeedKw = Math.max(0, localeNumber($("evChargeSpeedKw")?.value, state.evChargeSpeedKw));
  state.evChargingType = $("evChargingType")?.value || state.evChargingType;
  state.evBatteryKwh = Math.max(0, localeNumber($("evBatteryKwh")?.value, state.evBatteryKwh));
  state.evTypicalChargeLimitPct = clamp(localeNumber($("evTypicalChargeLimitPct")?.value, state.evTypicalChargeLimitPct), 50, 100);
  normalizeEvConfig();
  state.evEfficiencyPct = evChargeEfficiencyPct(effectiveEvChargeSpeedKw(), state.evChargingType);
  const eff = Math.max(0.01, state.evEfficiencyPct / 100);
  state.evAnnualKwh = driveKwh / eff;
  state.evAddOnTop = $("evAddOnTop")?.checked ?? state.evAddOnTop;
  if (evEnabled() && prevAddOnTop !== state.evAddOnTop) {
    if (state.evAddOnTop) {
      state.annualConsumptionHouseKwh = houseBase;
    } else {
      state.annualConsumptionHouseKwh = houseBase;
    }
  }
  normalizeAnnualConsumptionState();
  setValue("annualConsumption", de0(state.annualConsumptionKwh));
  setValue("evEfficiency", `${de(state.evEfficiencyPct, 0)}%`);
  setValue("evAnnualKwh", `${de0(state.evAnnualKwh)} kWh/Jahr`);
  updateEvScheduleUi();
  updateAnnualConsumptionUi();
}

function loadProfileShape() {
  const base = [...(LOAD_PROFILES[state.loadProfile] || LOAD_PROFILES.berufstaetig)];
  const weekendBias = state.loadProfile === "berufstaetig" || state.loadProfile === "homeoffice" || state.loadProfile === "single"
    ? 1.12
    : 1.03;
  const weekendShape = base.map((v, hour) => {
    const boosted = [...base];
    if (hour >= 8 && hour <= 11) boosted[hour] *= weekendBias;
    if (hour >= 18 && hour <= 22) boosted[hour] *= weekendBias;
    if (hour >= 12 && hour <= 14) boosted[hour] *= 0.92;
    return boosted[hour];
  });
  const weekdaySum = Math.max(0.0001, sum(base));
  const weekendSum = Math.max(0.0001, sum(weekendShape));
  return {
    weekday: base.map((v) => v / weekdaySum),
    weekend: weekendShape.map((v) => v / weekendSum)
  };
}

function annualLoadForDate(date) {
  const shapes = loadProfileShape();
  const info = dateContext(date);
  const dayType = [0, 6].includes(info.weekday) ? "weekend" : "weekday";
  const dailyUse = Math.max(0.1, annualHouseConsumptionKwh() / 365);
  const monthFactor = monthlyLoadFactor(info.monthIndex);
  const shape = shapes[dayType];
  return shape.map((v) => dailyUse * monthFactor * v);
}

function totalLoadForDate(date) {
  const base = annualLoadForDate(date);
  if (!evEnabled()) return base;
  const ev = evHourlyLoadSeries(date);
  return base.map((v, i) => v + (ev[i] || 0));
}

function normalizePowerFlow(result) {
  const safeCap = Math.max(0, result.cap || 0);
  const soc = Math.max(0, Math.min(safeCap, Number(result.soc || 0)));
  const pv = Math.max(0, Number(result.pv || 0));
  const direct = Math.max(0, Number(result.direct || 0));
  const battChargeIn = Math.max(0, Number(result.battChargeIn || 0));
  const battToLoad = Math.max(0, Number(result.battToLoad || 0));
  const exportKwh = Math.max(0, Number(result.exportKwh || 0));
  const gridImport = Math.max(0, Number(result.gridImport || 0));
  const loadTotal = Math.max(0, Number(result.loadTotal || 0));
  const selfUsed = Math.min(loadTotal, Math.max(0, loadTotal - gridImport));
  const autarky = loadTotal > 0 ? selfUsed / loadTotal : 0;
  const selfConsumption = pv > 0 ? Math.max(0, Math.min(1, (pv - exportKwh) / pv)) : 0;
  return { ...result, soc, pvTotal: pv, directUse: direct, battChargeIn, battToLoad, exportKwh, gridImport, selfUsed, autarky, selfConsumption };
}

function dailyPvShape(date, lat = state.lat) {
  const info = dateContext(date);
  const dayOfYearValue = dayOfYear(info.year, info.month, info.day);
  const decl = 23.44 * Math.sin((2 * Math.PI / 365) * (dayOfYearValue - 81));
  const latRad = lat * Math.PI / 180;
  const declRad = decl * Math.PI / 180;
  const cosH = Math.max(-1, Math.min(1, -Math.tan(latRad) * Math.tan(declRad)));
  const daylightHours = Math.max(4, Math.min(20, (2 * Math.acos(cosH) * 180 / Math.PI) / 15));
  const sunrise = 12 - daylightHours / 2;
  const sunset = 12 + daylightHours / 2;
  const shape = Array.from({ length: 24 }, (_, hour) => {
    const center = hour + 0.5;
    if (center < sunrise || center > sunset) return 0;
    const t = (center - sunrise) / Math.max(0.0001, daylightHours);
    return Math.sin(Math.PI * t) ** 1.8;
  });
  const total = Math.max(0.0001, sum(shape));
  return shape.map((v) => v / total);
}

function signedAzimuthDelta(fromDeg, toDeg) {
  return ((((Number(fromDeg) - Number(toDeg)) % 360) + 540) % 360) - 180;
}

function solarPositionForLocalTime(lat, lon, timeZone, year, month, day, hour = 12, minute = 30) {
  const referenceDate = new Date(Date.UTC(year, Math.max(0, month - 1), day, 12, 0, 0));
  const offsetMinutes = timezoneOffsetMinutes(timeZone, referenceDate);
  const doy = dayOfYear(year, month, day);
  const minutes = hour * 60 + minute;
  const gamma = (2 * Math.PI / 365) * (doy - 1 + ((minutes / 60) - 12) / 24);
  const equationOfTime = 229.18 * (
    0.000075 +
    0.001868 * Math.cos(gamma) -
    0.032077 * Math.sin(gamma) -
    0.014615 * Math.cos(2 * gamma) -
    0.040849 * Math.sin(2 * gamma)
  );
  const declination = 0.006918 -
    0.399912 * Math.cos(gamma) +
    0.070257 * Math.sin(gamma) -
    0.006758 * Math.cos(2 * gamma) +
    0.000907 * Math.sin(2 * gamma) -
    0.002697 * Math.cos(3 * gamma) +
    0.00148 * Math.sin(3 * gamma);
  const trueSolarMinutes = (minutes + equationOfTime + 4 * lon - offsetMinutes + 1440) % 1440;
  const hourAngle = trueSolarMinutes / 4 < 0 ? trueSolarMinutes / 4 + 180 : trueSolarMinutes / 4 - 180;
  const latRad = lat * Math.PI / 180;
  const haRad = hourAngle * Math.PI / 180;
  const zenith = Math.acos(
    Math.sin(latRad) * Math.sin(declination) +
    Math.cos(latRad) * Math.cos(declination) * Math.cos(haRad)
  );
  const elevation = 90 - (zenith * 180 / Math.PI);
  const azimuth = (Math.atan2(
    Math.sin(haRad),
    Math.cos(haRad) * Math.sin(latRad) - Math.tan(declination) * Math.cos(latRad)
  ) * 180 / Math.PI + 180 + 360) % 360;
  return { azimuth, elevation };
}

function areaDailyPvShape(date, area, lat = state.lat, lon = state.lon, timeZone = state.tz || "Europe/Berlin") {
  const info = dateContext(date);
  const panelAzimuth = normalizeCompassDegrees(Number(area?.azimuth || 180));
  const panelTilt = Math.max(0, Math.min(90, Number(area?.tilt || 35)));
  const tiltRad = panelTilt * Math.PI / 180;
  const skyView = (1 + Math.cos(tiltRad)) / 2;
  const groundView = (1 - Math.cos(tiltRad)) / 2;
  const shape = Array.from({ length: 24 }, (_, hour) => {
    const sun = solarPositionForLocalTime(lat, lon, timeZone, info.year, info.month, info.day, hour, 30);
    if (!Number.isFinite(sun.elevation) || sun.elevation <= 0) return 0;
    const elevationRad = sun.elevation * Math.PI / 180;
    const azimuthDeltaRad = signedAzimuthDelta(sun.azimuth, panelAzimuth) * Math.PI / 180;
    const sinElevation = Math.max(0, Math.sin(elevationRad));
    const cosIncidence = (
      Math.sin(elevationRad) * Math.cos(tiltRad) +
      Math.cos(elevationRad) * Math.sin(tiltRad) * Math.cos(azimuthDeltaRad)
    );
    const beam = Math.max(0, cosIncidence);
    const diffuse = sinElevation * skyView * 0.35;
    const ground = sinElevation * groundView * 0.08;
    const atmosphere = sinElevation ** 0.25;
    return Math.max(0, (beam + diffuse + ground) * atmosphere);
  });
  const total = Math.max(0.0001, sum(shape));
  return shape.map((value) => value / total);
}

function applyBatteryHourFlow(rawPvKwh, loadKwh, soc, withBattery, capKwh, etaIn, etaOut, chargeLimitW, dischargeLimitW, outputLimitW, exportLimitW, smartMeterFactor, smartMeterChargeFactor) {
  const sharedOutput = withBattery && batterySharesOutputPath();
  const harvestablePvKwh = Math.max(0, Math.min(rawPvKwh, exportLimitW / 1000 + (withBattery ? batteryChargeHeadroomWatts() / 1000 : 0)));
  const acPvKwh = Math.min(harvestablePvKwh, exportLimitW / 1000);
  const direct = Math.min(acPvKwh, loadKwh);
  let surplus = harvestablePvKwh - direct;
  let remaining = loadKwh - direct;
  let battChargeIn = 0;
  let battToLoad = 0;
  if (withBattery) {
    const capMax = batterySocMaxKwh(capKwh);
    const capMin = batterySocMinKwh(capKwh);
    const chargeSourceKwh = sharedOutput ? Math.max(0, surplus) : Math.max(0, acPvKwh - direct);
    const chargePossible = Math.min(chargeSourceKwh, chargeLimitW / 1000, Math.max(0, (capMax - soc) / Math.max(0.0001, etaIn))) * smartMeterChargeFactor;
    if (chargePossible > 0) {
      soc += chargePossible * etaIn;
      battChargeIn = chargePossible;
      surplus -= chargePossible;
    }
    const sharedHeadroomKwh = sharedOutput ? Math.max(0, (exportLimitW / 1000) - direct) : Number.POSITIVE_INFINITY;
    const dischargePossible = Math.min(remaining, outputLimitW / 1000, dischargeLimitW / 1000, Math.max(0, soc - capMin) * etaOut, sharedHeadroomKwh) * smartMeterFactor;
    if (dischargePossible > 0) {
      soc -= dischargePossible / etaOut;
      battToLoad = dischargePossible;
      remaining -= dischargePossible;
    }
  }
  const exportHeadroomKwh = Math.max(0, (exportLimitW / 1000) - direct);
  const exportKwh = Math.min(Math.max(0, surplus), exportHeadroomKwh);
  return { harvestablePvKwh, direct, battChargeIn, battToLoad, exportKwh, gridImport: Math.max(0, remaining), soc };
}

function monthlyBatteryEstimate(annualModel, withBattery) {
  if (!annualModel || !Array.isArray(annualModel.monthly)) return null;
  const shares = loadProfileShape();
  const { etaIn, etaOut } = batteryEfficiencyModel();
  const cap = Math.max(0.2, state.batteryCapacityKwh);
  const chargeLimitW = batteryChargeLimitWatts();
  const dischargeLimitW = batteryDischargeLimitWatts();
  const outputLimitW = batteryOutputLimitWatts();
  const exportLimitW = inverterLimitWatts();
  const smartMeterFactor = state.smartMeterInstalled ? 1 : 0.55;
  const smartMeterChargeFactor = state.smartMeterInstalled ? 1 : 0.7;
  const initialSoc = batteryInitialSocKwh(cap);
  let soc = initialSoc;
  let pvTotal = 0;
  let loadTotal = 0;
  let directUse = 0;
  let battChargeIn = 0;
  let battToLoad = 0;
  let exportKwh = 0;
  let gridImport = 0;
  const smartEnabled = evSmartModeActive();
  const safeTotalKwp = Math.max(totalKwp(), 0.01);
  const areaMonthly = Array.isArray(annualModel.areaMonthly) && annualModel.areaMonthly.length === state.areas.length
    ? annualModel.areaMonthly
    : state.areas.map((area) => annualModel.monthly.map((monthKwh) => monthKwh * (Math.max(0, Number(area.kwp || 0)) / safeTotalKwp)));
  const monthly = annualModel.monthly.map((monthKwh, monthIdx) => {
    const days = DAYS_IN_MONTH_DE[monthIdx];
    let monthPv = 0;
    let monthLoad = 0;
    let monthDirect = 0;
    let monthExport = 0;
    let monthGrid = 0;
    for (let day = 0; day < days; day++) {
      const date = new Date(Date.UTC(2024, monthIdx, day + 1));
      let smartRemainingKwh = smartEnabled ? evDailyEnergyTargetKwh(date) : 0;
      const loadShape = date.getUTCDay() === 0 || date.getUTCDay() === 6 ? shares.weekend : shares.weekday;
      const houseDailyUse = Math.max(0.1, annualHouseConsumptionKwh() / 365) * monthlyLoadFactor(monthIdx);
      const evSeries = evEnabled() ? evHourlyLoadSeries(date) : Array(24).fill(0);
      const loadSeries = loadShape.map((v, hour) => (houseDailyUse * v) + (evSeries[hour] || 0));
      const areaSeries = state.areas.map((area, areaIdx) => {
        const monthlyAreaKwh = Number(areaMonthly[areaIdx]?.[monthIdx] || 0);
        const dailyAreaKwh = monthlyAreaKwh / Math.max(1, days);
        if (dailyAreaKwh <= 0) return Array(24).fill(0);
        const areaShape = areaDailyPvShape(date, area);
        return areaShape.map((share) => share * dailyAreaKwh);
      });
      const pvSeries = Array.from({ length: 24 }, (_, hour) => sum(areaSeries.map((series) => series[hour] || 0)));
      for (let hour = 0; hour < 24; hour++) {
        const loadKwh = loadSeries[hour];
        const flow = applyBatteryHourFlow(pvSeries[hour], loadKwh, soc, withBattery, cap, etaIn, etaOut, chargeLimitW, dischargeLimitW, outputLimitW, exportLimitW, smartMeterFactor, smartMeterChargeFactor);
        soc = flow.soc;
        monthPv += flow.harvestablePvKwh;
        monthLoad += loadKwh;
        pvTotal += flow.harvestablePvKwh;
        loadTotal += loadKwh;
        monthDirect += flow.direct;
        directUse += flow.direct;
        battChargeIn += flow.battChargeIn;
        battToLoad += flow.battToLoad;
        let smartSurplus = Math.max(0, flow.exportKwh);
        if (smartEnabled && smartRemainingKwh > 0 && smartSurplus > 0) {
          const smartChargeKwh = evSmartChargeFromSurplus(smartSurplus, smartRemainingKwh);
          if (smartChargeKwh > 0) {
            smartRemainingKwh -= smartChargeKwh;
            monthLoad += smartChargeKwh;
            monthDirect += smartChargeKwh;
            loadTotal += smartChargeKwh;
            directUse += smartChargeKwh;
            smartSurplus -= smartChargeKwh;
          }
        }
        monthExport += smartSurplus;
        monthGrid += flow.gridImport;
        exportKwh += smartSurplus;
        gridImport += flow.gridImport;
      }
    }
    const monthSelfUsed = Math.max(0, monthLoad - monthGrid);
    const monthTotalValue = (monthSelfUsed * state.electricityPrice) + (monthExport * activeFeedInTariff());
    return { monthPv, monthLoad, monthDirect, monthSelfUsed, monthExport, monthGrid, totalValue: monthTotalValue };
  });
  if (withBattery) {
    const socDelta = soc - initialSoc;
    if (socDelta > 0) {
      exportKwh += socDelta / Math.max(0.0001, etaIn);
    } else if (socDelta < 0) {
      gridImport += (-socDelta) * etaOut;
    }
  }
  const selfUsed = Math.max(0, loadTotal - gridImport);
  const totalValue = selfUsed * state.electricityPrice + exportKwh * activeFeedInTariff();
  return normalizePowerFlow({ pv: pvTotal, loadTotal, direct: directUse, battChargeIn, battToLoad, exportKwh, gridImport, selfUsed, autarky: loadTotal > 0 ? (selfUsed / loadTotal) : 0, selfConsumption: pvTotal > 0 ? ((pvTotal - exportKwh) / pvTotal) : 0, totalValue, soc, cap, monthly });
}

function normalizeAreaColors() {
  state.areas.forEach((a, i) => {
    a.color = COLORS[i % COLORS.length];
  });
}

function loadFromUrl() {
  const raw = location.search || location.hash.replace(/^#/, "");
  const p = new URLSearchParams(raw);
  if (!p.size) return;
  state.locationName = p.get("location") || state.locationName;
  state.lat = Number(p.get("lat")) || state.lat;
  state.lon = Number(p.get("lon")) || state.lon;
  state.tz = p.get("tz") || state.tz;
  const areas = [];
  for (let i = 1; i <= 8; i++) {
    const kwp = p.get(`p${i}_kwp`);
    if (kwp === null) continue;
    areas.push({ name: p.get(`p${i}_name`) || `Fläche ${i}`, azimuth: Number(p.get(`p${i}_azimuth`)) || 180, tilt: Number(p.get(`p${i}_tilt`)) || 35, kwp: Number(kwp) || 0.5, color: COLORS[(i - 1) % COLORS.length] });
  }
  if (areas.length) state.areas = areas;
  normalizeAnnualConsumptionState();
}

function makeShareUrl() {
  const p = new URLSearchParams();
  p.set("location", state.locationName);
  p.set("lat", state.lat);
  p.set("lon", state.lon);
  p.set("tz", state.tz);
  state.areas.forEach((a, i) => { const n = i + 1; p.set(`p${n}_name`, a.name); p.set(`p${n}_azimuth`, a.azimuth); p.set(`p${n}_tilt`, a.tilt); p.set(`p${n}_kwp`, a.kwp); });
  return location.origin + location.pathname + "?" + p.toString();
}

function bindInputs() {
  const evSection = document.querySelector(".oce-config-section.oce-ev-experimental");
  const expertSection = $("expertToggle")?.closest(".oce-config-section");
  if (evSection && expertSection && evSection !== expertSection && evSection.nextElementSibling !== expertSection) {
    expertSection.parentNode.insertBefore(evSection, expertSection);
  }
  [["systemCost", "system"], ["pvSystemCost", "pv"], ["batterySystemCost", "battery"]].forEach(([id, source]) => {
    const commitCostTriplet = (normalizeSource = false) => {
      updateSystemCostBreakdownUi({ source, normalizeSource });
      requestRender(["financeOnly"], { invalidate: ["finance"] });
      saveLocalDebounced();
    };
    on(id, "input", () => commitCostTriplet(false));
    on(id, "change", () => commitCostTriplet(true));
    on(id, "blur", () => commitCostTriplet(true));
    on(id, "keydown", (event) => {
      if (event.key !== "Enter") return;
      event.preventDefault();
      commitCostTriplet(true);
    });
  });
  const rerenderPrimaryField = (id) => {
    if (id === "inverterPower" && usesBatteryIntegratedInverter()) {
      switchBatteryPresetToCustom();
      syncIntegratedInverterControls("inverterPower");
    }
    if (id === "batteryOutputPower" && usesBatteryIntegratedInverter()) {
      switchBatteryPresetToCustom();
      syncIntegratedInverterControls("batteryOutput");
    }
    readInputsToState({ allowEvPrompt: false });
    if (id === "annualConsumption") {
      state.annualConsumptionEdited = true;
      const typed = Math.max(0, localeNumber($("annualConsumption")?.value, state.annualConsumptionHouseKwh || DEFAULT_ANNUAL_CONSUMPTION_KWH));
      state.annualConsumptionHouseKwh = typed;
      state.annualConsumptionKwh = typed;
      state.evAddOnTop = false;
      state.evPromptKey = "";
      setChecked("evAddOnTop", false);
      updateAnnualConsumptionUi();
    }
    if (id.startsWith("battery")) updateBatteryPresetUi();
    if (id === "inverterMpptCount" && $("settingsModal")?.classList.contains("open")) renderAreaEditor();
    requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] });
    saveLocalDebounced();
  };
  const deferredBatteryCapacityFields = new Set(["batteryCapacity"]);
  ["inverterPower", "electricityPrice", "feedInTariff", "selfConsumption", "performanceRatio", "inverterMpptCount", "inverterDcAcRatio", "annualConsumption", "batteryCapacity", "batteryChargePower", "batteryDischargePower", "batteryOutputPower", "batteryEfficiency"].forEach((id) => {
    on(id, "input", () => {
      if (deferredBatteryCapacityFields.has(id)) {
        if (id.startsWith("battery")) switchBatteryPresetToCustom();
        return;
      }
      rerenderPrimaryField(id);
    });
    on(id, "change", () => {
      rerenderPrimaryField(id);
    });
    on(id, "blur", () => {
      rerenderPrimaryField(id);
    });
    on(id, "keydown", (event) => {
      if (event.key !== "Enter") return;
      event.preventDefault();
      rerenderPrimaryField(id);
    });
  });
  ["timezone", "latitude", "longitude", "annualSource", "pvgisProxy"].forEach((id) => {
    const handleRemoteInput = () => {
      readInputsToState({ allowEvPrompt: false });
      saveLocalDebounced();
      scheduleDataRefresh();
    };
    on(id, "input", handleRemoteInput);
    on(id, "change", handleRemoteInput);
  });
  ["evAnnualKm", "evKwhPer100Km", "evScheduleMode", "evTypicalTime", "evChargeSpeedKw", "evChargingType", "evBatteryKwh", "evTypicalChargeLimitPct", "evAddOnTop"].forEach((id) => {
    const el = $(id);
    if (!el) return;
    const rerenderEv = (allowEvPrompt) => {
      updateEvDerivedValues();
      readInputsToState({ allowEvPrompt });
      requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] });
      saveLocalDebounced();
    };
    if (id === "evAddOnTop") {
      el.addEventListener("input", () => rerenderEv(false));
      el.addEventListener("change", () => rerenderEv(false));
    } else {
      el.addEventListener("input", () => rerenderEv(false));
      el.addEventListener("change", () => rerenderEv(true));
    }
  });
  const evPhaseMode = $("evPhaseMode");
  if (evPhaseMode) {
    evPhaseMode.querySelectorAll("[data-evphase]").forEach((button) => {
      button.addEventListener("click", () => {
        state.evPhaseMode = button.dataset.evphase || "hybrid";
        evPhaseMode.querySelectorAll("[data-evphase]").forEach((pill) => {
          pill.setAttribute("aria-pressed", pill === button ? "true" : "false");
        });
        updateEvDerivedValues();
        readInputsToState({ allowEvPrompt: false });
        requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] });
        saveLocalDebounced();
      });
    });
  }
  const evLimitInput = $("evTypicalChargeLimitPct");
  if (evLimitInput) {
    const normalizeLimitInput = () => {
      const clamped = clamp(localeNumber(evLimitInput.value, state.evTypicalChargeLimitPct), 50, 100);
      evLimitInput.value = de0(clamped);
      state.evTypicalChargeLimitPct = clamped;
      readInputsToState({ allowEvPrompt: false });
      requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] });
      saveLocalDebounced();
    };
    evLimitInput.addEventListener("blur", normalizeLimitInput);
    evLimitInput.addEventListener("keydown", (event) => {
      if (event.key === "Enter") normalizeLimitInput();
    });
  }
  const evWeekdays = $("evWeekdays");
  if (evWeekdays) {
    evWeekdays.querySelectorAll("[data-evday]").forEach((button) => {
      button.addEventListener("click", () => {
        const day = Number(button.dataset.evday);
        const selected = sanitizeEvWeekdays(state.evWeeklyDays);
        const idx = selected.indexOf(day);
        if (idx >= 0) selected.splice(idx, 1);
        else selected.push(day);
        state.evWeeklyDays = sanitizeEvWeekdays(selected);
        updateEvScheduleUi();
        readInputsToState();
        requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] });
        saveLocalDebounced();
      });
    });
  }
  on("locationName", "keydown", (event) => {
    if (event.key === "Enter") { event.preventDefault(); searchLocation(); }
    if (event.key === "Escape") hideLocationSuggestions();
  });
  on("locationName", "input", () => {
    state.locationSource = "manual";
    clearTimeout(locationSuggestTimer);
    locationSuggestTimer = setTimeout(fetchLocationSuggestions, 220);
  });
  on("inverterLimitEnabled", "change", () => { readInputsToState(); updateInverterVisibility(); refresh(); });
  on("inverterAdvancedToggle", "click", () => {
    state.inverterAdvancedEnabled = !state.inverterAdvancedEnabled;
    updateInverterAdvancedUi();
    readInputsToState({ allowEvPrompt: false });
    if ($("settingsModal")?.classList.contains("open")) renderAreaEditor();
    saveLocal();
    requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] });
    refresh();
  });
  on("inverterType", "change", () => {
    readInputsToState({ allowEvPrompt: false });
    enforceAioInverterBatteryCoupling();
    updateBatteryMode();
    updateBatteryPresetUi();
    updateInverterAdvancedUi();
    saveLocal();
    requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] });
    refresh();
  });
  on("plugSolarLimit", "change", () => {
    if (usesBatteryIntegratedInverter()) {
      switchBatteryPresetToCustom();
      syncIntegratedInverterControls("inverterPlug");
    }
    readInputsToState();
    updateInverterVisibility();
    refresh();
  });
  on("priceIncrease", "change", () => { readInputsToState(); saveLocal(); requestRender(["financeOnly"], { invalidate: ["finance"] }); });
  on("expertToggle", "click", () => { state.expertMode = !state.expertMode; updateExpertMode(); saveLocal(); refresh(); });
  on("batteryToggle", "click", () => { state.batteryMode = !state.batteryMode; updateBatteryMode(); saveLocal(); requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] }); });
  on("showEnergyFlow", "change", () => { readInputsToState({ allowEvPrompt: false }); saveLocal(); renderSystemSummary(); });
  const evToggle = $("evToggle");
  if (evToggle) {
    evToggle.addEventListener("click", () => {
      if (!state.expertMode) {
        state.expertMode = true;
        updateExpertMode();
      }
      state.evMode = !state.evMode;
      updateEvMode();
      readInputsToState();
      saveLocal();
      requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] });
    });
  }
  on("batteryPlugIn", "change", () => {
    switchBatteryPresetToCustom();
    if (usesBatteryIntegratedInverter()) syncIntegratedInverterControls("batteryPlug");
    readInputsToState();
    updateBatteryOutputVisibility();
    updateInverterVisibility();
    saveLocal();
    requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] });
  });
  on("batteryType", "change", () => { switchBatteryPresetToCustom(); readInputsToState(); updateInverterVisibility(); saveLocal(); requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] }); });
  on("smartMeterInstalled", "change", () => { readInputsToState(); saveLocal(); requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] }); });
  on("loadProfile", "change", () => { readInputsToState(); updateLoadProfileHint(); saveLocal(); requestRender(["chartOnly", "financeOnly"], { invalidate: ["energy", "finance", "charts"] }); });
  on("batteryPreset", "change", () => { applyBatteryPreset($("batteryPreset").value); readInputsToState(); saveLocal(); requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] }); });
  on("batteryExtensionsEnabled", "change", () => {
    switchBatteryPresetToCustom();
    commitBatteryConfigRender();
  });
  on("batterySocMin", "input", () => { switchBatteryPresetToCustom(); commitBatteryConfigRender(); });
  on("batterySocMin", "change", () => { switchBatteryPresetToCustom(); commitBatteryConfigRender(); });
  on("batterySocMax", "input", () => { switchBatteryPresetToCustom(); commitBatteryConfigRender(); });
  on("batterySocMax", "change", () => { switchBatteryPresetToCustom(); commitBatteryConfigRender(); });
  on("batteryExtensionAddBtn", "click", addBatteryExtension);
  const batteryExtensionList = $("batteryExtensionList");
  if (batteryExtensionList) {
    batteryExtensionList.addEventListener("input", (event) => {
      const input = event.target.closest("[data-battery-extension-index], [data-battery-base-input]");
      if (!input || !batteryExtensionList.contains(input)) return;
      switchBatteryPresetToCustom();
    });
    batteryExtensionList.addEventListener("change", (event) => {
      const input = event.target.closest("[data-battery-extension-index], [data-battery-base-input]");
      if (!input || !batteryExtensionList.contains(input)) return;
      if (input.hasAttribute("data-battery-base-input")) setValue("batteryCapacity", input.value);
      switchBatteryPresetToCustom();
      commitBatteryConfigRender();
    });
    batteryExtensionList.addEventListener("focusout", (event) => {
      const input = event.target.closest("[data-battery-extension-index], [data-battery-base-input]");
      if (!input || !batteryExtensionList.contains(input)) return;
      if (input.hasAttribute("data-battery-base-input")) setValue("batteryCapacity", input.value);
      switchBatteryPresetToCustom();
      commitBatteryConfigRender();
    });
    batteryExtensionList.addEventListener("keydown", (event) => {
      const input = event.target.closest("[data-battery-extension-index], [data-battery-base-input]");
      if (!input || !batteryExtensionList.contains(input)) return;
      if (event.key !== "Enter") return;
      event.preventDefault();
      if (input.hasAttribute("data-battery-base-input")) setValue("batteryCapacity", input.value);
      switchBatteryPresetToCustom();
      commitBatteryConfigRender();
    });
    batteryExtensionList.addEventListener("click", (event) => {
      const button = event.target.closest("[data-battery-extension-remove]");
      if (!button || !batteryExtensionList.contains(button)) return;
      removeBatteryExtension(Number(button.dataset.batteryExtensionRemove));
    });
  }
  ["batteryCapacity", "batteryChargePower", "batteryDischargePower", "batteryOutputPower", "batteryEfficiency", "batteryType"].forEach((id) => {
    on(id, "input", () => { switchBatteryPresetToCustom(); });
  });
  on("themeBtn", "click", () => { state.theme = state.theme === "dark" ? "light" : "dark"; saveLocal(); requestRender(["theme"], { invalidate: ["charts"] }); });
  on("settingsBtn", "click", openModal);
  on("closeModal", "click", closeModal);
  on("modalBackdrop", "click", closeModal);
  on("refreshBtn", "click", () => refresh({ includeForecast: state.mainChartMode === "current" }));
  on("saveBtn", "click", closeModal);
  on("addAreaBtn", "click", () => {
    if (state.areas.length >= 8) { setStatus("Maximal 8 Flächen möglich."); return; }
    const i = state.areas.length;
    state.areas.push({ name: `Fläche ${i + 1}`, azimuth: 180, tilt: 35, kwp: 1.0, color: COLORS[i % COLORS.length] });
    ensureSeriesState();
    ensureAreaEditorState(true);
    runtimeState.areaEditorOpen.add(i);
    saveLocal();
    renderAreaEditor();
    requestRender(["chipsOnly", "financeOnly", "chartOnly"], { invalidate: ["forecast", "annual", "energy", "finance", "charts"] });
  });
  on("measureTutorialToggle", "click", () => {
    const card = $("measureTutorialCard");
    const btn = $("measureTutorialToggle");
    if (!card || !btn) return;
    card.hidden = !card.hidden;
    btn.textContent = card.hidden ? "Anleitung anzeigen" : "Anleitung ausblenden";
  });
  const areaChips = $("areaChips");
  if (areaChips) {
    areaChips.addEventListener("click", (event) => {
      const button = event.target.closest("[data-series]");
      if (!button || !areaChips.contains(button)) return;
      const key = button.dataset.series || "";
      const now = Date.now();
      const isRapidRepeat = runtimeState.lastSeriesTapKey === key && (now - runtimeState.lastSeriesTapAt) < 360;
      runtimeState.lastSeriesTapKey = key;
      runtimeState.lastSeriesTapAt = now;
      if (key === "combined" && isRapidRepeat) {
        activeSeries.combined = false;
        activeSeries.areas = activeSeries.areas.map(() => true);
        saveLocal();
        requestRender(["chipsOnly", "chartOnly"]);
        return;
      }
      toggleSeries(key);
    });
    areaChips.addEventListener("dblclick", (event) => {
      const button = event.target.closest("[data-series]");
      if (!button || !areaChips.contains(button)) return;
      const key = button.dataset.series || "";
      if (key === "combined") {
        activeSeries.combined = false;
        activeSeries.areas = activeSeries.areas.map(() => true);
        saveLocal();
        requestRender(["chipsOnly", "chartOnly"]);
        return;
      }
      const idx = Number(key.split("-")[1]);
      if (!Number.isFinite(idx)) return;
      activeSeries.combined = false;
      activeSeries.areas = activeSeries.areas.map((_, areaIndex) => areaIndex === idx);
      saveLocal();
      requestRender(["chipsOnly", "chartOnly"]);
    });
  }
  const dayTabs = $("dayTabs");
  if (dayTabs) {
    dayTabs.addEventListener("click", (event) => {
      const button = event.target.closest("[data-day]");
      if (!button || !dayTabs.contains(button)) return;
      state.selectedDayIndex = Number(button.dataset.day);
      requestRender(["daySelection"]);
    });
  }
  const mainChartModeTabs = $("mainChartModeTabs");
  if (mainChartModeTabs) {
    mainChartModeTabs.addEventListener("click", (event) => {
      const button = event.target.closest("[data-main-chart]");
      if (!button || !mainChartModeTabs.contains(button)) return;
      state.mainChartMode = button.dataset.mainChart;
      saveLocal();
      if (state.mainChartMode === "current" && !hasCurrentForecastData()) {
        setCurrentForecastStatus("loading", "Daten werden geladen …");
        requestRender(["tabsOnly", "chartOnly", "financeOnly"]);
        refresh({ includeForecast: true });
        return;
      }
      requestRender(["tabsOnly", "chartOnly", "financeOnly"]);
    });
  }
  const yearlyChartModeTabs = $("yearlyChartModeTabs");
  if (yearlyChartModeTabs) {
    yearlyChartModeTabs.addEventListener("click", (event) => {
      const button = event.target.closest("[data-yearly-chart]");
      if (!button || !yearlyChartModeTabs.contains(button)) return;
      state.yearlyChartMode = button.dataset.yearlyChart;
      saveLocal();
      requestRender(["chartOnly"]);
    });
  }
  const forecastTabs = $("forecastTabs");
  if (forecastTabs) {
    forecastTabs.addEventListener("click", (event) => {
      const button = event.target.closest("[data-forecast]");
      if (!button || !forecastTabs.contains(button)) return;
      updateUi({ savingsForecastMode: button.dataset.forecast });
      requestRender(["financeOnly"]);
    });
  }
  on("resetBtn", "click", () => { localStorage.removeItem(LS_KEY); location.href = location.pathname; });
  on("shareBtn", "click", async () => { try { await navigator.clipboard.writeText(makeShareUrl()); setStatus("Link wurde in die Zwischenablage kopiert."); } catch { setStatus(makeShareUrl()); } });
  on("useMyLocation", "click", requestCurrentLocation);
  on("measureBackdrop", "click", closeMeasureModal);
  on("closeMeasure", "click", closeMeasureModal);
  on("keepValues", "click", closeMeasureModal);
  on("removeAreaConfirmBackdrop", "click", closeRemoveAreaConfirm);
  on("cancelRemoveArea", "click", closeRemoveAreaConfirm);
  on("confirmRemoveArea", "click", confirmRemoveArea);
  on("measureLiveToggle", "click", toggleLiveMeasurement);
  on("measureReset", "click", resetLiveMeasurement);
  on("startMeasure", "click", startMeasurement);
  on("applyMeasure", "click", applyMeasurement);
  on("measureTiltDrag", "pointerdown", () => {
    if (measurementPhase !== "manual") switchToManualMeasurement({ preserveCurrent: true });
  });
  on("measureTiltDrag", "input", () => {
    if (measurementPhase !== "manual") switchToManualMeasurement({ preserveCurrent: true });
    measuredTilt = Math.round(clamp($("measureTiltDrag").value, 0, 90));
    triggerMeasureHaptic("tilt", measuredTilt, "manual");
    updateMeasurePreview();
  });
  setupCompassDrag();
  setupTiltDrag();
  document.addEventListener("keydown", (event) => { if (event.key === "Escape") { closeModal(); closeMeasureModal(); closeRemoveAreaConfirm(); } });
}

function readInputsToState(options = {}) {
  const { allowEvPrompt = true } = options;
  const valueOf = (id, fallback = "") => ($(id)?.value ?? fallback);
  const checkedOf = (id, fallback = false) => ($(id)?.checked ?? fallback);
  if (!["gps", "manual"].includes(state.locationSource)) state.locationSource = "manual";
  state.locationName = String(valueOf("locationName", state.locationName)).trim() || "Standort";
  state.tz = String(valueOf("timezone", state.tz)).trim() || "Europe/Berlin";
  state.lat = localeNumber(valueOf("latitude", state.lat), state.lat);
  state.lon = localeNumber(valueOf("longitude", state.lon), state.lon);
  state.countryHint = String(valueOf("countryHint", state.countryHint)).trim() || "Deutschland";
  state.inverterLimitEnabled = checkedOf("inverterLimitEnabled", state.inverterLimitEnabled);
  state.plugSolarLimit = checkedOf("plugSolarLimit", state.plugSolarLimit);
  const inverterInput = $("inverterPower");
  if (!inverterInput || !inverterInput.disabled) {
    state.inverterPower = localeNumber(valueOf("inverterPower", state.inverterPower), 0.1);
  }
  state.systemCost = localeNumber(valueOf("systemCost", state.systemCost), 0);
  state.batterySystemCost = localeNumber(valueOf("batterySystemCost", state.batterySystemCost), 0);
  state.electricityPrice = localeNumber(valueOf("electricityPrice", state.electricityPrice), 0);
  state.feedInTariff = localeNumber(valueOf("feedInTariff", state.feedInTariff), 0);
  {
    const v = String(valueOf("selfConsumption", "")).trim();
    state.selfConsumption = v === "" ? null : localeNumber(v, null);
  }
  {
    const v = String(valueOf("performanceRatio", "")).trim();
    state.performanceRatio = v === "" ? null : localeNumber(v, null);
  }
  state.inverterAdvancedEnabled = $("inverterAdvancedToggle") ? $("inverterAdvancedToggle").classList.contains("oce-open") : state.inverterAdvancedEnabled;
  state.inverterType = String(valueOf("inverterType", state.inverterType)) || "micro";
  {
    const v = String(valueOf("inverterMpptCount", "")).trim();
    state.inverterMpptCount = v === "" ? null : Math.max(1, Math.round(localeNumber(v, null)));
  }
  {
    const v = String(valueOf("inverterDcAcRatio", "")).trim();
    state.inverterDcAcRatio = v === "" ? null : Math.max(0.1, localeNumber(v, null));
  }
  const shadeEnabledEl = document.querySelector("[data-inverter-shade-enabled]");
  const shadeLevelEl = document.querySelector("[data-inverter-shade-level]");
  state.inverterShadeEnabled = shadeEnabledEl ? Boolean(shadeEnabledEl.checked) : state.inverterShadeEnabled;
  state.inverterShadeLevel = shadeLevelEl ? (String(shadeLevelEl.value || state.inverterShadeLevel) || "light") : state.inverterShadeLevel;
  state.priceIncrease = checkedOf("priceIncrease", state.priceIncrease);
  state.showEnergyFlow = checkedOf("showEnergyFlow", state.showEnergyFlow);
  state.annualSource = String(valueOf("annualSource", state.annualSource));
  state.pvgisProxy = String(valueOf("pvgisProxy", state.pvgisProxy)).trim();
  state.batteryPreset = String(valueOf("batteryPreset", state.batteryPreset));
  state.batteryPlugIn = checkedOf("batteryPlugIn", state.batteryPlugIn);
  state.batteryType = String(valueOf("batteryType", state.batteryType)) || "all_in_one";
  state.batteryExtensionsEnabled = checkedOf("batteryExtensionsEnabled", state.batteryExtensionsEnabled);
  state.batteryExtensionMode = "individual";
  state.batterySocMinPct = localeNumber(valueOf("batterySocMin", state.batterySocMinPct), state.batterySocMinPct);
  state.batterySocMaxPct = localeNumber(valueOf("batterySocMax", state.batterySocMaxPct), state.batterySocMaxPct);
  state.batteryExtensionModules = [...document.querySelectorAll("[data-battery-extension-index]")]
    .map((input) => Math.max(0.1, localeNumber(input.value, state.batteryExtensionCapacityKwh)));
  state.smartMeterInstalled = checkedOf("smartMeterInstalled", state.smartMeterInstalled);
  state.evMode = $("evToggle") ? $("evToggle").classList.contains("oce-open") : state.evMode;
  state.evAnnualKm = Math.max(0, localeNumber(valueOf("evAnnualKm", state.evAnnualKm), state.evAnnualKm));
  state.evKwhPer100Km = Math.max(0, localeNumber(valueOf("evKwhPer100Km", state.evKwhPer100Km), state.evKwhPer100Km));
  state.evScheduleMode = String(valueOf("evScheduleMode", state.evScheduleMode)) || state.evScheduleMode;
  state.evTypicalTime = String(valueOf("evTypicalTime", state.evTypicalTime)) || state.evTypicalTime;
  {
    const pickedDays = [...document.querySelectorAll("#evWeekdays [data-evday][aria-pressed='true']")]
      .map((el) => Number(el.dataset.evday));
    if (pickedDays.length) state.evWeeklyDays = sanitizeEvWeekdays(pickedDays);
  }
  state.evChargeSpeedKw = Math.max(0, localeNumber(valueOf("evChargeSpeedKw", state.evChargeSpeedKw), state.evChargeSpeedKw));
  state.evChargingType = String(valueOf("evChargingType", state.evChargingType)) || state.evChargingType;
  state.evPhaseMode = document.querySelector("#evPhaseMode [data-evphase][aria-pressed='true']")?.dataset.evphase || state.evPhaseMode;
  state.evBatteryKwh = Math.max(0, localeNumber(valueOf("evBatteryKwh", state.evBatteryKwh), state.evBatteryKwh));
  state.evTypicalChargeLimitPct = clamp(localeNumber(valueOf("evTypicalChargeLimitPct", state.evTypicalChargeLimitPct), state.evTypicalChargeLimitPct), 50, 100);
  state.evAddOnTop = checkedOf("evAddOnTop", state.evAddOnTop);
  state.evAnnualKwh = Math.max(0, (state.evAnnualKm * state.evKwhPer100Km / 100) / Math.max(0.01, state.evEfficiencyPct / 100));
  normalizeEvConfig();
  normalizeInverterAdvancedConfig();
  state.evEfficiencyPct = evChargeEfficiencyPct(effectiveEvChargeSpeedKw(), state.evChargingType);
  state.evAnnualKwh = Math.max(0, (state.evAnnualKm * state.evKwhPer100Km / 100) / Math.max(0.01, state.evEfficiencyPct / 100));
  state.loadProfile = String(valueOf("loadProfile", state.loadProfile));
  const annualInputValue = Math.max(0, localeNumber(valueOf("annualConsumption", state.annualConsumptionKwh), DEFAULT_ANNUAL_CONSUMPTION_KWH));
  if (evEnabled() && state.evAddOnTop) {
    state.annualConsumptionHouseKwh = Math.max(0, annualInputValue - state.evAnnualKwh);
  } else {
    state.annualConsumptionHouseKwh = annualInputValue;
  }
  normalizeAnnualConsumptionState();
  const capacityInputValue = localeNumber(valueOf("batteryCapacity", state.batteryExtensionsEnabled ? state.batteryBaseCapacityKwh : state.batteryCapacityKwh), state.batteryExtensionsEnabled ? state.batteryBaseCapacityKwh : state.batteryCapacityKwh);
  if (state.batteryPreset === "custom") {
    const charge = localeNumber($("batteryChargePower").value, 0.1);
    const discharge = localeNumber($("batteryDischargePower").value, 0.1);
    const output = localeNumber($("batteryOutputPower").value, 0.1);
    const efficiency = localeNumber($("batteryEfficiency").value, 90);
    if ($("batteryCapacity").value.trim() !== "") state.batteryBaseCapacityKwh = Math.max(0.1, capacityInputValue);
    if ($("batteryChargePower").value.trim() !== "") state.batteryChargeKw = charge;
    if ($("batteryDischargePower").value.trim() !== "") state.batteryDischargeKw = discharge;
    if ($("batteryOutputPower").value.trim() !== "") state.batteryOutputKw = output;
    if ($("batteryEfficiency").value.trim() !== "") state.batteryEfficiencyPct = efficiency;
  } else {
    state.batteryBaseCapacityKwh = Math.max(0.1, capacityInputValue);
    state.batteryChargeKw = localeNumber($("batteryChargePower").value, 0.1);
    state.batteryDischargeKw = localeNumber($("batteryDischargePower").value, 0.1);
    state.batteryOutputKw = localeNumber($("batteryOutputPower").value, 0.1);
    state.batteryEfficiencyPct = localeNumber($("batteryEfficiency").value, 90);
  }
  enforceAioInverterBatteryCoupling();
  normalizeBatteryConfig();
  if (usesBatteryIntegratedInverter()) {
    state.plugSolarLimit = state.batteryPlugIn;
    state.inverterPower = state.batteryPlugIn ? 0.8 : state.batteryOutputKw;
  }
  updateLoadProfileHint();
}

function syncInputs() {
  setValue("locationName", state.locationName);
  setValue("timezone", state.tz);
  setValue("latitude", Number.isFinite(state.lat) ? de(state.lat, 4) : "");
  setValue("longitude", Number.isFinite(state.lon) ? de(state.lon, 4) : "");
  setValue("countryHint", state.countryHint || "");
  setChecked("inverterLimitEnabled", state.inverterLimitEnabled);
  setChecked("plugSolarLimit", state.plugSolarLimit);
  setValue("inverterPower", state.inverterPower);
  setValue("systemCost", state.systemCost);
  setValue("batterySystemCost", state.batterySystemCost);
  updateSystemCostBreakdownUi();
  setValue("electricityPrice", state.electricityPrice);
  setValue("feedInTariff", state.feedInTariff);
  setValue("selfConsumption", Number.isFinite(state.selfConsumption) ? state.selfConsumption : "");
  setValue("performanceRatio", Number.isFinite(state.performanceRatio) ? state.performanceRatio : "");
  setValue("inverterType", state.inverterType);
  setValue("inverterMpptCount", Number.isFinite(state.inverterMpptCount) ? de0(state.inverterMpptCount) : "");
  setValue("inverterDcAcRatio", Number.isFinite(state.inverterDcAcRatio) ? de(state.inverterDcAcRatio, 2) : "");
  setChecked("priceIncrease", state.priceIncrease);
  setChecked("showEnergyFlow", state.showEnergyFlow);
  setValue("annualSource", state.annualSource);
  setValue("pvgisProxy", state.pvgisProxy);
  setValue("batteryPreset", state.batteryPreset);
  setChecked("batteryPlugIn", state.batteryPlugIn);
  setChecked("batteryExtensionsEnabled", state.batteryExtensionsEnabled);
  setValue("batteryType", state.batteryType);
  setChecked("smartMeterInstalled", state.smartMeterInstalled);
  setValue("loadProfile", state.loadProfile);
  setValue("annualConsumption", evEnabled() && state.evAddOnTop ? de0(annualTotalConsumptionKwh()) : de0(annualHouseConsumptionKwh()));
  setValue("batteryCapacity", state.batteryExtensionsEnabled ? deMax(state.batteryBaseCapacityKwh, 3) : deMax(state.batteryCapacityKwh, 3));
  setValue("batteryChargePower", state.batteryChargeKw);
  setValue("batteryDischargePower", state.batteryDischargeKw);
  setValue("batteryOutputPower", state.batteryOutputKw);
  setValue("batteryEfficiency", state.batteryEfficiencyPct);
  setValue("batterySocMin", state.batterySocMinPct);
  setValue("batterySocMax", state.batterySocMaxPct);
  setValue("evAnnualKm", state.evAnnualKm);
  setValue("evKwhPer100Km", state.evKwhPer100Km);
  setValue("evScheduleMode", state.evScheduleMode);
  setValue("evTypicalTime", state.evTypicalTime);
  setValue("evChargeSpeedKw", state.evChargeSpeedKw);
  setValue("evChargingType", state.evChargingType);
  setValue("evBatteryKwh", state.evBatteryKwh);
  setValue("evTypicalChargeLimitPct", state.evTypicalChargeLimitPct);
  setChecked("evAddOnTop", state.evAddOnTop);
  setValue("evAnnualKwh", `${de0(state.evAnnualKwh)} kWh/Jahr`);
  setValue("evEfficiency", `${de(state.evEfficiencyPct, 0)}%`);
  updateEvScheduleUi();
  updateInverterVisibility(); updateInverterAdvancedUi(); updateExpertMode(); updateBatteryMode(); updateEvMode(); updateLoadProfileHint(); updateAnnualConsumptionUi();
  updateBatteryPresetUi();
}
function updateInverterVisibility() {
  const input = $("inverterPower");
  const plugToggle = $("plugSolarLimit");
  const lockHint = $("inverterLockHint");
  const limitRow = $("inverterLimitRow");
  const limitToggle = $("inverterLimitEnabled");
  if (!input) return;
  const integrated = usesBatteryIntegratedInverter();
  if (integrated && !runtimeState.wasIntegratedInverter) {
    runtimeState.previousPlugSolarLimit = Boolean(state.plugSolarLimit);
    runtimeState.previousInverterPower = Number(state.inverterPower || 0);
  }
  if (!integrated && runtimeState.wasIntegratedInverter && runtimeState.previousPlugSolarLimit != null) {
    state.plugSolarLimit = runtimeState.previousPlugSolarLimit;
    if (runtimeState.previousInverterPower != null) state.inverterPower = Number(runtimeState.previousInverterPower);
    if (plugToggle) plugToggle.checked = state.plugSolarLimit;
    runtimeState.previousPlugSolarLimit = null;
    runtimeState.previousInverterPower = null;
  }
  runtimeState.wasIntegratedInverter = integrated;
  const plugActive = !integrated && state.plugSolarLimit;
  if (integrated) {
    state.plugSolarLimit = state.batteryPlugIn;
    state.inverterPower = state.batteryPlugIn ? 0.8 : state.batteryOutputKw;
  }
  if (plugToggle) {
    plugToggle.checked = integrated ? state.batteryPlugIn : plugActive;
  }
  const inverterWrap = $("inverterCustomWrap");
  if (inverterWrap) inverterWrap.classList.toggle("is-disabled", integrated ? state.batteryPlugIn : plugActive);
  if (lockHint) {
    lockHint.hidden = !(integrated || plugActive);
    lockHint.textContent = integrated
      ? `Mit All in One verknüpft: Wechselrichterleistung und Steckersolar folgen dem Speichersystem in beide Richtungen.`
      : "Nicht editierbar: Steckersolar (0,8 kW) ist aktiv.";
  }
  if (integrated) {
    input.value = state.batteryPlugIn ? "0.8" : String(state.batteryOutputKw);
    input.disabled = state.batteryPlugIn;
    if (plugToggle) plugToggle.disabled = false;
  } else if (plugActive) {
    input.value = "0.8";
    input.disabled = true;
    if (plugToggle) plugToggle.disabled = false;
  } else {
    input.disabled = false;
    input.value = String(state.inverterPower);
    if (plugToggle) plugToggle.disabled = false;
  }
  const showLimitToggle = totalKwp() > activeSystemKw();
  if (limitRow) limitRow.hidden = !showLimitToggle;
  if (!showLimitToggle) {
    state.inverterLimitEnabled = false;
    if (limitToggle) limitToggle.checked = false;
  }
}
function updateInverterAdvancedUi() {
  const panel = $("inverterAdvancedPanel");
  const toggle = $("inverterAdvancedToggle");
  const label = $("inverterAdvancedLabel");
  const hint = $("inverterAdvancedWarning");
  if (!panel || !toggle || !label) return;
  panel.classList.toggle("open", state.inverterAdvancedEnabled);
  toggle.classList.toggle("oce-open", state.inverterAdvancedEnabled);
  label.textContent = state.inverterAdvancedEnabled ? "An" : "Aus";
  if (hint) {
    hint.hidden = true;
    hint.textContent = "";
    if (!state.inverterAdvancedEnabled) return;
    const type = inverterTypeNormalized();
    if (type === "micro") {
      hint.hidden = false;
      hint.textContent = "Hinweis: Bei Mikrowechselrichtern ist MPPT typischerweise je Modul/Tracker geführt; die MPPT-Prüfung auf Flächenanzahl ist hier optional.";
      return;
    }
    if (!Number.isFinite(state.inverterMpptCount)) {
      hint.hidden = false;
      hint.textContent = "Hinweis: Für String, Hybrid und All in One bitte Anzahl MPPT eintragen, damit die Flächenprüfung aktiv wird.";
      return;
    }
    if (state.areas.length > state.inverterMpptCount) {
      hint.hidden = false;
      hint.textContent = `Hinweis: ${state.areas.length} Flächen konfiguriert, aber nur ${de0(state.inverterMpptCount)} MPPT angegeben.`;
      return;
    }
    hint.hidden = false;
    hint.textContent = `MPPT passt: ${de0(state.inverterMpptCount)} MPPT für ${state.areas.length} Flächen.`;
  }
}
function syncIntegratedInverterControls(source = "") {
  if (!usesBatteryIntegratedInverter()) return;
  const inverterInput = $("inverterPower");
  const batteryOutputInput = $("batteryOutputPower");
  const inverterPlug = $("plugSolarLimit");
  const batteryPlug = $("batteryPlugIn");
  let plugIn = state.batteryPlugIn;
  if (source === "inverterPlug" && inverterPlug) plugIn = Boolean(inverterPlug.checked);
  else if (source === "batteryPlug" && batteryPlug) plugIn = Boolean(batteryPlug.checked);
  state.batteryPlugIn = plugIn;
  state.plugSolarLimit = plugIn;
  if (inverterPlug) inverterPlug.checked = plugIn;
  if (batteryPlug) batteryPlug.checked = plugIn;
  let outputKw = state.batteryOutputKw;
  if (plugIn) {
    outputKw = 0.8;
  } else if (source === "inverterPower" && inverterInput) {
    outputKw = Math.max(0.1, localeNumber(inverterInput.value, state.batteryOutputKw));
  } else if (source === "batteryOutput" && batteryOutputInput) {
    outputKw = Math.max(0.1, localeNumber(batteryOutputInput.value, state.batteryOutputKw));
  }
  state.batteryOutputKw = outputKw;
  state.inverterPower = outputKw;
  if (inverterInput) inverterInput.value = plugIn ? "0.8" : String(outputKw);
  if (batteryOutputInput) batteryOutputInput.value = plugIn ? "0.8" : String(outputKw);
}
function updateExpertMode() {
  if (!state.expertMode) state.evMode = false;
  $("expertPanel").classList.toggle("open", state.expertMode);
  $("expertToggle").classList.toggle("oce-open", state.expertMode);
  $("expertLabel").textContent = state.expertMode ? "An" : "Aus";
  const evToggle = $("evToggle");
  if (evToggle) {
    evToggle.disabled = !state.expertMode;
    evToggle.style.opacity = state.expertMode ? "1" : "0.55";
  }
  if (!state.expertMode) state.showEnergyFlow = false;
  setChecked("showEnergyFlow", state.showEnergyFlow);
  renderEnergyFlowPanel();
}
function updateBatteryMode() {
  $("batteryPanel").classList.toggle("open", state.batteryMode);
  $("batteryToggle").classList.toggle("oce-open", state.batteryMode);
  $("batteryLabel").textContent = state.batteryMode ? "An" : "Aus";
  const systemCostWrap = $("systemCostWrap");
  const pvCostWrap = $("pvSystemCostWrap");
  const batteryCostWrap = $("batterySystemCostWrap");
  if (systemCostWrap) systemCostWrap.firstChild.textContent = state.batteryMode ? "Systemkosten gesamt (€)" : "Systemkosten (€)";
  if (pvCostWrap) pvCostWrap.hidden = !state.batteryMode;
  if (batteryCostWrap) batteryCostWrap.hidden = !state.batteryMode;
  if (!state.batteryMode) {
    const pvInput = $("pvSystemCost");
    const batteryCostInput = $("batterySystemCost");
    if (pvInput) pvInput.value = "";
    if (batteryCostInput) batteryCostInput.value = "";
    if (batteryCostInput) batteryCostInput.blur();
  }
  updateSystemCostBreakdownUi();
  renderBatteryExtensionsUi();
  updateBatteryOutputVisibility();
  updateInverterVisibility();
}

function updateSystemCostBreakdownUi(options = {}) {
  const { source = null, normalizeSource = true } = options;
  const systemInput = $("systemCost");
  const pvInput = $("pvSystemCost");
  const batteryInput = $("batterySystemCost");
  if (!systemInput || !pvInput || !batteryInput) return;
  if (!state.batteryMode) {
    setValue("systemCost", de0(state.systemCost));
    return;
  }
  const parseCostInput = (el, fallback) => {
    const raw = String(el?.value ?? "").trim();
    return { raw, hasValue: raw !== "", value: raw === "" ? 0 : Math.max(0, localeNumber(raw, fallback)) };
  };
  const totalField = parseCostInput(systemInput, state.systemCost);
  const pvField = parseCostInput(pvInput, Math.max(0, Number(state.systemCost || 0) - Number(state.batterySystemCost || 0)));
  const batteryField = parseCostInput(batteryInput, state.batterySystemCost);
  let total = totalField.value;
  let pv = pvField.value;
  let battery = batteryField.value;
  let totalHas = totalField.hasValue;
  let pvHas = pvField.hasValue;
  let batteryHas = batteryField.hasValue;

  if (source === "pv" || source === "battery") runtimeState.lastCostComponentEdited = source;

  if (source === "pv") {
    if (pvHas && batteryHas) {
      total = pv + battery;
      totalHas = true;
    } else if (pvHas && totalHas) {
      battery = Math.max(0, total - pv);
      batteryHas = true;
    }
  } else if (source === "battery") {
    if (pvHas && batteryHas) {
      total = pv + battery;
      totalHas = true;
    } else if (batteryHas && totalHas) {
      pv = Math.max(0, total - battery);
      pvHas = true;
    }
  } else if (source === "system") {
    if (totalHas && pvHas && batteryHas) {
      if (runtimeState.lastCostComponentEdited === "pv") {
        battery = Math.max(0, total - pv);
      } else {
        pv = Math.max(0, total - battery);
      }
    } else if (totalHas && pvHas) {
      battery = Math.max(0, total - pv);
      batteryHas = true;
    } else if (totalHas && batteryHas) {
      pv = Math.max(0, total - battery);
      pvHas = true;
    } else if (pvHas && batteryHas) {
      total = pv + battery;
      totalHas = true;
    }
  } else {
    total = Math.max(0, Number(state.systemCost || 0));
    battery = Math.max(0, Number(state.batterySystemCost || 0));
    pv = Math.max(0, total - battery);
    totalHas = pvHas = batteryHas = true;
  }

  if (pvHas && batteryHas && (!totalHas || source === "pv" || source === "battery")) {
    total = pv + battery;
    totalHas = true;
  }
  if (totalHas && pvHas && !batteryHas) {
    battery = Math.max(0, total - pv);
    batteryHas = true;
  }
  if (totalHas && batteryHas && !pvHas) {
    pv = Math.max(0, total - battery);
    pvHas = true;
  }

  total = Math.max(0, total);
  pv = Math.max(0, pv);
  battery = Math.max(0, battery);
  const fallbackTotal = Math.max(0, Number(state.systemCost || 0));
  const fallbackBattery = Math.max(0, Number(state.batterySystemCost || 0));
  const finalTotal = totalHas ? total : fallbackTotal;
  const finalBattery = batteryHas ? battery : fallbackBattery;
  const finalPv = pvHas ? pv : Math.max(0, finalTotal - finalBattery);
  state.systemCost = finalTotal;
  state.batterySystemCost = finalBattery;

  if (normalizeSource || source !== "system") systemInput.value = de0(finalTotal);
  if (normalizeSource || source !== "pv") pvInput.value = de0(finalPv);
  if (normalizeSource || source !== "battery") batteryInput.value = de0(finalBattery);
}

function switchBatteryPresetToCustom() {
  const presetField = $("batteryPreset");
  if (!presetField || presetField.value === "custom") return;
  presetField.value = "custom";
  state.batteryPreset = "custom";
}

function updateBatteryOutputVisibility() {
  const outputWrap = $("batteryOutputWrap");
  const output = $("batteryOutputPower");
  if (!outputWrap || !output) return;
  outputWrap.style.opacity = state.batteryPlugIn ? "0.7" : "1";
  if (state.batteryPlugIn) {
    output.value = "0.8";
    output.disabled = true;
  } else {
    output.disabled = false;
    output.value = String(state.batteryOutputKw);
  }
}
function commitBatteryConfigRender() {
  readInputsToState({ allowEvPrompt: false });
  updateBatteryPresetUi();
  updateBatteryOutputVisibility();
  updateInverterVisibility();
  saveLocal();
  requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] });
}
function addBatteryExtension() {
  switchBatteryPresetToCustom();
  state.batteryExtensionsEnabled = true;
  state.batteryExtensionMode = "individual";
  if (state.batteryExtensionModules.length >= BATTERY_EXTENSION_LIMIT) return;
  const previousValue = state.batteryExtensionModules.length
    ? state.batteryExtensionModules[state.batteryExtensionModules.length - 1]
    : (state.batteryBaseCapacityKwh || state.batteryExtensionCapacityKwh || 1);
  state.batteryExtensionModules.push(previousValue);
  normalizeBatteryConfig();
  syncInputs();
  saveLocal();
  requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] });
}
function removeBatteryExtension(index) {
  switchBatteryPresetToCustom();
  state.batteryExtensionModules.splice(index, 1);
  normalizeBatteryConfig();
  syncInputs();
  saveLocal();
  requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] });
}
function updateEvMode() {
  const panel = $("evPanel");
  const toggle = $("evToggle");
  const label = $("evLabel");
  const active = evEnabled();
  if (panel) panel.classList.toggle("open", active);
  if (toggle) toggle.classList.toggle("oce-open", active);
  if (label) label.textContent = active ? "An" : "Aus";
  updateEvScheduleUi();
  updateAnnualConsumptionUi();
}
function updateEvScheduleUi() {
  normalizeEvConfig();
  const weekly = state.evScheduleMode === "weekly";
  const wrap = $("evWeeklyDaysWrap");
  if (wrap) wrap.hidden = !weekly;
  const typical = $("evTypicalTime");
  const smartOption = typical?.querySelector('option[value="smart"]');
  if (smartOption) {
    smartOption.disabled = !state.smartMeterInstalled;
    smartOption.textContent = state.smartMeterInstalled ? "Smart (Solarstunden)" : "Smart (nur mit Smart Meter)";
  }
  if (typical && typical.value !== state.evTypicalTime) typical.value = state.evTypicalTime;
  const selected = sanitizeEvWeekdays(state.evWeeklyDays);
  document.querySelectorAll("#evWeekdays [data-evday]").forEach((button) => {
    const day = Number(button.dataset.evday);
    button.setAttribute("aria-pressed", selected.includes(day) ? "true" : "false");
  });
  const phaseWrap = $("evPhaseModeWrap");
  if (phaseWrap) phaseWrap.hidden = !evPhaseModeVisible();
  const phaseHint = $("evPhaseModeHint");
  if (phaseHint) {
    const smartFloor = evSmartChargeSurplusFloorKw();
    const capText = de(effectiveEvChargeSpeedKw(), 1);
    phaseHint.textContent = state.evPhaseMode === "single"
      ? `1‑phasig startet ab ca. ${de(EV_SINGLE_PHASE_MIN_KW, 2)} kW und begrenzt die Ladeleistung hier auf ${capText} kW.`
      : state.evPhaseMode === "three"
        ? `3‑phasig startet erst ab ca. ${de(EV_THREE_PHASE_MIN_KW, 2)} kW PV-Überschuss, nutzt dann aber bis zu ${capText} kW.`
        : `Smart Hybrid startet ab ca. ${de(smartFloor, 2)} kW 1‑phasig und schaltet ab ca. ${de(EV_THREE_PHASE_MIN_KW, 2)} kW auf 3 Phasen.`;
  }
  document.querySelectorAll("#evPhaseMode [data-evphase]").forEach((button) => {
    button.setAttribute("aria-pressed", button.dataset.evphase === state.evPhaseMode ? "true" : "false");
  });
}
function renderBatteryExtensionsUi() {
  normalizeBatteryConfig();
  const enabled = state.batteryExtensionsEnabled;
  const modules = batteryModuleCapacities();
  const totalKwh = sum(modules);
  const capacityLabel = $("batteryCapacityLabelText");
  const totalWrap = $("batteryCapacityTotalWrap");
  const totalInput = $("batteryCapacityTotal");
  const capacityRow = $("batteryCapacityRow");
  const socWindow = $("batterySocWindow");
  const extensionsToggle = $("batteryExtensionsEnabled");
  const extensionsPanel = $("batteryExtensionsPanel");
  const individualWrap = $("batteryExtensionsIndividualWrap");
  const summary = $("batteryExtensionSummary");
  const preview = $("batteryStackPreview");
  if (capacityLabel) capacityLabel.textContent = enabled ? "Kopfeinheit (kWh)" : "Speichergröße gesamt (kWh)";
  if (totalWrap) totalWrap.hidden = !enabled;
  if (capacityRow) capacityRow.style.gridTemplateColumns = enabled ? "1fr 1fr" : "1fr";
  if (totalInput) totalInput.value = deMax(totalKwh, 3);
  if (socWindow) socWindow.value = `${de0(Math.max(0, state.batterySocMaxPct - state.batterySocMinPct))}%`;
  if (extensionsToggle) extensionsToggle.checked = enabled;
  if (extensionsPanel) extensionsPanel.hidden = !enabled;
  if (individualWrap) individualWrap.hidden = !enabled;
  if (summary) summary.textContent = `${state.batteryExtensionCount}/${BATTERY_EXTENSION_LIMIT} Erweiterungen`;
  const list = $("batteryExtensionList");
  if (list) {
    if (!enabled) {
      list.innerHTML = "";
    } else {
      const baseItem = `
        <div class="oce-battery-extension-item">
          <label>Kopfeinheit (kWh)
            <input data-battery-base-input="true" type="text" inputmode="decimal" value="${escapeHtml(deMax(state.batteryBaseCapacityKwh, 3))}">
          </label>
          <span aria-hidden="true"></span>
        </div>
      `;
      const extensionItems = state.batteryExtensionModules.map((capacity, index) => `
        <div class="oce-battery-extension-item">
          <label>Erweiterung ${index + 1} (kWh)
            <input data-battery-extension-index="${index}" type="text" inputmode="decimal" value="${escapeHtml(deMax(capacity, 3))}">
          </label>
          <button class="oce-remove-link" type="button" data-battery-extension-remove="${index}" aria-label="Erweiterung löschen">
            <img class="oce-icon" src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/trash.svg" alt="" aria-hidden="true" draggable="false">
          </button>
        </div>
      `).join("");
      list.innerHTML = `${baseItem}${extensionItems}`;
    }
  }
  if (preview) {
    preview.style.setProperty("--battery-unit-height-base", totalKwh > 20 ? "0.5rem" : "");
    preview.innerHTML = modules.length
      ? modules.map((capacity, index) => `<div class="oce-battery-stack-module${index === 0 ? " is-main" : ""}" style="--module-kwh:${Math.max(0.1, capacity)}" data-kwh="${escapeHtml(deMax(capacity, 3))} kWh"></div>`).join("")
      : `<div class="oce-battery-stack-empty">Keine Batteriemodule konfiguriert.</div>`;
  }
}
function updateBatteryPresetUi() {
  const plugIn = $("batteryPlugIn");
  if (!plugIn) return;
  normalizeBatteryConfig();
  plugIn.checked = state.batteryPlugIn;
  setValue("batteryCapacity", state.batteryExtensionsEnabled ? deMax(state.batteryBaseCapacityKwh, 3) : deMax(state.batteryCapacityKwh, 3));
  setValue("batteryChargePower", state.batteryChargeKw);
  setValue("batteryDischargePower", state.batteryDischargeKw);
  setValue("batteryOutputPower", state.batteryOutputKw);
  setValue("batteryType", state.batteryType);
  setValue("batteryEfficiency", state.batteryEfficiencyPct);
  setValue("batterySocMin", state.batterySocMinPct);
  setValue("batterySocMax", state.batterySocMaxPct);
  renderBatteryExtensionsUi();
  updateBatteryOutputVisibility();
  updateInverterVisibility();
}
function updateLoadProfileHint() {
  const loadProfileValue = $("loadProfile")?.value || state.loadProfile;
  const hideProfile = loadProfileValue === "-";
  const hint = LOAD_PROFILE_HINTS[loadProfileValue] || "";
  if ($("loadProfileHint")) $("loadProfileHint").textContent = hideProfile ? "" : hint;
}
function applyBatteryPreset(key) {
  state.batteryPreset = key;
  if (key === "custom") {
    updateBatteryPresetUi();
    return;
  }
  const preset = BATTERY_PRESETS[key];
  if (!preset) return;
  state.batteryBaseCapacityKwh = preset.capacityKwh;
  state.batteryChargeKw = preset.chargeKw;
  state.batteryDischargeKw = preset.dischargeKw;
  state.batteryOutputKw = preset.outputKw;
  state.batteryType = preset.type || "all_in_one";
  state.batteryEfficiencyPct = preset.efficiencyPct;
  state.batteryPlugIn = preset.plugIn;
  normalizeBatteryConfig();
  updateBatteryPresetUi();
}
function openModal() { syncInputs(); ensureAreaEditorState(true); renderAreaEditor(); $("settingsModal").classList.add("open"); $("settingsModal").setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden"; }
function closeModal() {
  const modal = $("settingsModal");
  if (!modal?.classList.contains("open")) return;
  readInputsToState({ allowEvPrompt: false });
  updateSystemCostBreakdownUi({ normalizeSource: true });
  saveLocal();
  discardAreaEditorState();
  hideLocationSuggestions();
  modal.classList.remove("open");
  modal.setAttribute("aria-hidden", "true");
  document.body.style.overflow = "";
  requestRender(["all"], { invalidate: ["forecast", "annual", "energy", "finance", "charts"] });
  refresh();
}

async function searchLocation() {
  const q = $("locationName").value.trim();
  if (!q) return;
  $("locationStatus").textContent = "Standort wird gesucht …";
  try {
    const result = await remoteService.searchLocation(q);
    if (!result) { $("locationStatus").textContent = "Kein Standort gefunden. Eine genauere Eingabe von PLZ oder Stadt ist erforderlich."; return; }
    state.locationName = result.display_name.split(",").slice(0, 2).join(", ").trim();
    state.locationSource = "manual";
    state.lat = Number(Number(result.lat).toFixed(4));
    state.lon = Number(Number(result.lon).toFixed(4));
    state.countryHint = result.address?.country || "Deutschland";
    syncInputs();
    $("locationStatus").textContent = `${state.locationName} wurde übernommen.`;
    refresh();
  } catch (err) {
    $("locationStatus").textContent = "Standortsuche fehlgeschlagen: " + err.message;
  }
}

function hideLocationSuggestions() {
  const host = $("locationSuggestions");
  host.hidden = true;
  host.innerHTML = "";
}

async function fetchLocationSuggestions() {
  const q = $("locationName").value.trim();
  if (q.length < 2) { hideLocationSuggestions(); return; }
  try {
    const rows = await remoteService.fetchLocationSuggestions(q);
    const host = $("locationSuggestions");
    if (!rows?.length) { hideLocationSuggestions(); return; }
    host.hidden = false;
    host.innerHTML = rows.map((r, idx) => {
      const label = (r.display_name || "").split(",").slice(0, 3).join(", ").trim();
      return `<button type="button" class="oce-suggestion" data-suggest="${idx}">${escapeHtml(label)}</button>`;
    }).join("");
    host.querySelectorAll("[data-suggest]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const r = rows[Number(btn.dataset.suggest)];
        if (!r) return;
        state.locationName = (r.display_name || "").split(",").slice(0, 2).join(", ").trim();
        state.locationSource = "manual";
        state.lat = Number(Number(r.lat).toFixed(4));
        state.lon = Number(Number(r.lon).toFixed(4));
        state.countryHint = r.address?.country || "Deutschland";
        syncInputs();
        hideLocationSuggestions();
        $("locationStatus").textContent = `${state.locationName} wurde übernommen.`;
        refresh();
      });
    });
  } catch (err) {
    if (err.name !== "AbortError") hideLocationSuggestions();
  }
}

function angleHint(angle) {
  const a = Number(angle);
  if (a <= 3) return "0° = flach liegend, z.B. Tisch oder sehr flaches Dach.";
  if (a <= 14) return "Ca. 10° = Well‑ oder Blechdach / sehr flache Aufständerung.";
  if (a <= 24) return "Ca. 17° = typische Flachdach‑Aufständerung.";
  if (a <= 50) return "Ca. 35° = typisches Schrägdach und oft sehr effizient.";
  if (a >= 80) return "90° = Fassade oder Balkon senkrecht.";
  return `${a}° = mittlere bis steile Aufständerung.`;
}

function createAreaDraft(area, index) {
  return {
    name: String(area?.name || `Fläche ${index + 1}`),
    azimuth: localeNumber(area?.azimuth, 180),
    tilt: localeNumber(area?.tilt, 35),
    kwp: localeNumber(area?.kwp, 1),
    color: area?.color || COLORS[index % COLORS.length]
  };
}

function ensureAreaEditorState(force = false) {
  const needsReset = force || !Array.isArray(runtimeState.areaEditorDrafts) || runtimeState.areaEditorDrafts.length !== state.areas.length;
  if (needsReset) runtimeState.areaEditorDrafts = state.areas.map((area, index) => createAreaDraft(area, index));
  runtimeState.areaEditorDrafts = state.areas.map((area, index) => createAreaDraft(runtimeState.areaEditorDrafts[index] || area, index));
  if (!(runtimeState.areaEditorOpen instanceof Set) || force) runtimeState.areaEditorOpen = new Set();
  runtimeState.areaEditorOpen = new Set([...runtimeState.areaEditorOpen].filter((index) => index >= 0 && index < state.areas.length));
}

function discardAreaEditorState() {
  runtimeState.areaEditorDrafts = [];
  runtimeState.areaEditorOpen = new Set();
}

function areaDraftAt(index) {
  ensureAreaEditorState();
  if (!runtimeState.areaEditorDrafts[index]) runtimeState.areaEditorDrafts[index] = createAreaDraft(state.areas[index], index);
  return runtimeState.areaEditorDrafts[index];
}

function areaSummaryText(area) {
  const shadeLabel = state.inverterShadeLevel === "medium"
    ? "Mittlere Verschattung"
    : state.inverterShadeLevel === "strong"
      ? "Starke Verschattung"
      : "Leichte Verschattung";
  const shadeTag = state.inverterShadeEnabled ? ` · ${shadeLabel}` : "";
  return `${de(area.kwp, 2)} kWp · ${de0(area.azimuth)}° ${compassLabel(area.azimuth)} · ${de0(area.tilt)}° Neigung${shadeTag}`;
}

function renderAreaEditor() {
  const host = $("areaEditor");
  ensureAreaEditorState();
  ensureSeriesState();
  const showMpptWarning = state.inverterAdvancedEnabled && Number.isFinite(state.inverterMpptCount) && state.areas.length > state.inverterMpptCount;
  const mpptWarningHtml = showMpptWarning
    ? `<p class="oce-note">Hinweis: ${state.areas.length} Flächen konfiguriert, aber nur ${de0(state.inverterMpptCount)} MPPT angegeben.</p>`
    : "";
  $("areaCount").textContent = `${state.areas.length}/8`;
  $("addAreaBtn").disabled = state.areas.length >= 8;
  $("addAreaBtn").style.opacity = state.areas.length >= 8 ? "0.5" : "1";
  host.innerHTML = "";
  state.areas.forEach((a, i) => {
    const draft = areaDraftAt(i);
    const open = runtimeState.areaEditorOpen.has(i);
    const box = document.createElement("div");
    box.className = `oce-area-box${open ? " is-open" : " is-collapsed"}`;
    box.style.setProperty("--area-color", a.color);
    box.dataset.index = i;
    box.innerHTML = open ? `
      <div class="oce-area-title">
        <strong><span class="oce-panel" aria-hidden="true"></span> ${escapeHtml(draft.name || `Fläche ${i + 1}`)}</strong>
        <div class="oce-area-tools">
          <button class="oce-area-link oce-measure-btn" data-measure="${i}" type="button"><img class="oce-icon" src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/explore.svg" alt="" aria-hidden="true" draggable="false">Vor-Ort-Messung</button>
          ${state.areas.length > 1 ? `<button class="oce-area-link oce-remove-link" data-remove="${i}" type="button" aria-label="Fläche löschen"><img class="oce-icon" src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/trash.svg" alt="" aria-hidden="true" draggable="false"></button>` : ""}
        </div>
      </div>
      <div class="oce-inline">
        <label class="oce-area-label">Name
          <input data-i="${i}" data-k="name" value="${escapeHtml(draft.name)}">
        </label>
        <label class="oce-area-label">Leistung (kWp)
          <input data-i="${i}" data-k="kwp" type="text" inputmode="decimal" value="${draft.kwp}">
        </label>
      </div>
      ${mpptWarningHtml}
      <div class="oce-field-row">
        <label class="oce-area-axis-label">Ausrichtung (Azimut) <b class="azimuth-label">${draft.azimuth}° ${compassLabel(draft.azimuth)}</b></label>
      </div>
      <div class="oce-slider-row">
        <input data-i="${i}" data-k="azimuth" type="range" min="0" max="359" step="1" value="${draft.azimuth}" style="--area-color:${a.color}">
      </div>
      <div class="oce-slider-legend">
        <span>N 0°</span><span>E 90°</span><span>S 180°</span><span>W 270°</span><span>N 360°</span>
      </div>
      <label class="oce-area-axis-label">Neigung <b class="tilt-label">${draft.tilt}°</b></label>
      <div class="oce-slider-row">
        <input data-i="${i}" data-k="tilt" type="range" min="0" max="90" step="1" value="${draft.tilt}" style="--area-color:${a.color}">
      </div>
      <div class="oce-slider-legend oce-slider-legend-tilt">
        <span>0°</span><span>15°</span><span>30°</span><span>45°</span><span>60°</span><span>75°</span><span>90°</span>
      </div>
      <div class="oce-angle-help">${angleHint(draft.tilt)}</div>
      <div class="oce-area-save-row">
        <div class="oce-switch-row" style="margin:0">
          <label class="oce-switch">
            <input data-inverter-shade-enabled type="checkbox" ${state.inverterShadeEnabled === true ? "checked" : ""}>
            <span></span>
          </label>
          <span class="oce-toggle-label">Verschattung</span>
          <select data-inverter-shade-level ${state.inverterShadeEnabled ? "" : "hidden"}>
            <option value="light" ${state.inverterShadeLevel === "light" ? "selected" : ""}>Leichte Verschattung</option>
            <option value="medium" ${state.inverterShadeLevel === "medium" ? "selected" : ""}>Mittlere Verschattung</option>
            <option value="strong" ${state.inverterShadeLevel === "strong" ? "selected" : ""}>Starke Verschattung</option>
          </select>
        </div>
        <button class="oce-primary-btn oce-area-save-btn" data-save-area="${i}" type="button" aria-label="Fläche speichern">
          <span class="oce-area-save-icon" aria-hidden="true"></span>
          <span>Speichern</span>
        </button>
      </div>
    ` : `
      <div class="oce-area-title oce-area-title-collapsed">
        <strong><span class="oce-panel" aria-hidden="true"></span> ${escapeHtml(draft.name || `Fläche ${i + 1}`)}</strong>
        <div class="oce-area-tools">
          <button class="oce-area-link oce-area-icon-btn" data-edit-area="${i}" type="button" aria-label="Fläche bearbeiten"><img class="oce-icon" src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/edit.svg" alt="" aria-hidden="true" draggable="false"></button>
          ${state.areas.length > 1 ? `<button class="oce-area-link oce-remove-link" data-remove="${i}" type="button" aria-label="Fläche löschen"><img class="oce-icon" src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/trash.svg" alt="" aria-hidden="true" draggable="false"></button>` : ""}
        </div>
      </div>
      <div class="oce-area-summary">${escapeHtml(areaSummaryText(draft))}</div>
    `;
    host.appendChild(box);
  });
  host.querySelectorAll("input").forEach((inp) => { inp.addEventListener("input", handleAreaInput); inp.addEventListener("change", handleAreaInput); });
  host.querySelectorAll("[data-inverter-shade-level]").forEach((sel) => {
    sel.addEventListener("change", () => {
      readInputsToState({ allowEvPrompt: false });
      saveLocalDebounced();
      requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] });
      refresh();
    });
  });
  host.querySelectorAll("[data-inverter-shade-enabled]").forEach((toggle) => {
    toggle.addEventListener("change", () => {
      readInputsToState({ allowEvPrompt: false });
      renderAreaEditor();
      saveLocalDebounced();
      requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] });
      refresh();
    });
  });
  host.querySelectorAll("[data-remove]").forEach((btn) => { btn.addEventListener("click", (event) => { openRemoveAreaConfirm(Number(event.currentTarget.dataset.remove)); }); });
  host.querySelectorAll("[data-save-area]").forEach((btn) => { btn.addEventListener("click", (event) => { saveAreaDraft(Number(event.currentTarget.dataset.saveArea)); }); });
  host.querySelectorAll("[data-edit-area]").forEach((btn) => { btn.addEventListener("click", (event) => { toggleAreaEditor(Number(event.currentTarget.dataset.editArea), true); }); });
  host.onclick = (event) => {
    const measureBtn = event.target.closest("[data-measure]");
    if (measureBtn && host.contains(measureBtn)) {
      openMeasureModal(Number(measureBtn.dataset.measure));
    }
  };
}

function openRemoveAreaConfirm(index) {
  pendingAreaRemovalIndex = Number(index);
  const area = state.areas[pendingAreaRemovalIndex];
  $("removeAreaConfirmText").textContent = area?.name
    ? `„${area.name}“ wird aus den Modulflächen entfernt.`
    : "Diese Modulfläche wird entfernt.";
  $("removeAreaConfirm").classList.add("open");
  $("removeAreaConfirm").setAttribute("aria-hidden", "false");
}

function closeRemoveAreaConfirm() {
  pendingAreaRemovalIndex = null;
  $("removeAreaConfirm").classList.remove("open");
  $("removeAreaConfirm").setAttribute("aria-hidden", "true");
}

function confirmRemoveArea() {
  if (pendingAreaRemovalIndex == null) return;
  state.areas.splice(pendingAreaRemovalIndex, 1);
  ensureSeriesState();
  saveLocal();
  ensureAreaEditorState(true);
  renderAreaEditor();
  closeRemoveAreaConfirm();
  refresh();
}

function toggleAreaEditor(index, open) {
  ensureAreaEditorState();
  if (open) runtimeState.areaEditorOpen.add(index);
  else runtimeState.areaEditorOpen.delete(index);
  renderAreaEditor();
}

function saveAreaDraft(index) {
  const draft = areaDraftAt(index);
  state.areas[index] = { ...state.areas[index], ...draft, color: state.areas[index].color };
  runtimeState.areaEditorDrafts[index] = createAreaDraft(state.areas[index], index);
  runtimeState.areaEditorOpen.delete(index);
  saveLocal();
  renderAreaEditor();
  requestRender(["chipsOnly", "financeOnly", "chartOnly"], { invalidate: ["forecast", "annual", "energy", "finance", "charts"] });
  refresh();
}

function handleAreaInput(event) {
  const target = event.currentTarget;
  const i = Number(target.dataset.i);
  const k = target.dataset.k;
  const draft = areaDraftAt(i);
  if (k === "name") draft.name = target.value;
  if (k === "kwp") draft.kwp = localeNumber(target.value, 0.01);
  if (k === "azimuth") {
    draft.azimuth = localeNumber(target.value, 0);
    triggerMeasureHaptic("azimuth", draft.azimuth, "manual");
  }
  if (k === "tilt") {
    draft.tilt = localeNumber(target.value, 0);
    triggerMeasureHaptic("tilt", draft.tilt, "manual");
  }
  syncAreaBox(i);
}

function syncAreaBox(i) {
  const box = document.querySelector(`.oce-area-box[data-index="${i}"]`);
  if (!box) return;
  const a = areaDraftAt(i);
  box.querySelectorAll(`[data-i="${i}"][data-k="azimuth"]`).forEach((input) => input.value = a.azimuth);
  box.querySelectorAll(`[data-i="${i}"][data-k="tilt"]`).forEach((input) => input.value = a.tilt);
  const az = box.querySelector(".azimuth-label");
  const ti = box.querySelector(".tilt-label");
  const help = box.querySelector(".oce-angle-help");
  const title = box.querySelector(".oce-area-title strong");
  if (az) az.textContent = `${a.azimuth}° ${compassLabel(a.azimuth)}`;
  if (ti) ti.textContent = `${a.tilt}°`;
  if (help) help.textContent = angleHint(a.tilt);
  if (title) title.innerHTML = `<span class="oce-panel" aria-hidden="true"></span> ${escapeHtml(a.name || `Fläche ${i + 1}`)}`;
}

function solarMarkerAzimuthsForDay() {
  const day = forecast?.days?.[state.selectedDayIndex];
  const dateStr = day?.date || new Date().toISOString().slice(0, 10);
  const d = new Date(`${dateStr}T12:00:00`);
  const start = new Date(d.getFullYear(), 0, 0);
  const diff = d - start;
  const oneDay = 1000 * 60 * 60 * 24;
  const dayOfYear = Math.floor(diff / oneDay);
  const decl = 23.44 * Math.sin((2 * Math.PI / 365) * (dayOfYear - 81));
  const phi = state.lat * Math.PI / 180;
  const delta = decl * Math.PI / 180;
  const ratio = Math.max(-1, Math.min(1, Math.sin(delta) / Math.cos(phi)));
  const rise = Math.acos(ratio) * 180 / Math.PI;
  return { rise, set: 360 - rise };
}

function timezoneOffsetMinutes(timeZone, date = new Date()) {
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    }).formatToParts(date).reduce((acc, part) => {
      if (part.type !== "literal") acc[part.type] = part.value;
      return acc;
    }, {});
    const asUtc = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute), Number(parts.second));
    return (asUtc - date.getTime()) / 60000;
  } catch {
    return 0;
  }
}

function zonedParts(timeZone, date = new Date()) {
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone,
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false
    }).formatToParts(date).reduce((acc, part) => {
      if (part.type !== "literal") acc[part.type] = part.value;
      return acc;
    }, {});
    return {
      year: Number(parts.year),
      month: Number(parts.month),
      day: Number(parts.day),
      hour: Number(parts.hour),
      minute: Number(parts.minute),
      second: Number(parts.second)
    };
  } catch {
    return {
      year: date.getUTCFullYear(),
      month: date.getUTCMonth() + 1,
      day: date.getUTCDate(),
      hour: date.getUTCHours(),
      minute: date.getUTCMinutes(),
      second: date.getUTCSeconds()
    };
  }
}

function dayOfYear(year, month, day) {
  const start = Date.UTC(year, 0, 0);
  const current = Date.UTC(year, month - 1, day);
  return Math.floor((current - start) / 86400000);
}

function solarPositionForLocation(lat, lon, timeZone, date = new Date()) {
  const parts = zonedParts(timeZone, date);
  const offsetMinutes = timezoneOffsetMinutes(timeZone, date);
  const doy = dayOfYear(parts.year, parts.month, parts.day);
  const minutes = parts.hour * 60 + parts.minute + parts.second / 60;
  const gamma = (2 * Math.PI / 365) * (doy - 1 + ((minutes / 60) - 12) / 24);
  const equationOfTime = 229.18 * (
    0.000075 +
    0.001868 * Math.cos(gamma) -
    0.032077 * Math.sin(gamma) -
    0.014615 * Math.cos(2 * gamma) -
    0.040849 * Math.sin(2 * gamma)
  );
  const declination = 0.006918 -
    0.399912 * Math.cos(gamma) +
    0.070257 * Math.sin(gamma) -
    0.006758 * Math.cos(2 * gamma) +
    0.000907 * Math.sin(2 * gamma) -
    0.002697 * Math.cos(3 * gamma) +
    0.00148 * Math.sin(3 * gamma);
  const trueSolarMinutes = (minutes + equationOfTime + 4 * lon - offsetMinutes + 1440) % 1440;
  const hourAngle = trueSolarMinutes / 4 < 0 ? trueSolarMinutes / 4 + 180 : trueSolarMinutes / 4 - 180;
  const latRad = lat * Math.PI / 180;
  const haRad = hourAngle * Math.PI / 180;
  const zenith = Math.acos(
    Math.sin(latRad) * Math.sin(declination) +
    Math.cos(latRad) * Math.cos(declination) * Math.cos(haRad)
  );
  const elevation = 90 - (zenith * 180 / Math.PI);
  const azimuth = (Math.atan2(
    Math.sin(haRad),
    Math.cos(haRad) * Math.sin(latRad) - Math.tan(declination) * Math.cos(latRad)
  ) * 180 / Math.PI + 180 + 360) % 360;
  return { azimuth, elevation };
}

function openMeasureModal(index) {
  measurementSessionId += 1;
  const sessionId = measurementSessionId;
  measuringAreaIndex = index;
  measuredAzimuth = state.areas[index].azimuth;
  measuredTilt = state.areas[index].tilt;
  livePhoneHeading = null;
  liveCompassRotation = null;
  const markers = solarMarkerAzimuthsForDay();
  sunriseAzimuth = markers.rise;
  sunsetAzimuth = markers.set;
  const sun = solarPositionForLocation(state.lat, state.lon, state.tz);
  sunAzimuthNow = sun.azimuth;
  sunElevationNow = sun.elevation;
  measurementPhase = "manual";
  resetMeasureHaptics();
  $("measureStatus").textContent = "Live-Kompass wird aktiviert …";
  updateMeasurePreview();
  updateMeasurementUi();
  $("measureModal").classList.add("open");
  $("measureModal").setAttribute("aria-hidden", "false");
  activateLiveMode({ auto: true, sessionId });
}

function applyManualMeasureDefaults() {
  measuredAzimuth = 180;
  measuredTilt = 35;
}

function switchToManualMeasurement({ preserveCurrent = true } = {}) {
  stopMeasurementListeners();
  measurementPhase = "manual";
  if (!preserveCurrent || measuredAzimuth == null || measuredTilt == null) applyManualMeasureDefaults();
  resetMeasureHaptics();
  $("measureStatus").textContent = "Manueller Kompass aktiv. Die Ausrichtung kann direkt im Kreis gesetzt und die Neigung unten angepasst werden.";
  updateMeasurementUi();
  updateMeasurePreview();
}

function closeMeasureModal() {
  measurementSessionId += 1;
  stopMeasurementListeners();
  measurementPhase = "manual";
  updateMeasurementUi();
  $("measureModal").classList.remove("open");
  $("measureModal").setAttribute("aria-hidden", "true");
}

function resetLiveMeasurement() {
  if (measuringAreaIndex == null) return;
  measurementSessionId += 1;
  const sessionId = measurementSessionId;
  stopMeasurementListeners();
  measuredAzimuth = state.areas[measuringAreaIndex]?.azimuth ?? 180;
  measuredTilt = state.areas[measuringAreaIndex]?.tilt ?? 35;
  livePhoneHeading = null;
  liveCompassRotation = null;
  resetMeasureHaptics();
  $("measureStatus").textContent = "Live-Kompass wird zurückgesetzt …";
  updateMeasurementUi();
  updateMeasurePreview();
  activateLiveMode({ auto: true, sessionId });
}

function startMeasurement() {
  if (measurementPhase !== "live") return;
  stopMeasurementListeners();
  measurementPhase = "countdown";
  sensorActive = true;
  window.addEventListener("deviceorientation", handleOrientation, true);
  $("measureStatus").textContent = "Live-Messung läuft. Für stabile Werte sollte das Smartphone ruhig und flach auf der Fläche liegen.";
  updateMeasurementUi();
  measurementTimer = setTimeout(() => {
    stopMeasurementListeners();
    measurementPhase = "frozen";
    $("measureStatus").textContent = `Messung eingefroren: ${measuredAzimuth}° ${compassLabel(measuredAzimuth)} · ${measuredTilt}°`;
    updateMeasurementUi();
    updateMeasurePreview();
  }, 5000);
}

async function requestOrientationAccess() {
  try {
    if (typeof window === "undefined" || typeof window.DeviceOrientationEvent === "undefined") return false;
    if (typeof DeviceOrientationEvent !== "undefined" && typeof DeviceOrientationEvent.requestPermission === "function") {
      const permission = await DeviceOrientationEvent.requestPermission();
      if (permission !== "granted") return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}

async function activateLiveMode({ auto = false, sessionId = measurementSessionId } = {}) {
  const sensorReady = await requestOrientationAccess();
  if (sessionId !== measurementSessionId || !$("measureModal")?.classList.contains("open")) {
    stopMeasurementListeners();
    return false;
  }
  stopMeasurementListeners();
  if (!sensorReady) {
    if (auto) applyManualMeasureDefaults();
    measurementPhase = "manual";
    $("measureStatus").textContent = auto
      ? "Live-Sensor nicht verfügbar. Ausrichtung und Neigung können unten manuell eingestellt werden."
      : "Live konnte nicht aktiviert werden. Der manuelle Kompass ist verfügbar; eine erneute Aktivierung ist möglich.";
    updateMeasurementUi();
    updateMeasurePreview();
    return false;
  }
  measurementPhase = "live";
  livePhoneHeading = null;
  liveCompassRotation = null;
  resetMeasureHaptics();
  sensorActive = true;
  sensorHasData = false;
  window.addEventListener("deviceorientation", handleOrientation, true);
  sensorWarmupTimer = setTimeout(() => {
    if (measurementPhase !== "live" || sensorHasData) return;
    if (auto) applyManualMeasureDefaults();
    switchToManualMeasurement({ preserveCurrent: !auto });
    $("measureStatus").textContent = "Keine Sensordaten erkannt. Live wurde deaktiviert und der manuelle Modus geöffnet.";
  }, 500);
  $("measureStatus").textContent = "Live-Kompass aktiv. Über die kleine Mess-Taste lassen sich die Werte 5 Sekunden lang erfassen und anschließend einfrieren.";
  updateMeasurementUi();
  updateMeasurePreview();
  return true;
}

function stopMeasurementListeners() {
  sensorActive = false;
  window.removeEventListener("deviceorientation", handleOrientation, true);
  if (measurementTimer) clearTimeout(measurementTimer);
  if (sensorWarmupTimer) clearTimeout(sensorWarmupTimer);
  measurementTimer = null;
  sensorWarmupTimer = null;
  sensorHasData = false;
}

async function toggleLiveMeasurement() {
  if (measurementPhase === "manual" || measurementPhase === "frozen") {
    await activateLiveMode({ sessionId: measurementSessionId });
    return;
  }
  switchToManualMeasurement({ preserveCurrent: true });
}

function updateMeasurementUi() {
  const toggle = $("measureLiveToggle");
  const toggleState = $("measureLiveToggleState");
  const startBtn = $("startMeasure");
  const resetBtn = $("measureReset");
  const startIcon = $("measureActionIcon");
  const compass = $("measureCompass");
  const tiltStage = $("measureTiltStage");
  const tiltSlider = $("measureTiltDrag");
  const applyBtn = $("applyMeasure");
  const liveLike = measurementPhase === "live" || measurementPhase === "countdown" || measurementPhase === "frozen";
  if (toggle) toggle.setAttribute("aria-pressed", liveLike ? "true" : "false");
  if (toggleState) {
    toggleState.textContent = measurementPhase === "manual"
      ? "Manuell"
      : measurementPhase === "frozen"
        ? "Pausiert"
        : "Live";
  }
  if (startBtn) {
    startBtn.hidden = !liveLike;
    startBtn.disabled = measurementPhase === "countdown" || measurementPhase === "frozen";
    startBtn.classList.toggle("is-spinning", measurementPhase === "countdown");
    startBtn.setAttribute("aria-label",
      measurementPhase === "countdown"
        ? "Messung läuft"
        : measurementPhase === "frozen"
          ? "Messung eingefroren"
          : "Messung starten"
    );
  }
  if (resetBtn) {
    resetBtn.hidden = !liveLike;
    resetBtn.disabled = measurementPhase === "countdown";
  }
  if (startIcon) {
    startIcon.src = measurementPhase === "countdown"
      ? MEASURE_ICON_SPINNER
      : measurementPhase === "frozen"
        ? MEASURE_ICON_FROZEN
        : MEASURE_ICON_PLAY;
  }
  if (compass) compass.classList.toggle("is-sensor", liveLike);
  if (tiltStage) tiltStage.classList.toggle("is-manual", !liveLike);
  if (tiltSlider) tiltSlider.disabled = false;
  if (applyBtn) applyBtn.disabled = measurementPhase === "countdown";
}

function handleOrientation(event) {
  if (!sensorActive) return;
  if (!sensorHasData) {
    sensorHasData = true;
    if (sensorWarmupTimer) clearTimeout(sensorWarmupTimer);
    sensorWarmupTimer = null;
  }
  let heading = event.webkitCompassHeading;
  if (heading == null && event.alpha != null) heading = 360 - event.alpha;
  if (heading != null && Number.isFinite(heading)) {
    const normalizedHeading = normalizeCompassDegrees(heading);
    if (livePhoneHeading == null || !Number.isFinite(liveCompassRotation)) {
      liveCompassRotation = normalizedHeading;
    } else {
      let delta = normalizedHeading - livePhoneHeading;
      if (delta > 180) delta -= 360;
      if (delta < -180) delta += 360;
      liveCompassRotation += delta;
    }
    livePhoneHeading = normalizedHeading;
    measuredAzimuth = Math.round(normalizeCompassDegrees(normalizedHeading + 180));
    triggerMeasureHaptic("azimuth", measuredAzimuth, "live");
  }
  const beta = event.beta == null ? 0 : event.beta;
  const gamma = event.gamma == null ? 0 : event.gamma;
  const tilt = Math.atan(Math.sqrt(Math.tan(beta * Math.PI / 180) ** 2 + Math.tan(gamma * Math.PI / 180) ** 2)) * 180 / Math.PI;
  if (Number.isFinite(tilt)) {
    measuredTilt = Math.round(tilt);
    triggerMeasureHaptic("tilt", measuredTilt, "live");
  }
  updateMeasurePreview();
}

function setupCompassDrag() {
  const compass = $("measureCompass");
  if (!compass) return;
  const onMove = (event) => {
    if (!draggingCompass || measurementPhase !== "manual") return;
    const point = event.touches ? event.touches[0] : event;
    const rect = compass.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const dx = point.clientX - cx;
    const dy = point.clientY - cy;
    let angle = Math.atan2(dx, -dy) * 180 / Math.PI;
    angle = (angle + 360) % 360;
    measuredAzimuth = Math.round(angle);
    triggerMeasureHaptic("azimuth", measuredAzimuth, "manual");
    updateMeasurePreview();
  };
  const endDrag = () => {
    draggingCompass = false;
    window.removeEventListener("pointermove", onMove);
    window.removeEventListener("pointerup", endDrag);
    window.removeEventListener("touchmove", onMove);
    window.removeEventListener("touchend", endDrag);
  };
  const startDrag = (event) => {
    if (measurementPhase !== "manual") {
      switchToManualMeasurement({ preserveCurrent: true });
    }
    draggingCompass = true;
    onMove(event);
    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerup", endDrag);
    window.addEventListener("touchmove", onMove, { passive: false });
    window.addEventListener("touchend", endDrag);
  };
  compass.addEventListener("pointerdown", startDrag);
  compass.addEventListener("touchstart", startDrag, { passive: true });
}

function setupTiltDrag() {
  const stage = $("measureTiltStage");
  if (!stage) return;
  let startClientY = 0;
  let startTilt = 35;
  const eventPoint = (event) => {
    if (event.touches && event.touches[0]) return event.touches[0];
    if (event.changedTouches && event.changedTouches[0]) return event.changedTouches[0];
    return event;
  };
  const tiltFromDrag = (clientY) => {
    const rect = stage.getBoundingClientRect();
    const pixelsPerDegree = Math.max(1.6, rect.height / 90);
    const deltaDegrees = (startClientY - clientY) / pixelsPerDegree;
    measuredTilt = Math.round(clamp(startTilt + deltaDegrees, 0, 90));
    triggerMeasureHaptic("tilt", measuredTilt, "manual");
    updateMeasurePreview();
  };
  const tiltFromPointer = (event) => {
    const point = eventPoint(event);
    tiltFromDrag(point.clientY);
  };
  const onPointerMove = (event) => {
    if (!draggingTilt || measurementPhase !== "manual") return;
    if (event.cancelable) event.preventDefault();
    tiltFromPointer(event);
  };
  const endDrag = () => {
    draggingTilt = false;
    window.removeEventListener("mousemove", onPointerMove);
    window.removeEventListener("mouseup", endDrag);
    window.removeEventListener("touchmove", onPointerMove);
    window.removeEventListener("touchend", endDrag);
  };
  const startDrag = (event) => {
    if (measurementPhase !== "manual") {
      switchToManualMeasurement({ preserveCurrent: true });
    }
    if (event.cancelable) event.preventDefault();
    draggingTilt = true;
    const point = eventPoint(event);
    startClientY = point.clientY;
    startTilt = measuredTilt ?? 35;
    updateMeasurePreview();
    window.addEventListener("mousemove", onPointerMove);
    window.addEventListener("mouseup", endDrag);
    window.addEventListener("touchmove", onPointerMove, { passive: false });
    window.addEventListener("touchend", endDrag);
  };
  stage.addEventListener("mousedown", startDrag);
  stage.addEventListener("touchstart", startDrag, { passive: true });
}

function polarPosition(azimuth, radiusPercent) { const rad = azimuth * Math.PI / 180; return { x: 50 + radiusPercent * Math.sin(rad), y: 50 - radiusPercent * Math.cos(rad) }; }

function sunriseToSunsetArc(startAngle, endAngle) {
  return {
    start: startAngle,
    span: (endAngle - startAngle + 360) % 360
  };
}

function buildCompassRose() {
  const scale = $("measureCompassScale");
  if (!scale || scale.dataset.ready === "1") return;
  let html = "";
  for (let angle = 0; angle < 360; angle += 5) {
    const tickClass = angle % 30 === 0 ? "is-major" : angle % 10 === 0 ? "is-mid" : "is-minor";
    const tickRadius = angle % 30 === 0 ? 43.5 : angle % 10 === 0 ? 44.5 : 45.5;
    const tickPos = polarPosition(angle, tickRadius);
    html += `<div class="oce-compass-tick ${tickClass}" style="left:${tickPos.x}%;top:${tickPos.y}%;transform:translate(-50%, -50%) rotate(${angle}deg)"></div>`;
  }
  for (let angle = 0; angle < 360; angle += 30) {
    const labelPos = polarPosition(angle, 36.5);
    let label = String(angle);
    let cls = "oce-compass-label is-degree";
    let transform = "translate(-50%, -50%)";
    if (angle === 0) {
      label = "N";
      cls = "oce-compass-label is-cardinal is-north";
    } else if (angle === 90) {
      label = "O";
      cls = "oce-compass-label is-cardinal";
    } else if (angle === 180) {
      label = "S";
      cls = "oce-compass-label is-cardinal";
    } else if (angle === 270) {
      label = "W";
      cls = "oce-compass-label is-cardinal";
    } else {
      transform = `translate(-50%, -50%) rotate(${angle}deg)`;
    }
    html += `<div class="${cls}" style="left:${labelPos.x}%;top:${labelPos.y}%;transform:${transform}">${label}</div>`;
  }
  scale.innerHTML = html;
  scale.dataset.ready = "1";
}

function updateMeasurePreview() {
  $("measureAzimuth").textContent = `${measuredAzimuth ?? "–"}°`;
  $("measureAzimuthLabel").textContent = measuredAzimuth == null ? "Ausrichtung" : compassLabel(measuredAzimuth);
  $("measureTilt").textContent = `${measuredTilt ?? "–"}°`;
  $("measureTiltHelp").textContent = angleHint(measuredTilt ?? 0);
  setValue("measureTiltDrag", measuredTilt ?? 35);
  const handle = $("dragHandle");
  const rose = $("measureCompassRose");
  const sunWindow = $("measureSunWindow");
  const moduleFacing = $("measureModuleFacing");
  const tiltNeedle = $("measureTiltNeedle");
  const sun = $("sunPositionMarker");
  const rise = $("sunriseMarker");
  const set = $("sunsetMarker");
  if (measurementPhase !== "manual") {
    const sunNow = solarPositionForLocation(state.lat, state.lon, state.tz);
    sunAzimuthNow = sunNow.azimuth;
    sunElevationNow = sunNow.elevation;
  }
  const hPos = polarPosition(measuredAzimuth || 0, 31);
  handle.style.left = `${hPos.x}%`;
  handle.style.top = `${hPos.y}%`;
  if (rose) {
    const rotation = measurementPhase === "manual"
      ? 0
      : -(Number.isFinite(liveCompassRotation) ? (liveCompassRotation + 180) : 180);
    rose.style.transform = `rotate(${rotation}deg)`;
  }
  if (sunWindow) {
    const arc = sunriseToSunsetArc(sunriseAzimuth, sunsetAzimuth);
    sunWindow.style.setProperty("--sun-window-start", `${arc.start}`);
    sunWindow.style.setProperty("--sun-window-span", `${arc.span}`);
  }
  if (moduleFacing) {
    const moduleRotation = measurementPhase === "manual"
      ? (measuredAzimuth || 0)
      : 180;
    moduleFacing.style.transform = `translate(-50%, -100%) rotate(${moduleRotation}deg)`;
  }
  if (tiltNeedle) tiltNeedle.style.transform = `translateY(-50%) rotate(-${measuredTilt || 0}deg)`;
  if (sun) {
    const sunRadius = 48.5;
    const sunPos = polarPosition(sunAzimuthNow, sunRadius);
    sun.style.left = `${sunPos.x}%`;
    sun.style.top = `${sunPos.y}%`;
    sun.style.opacity = sunElevationNow > 0 ? "1" : "0.35";
  }
  const rPos = polarPosition(sunriseAzimuth, 44.5);
  rise.style.left = `${rPos.x}%`;
  rise.style.top = `${rPos.y}%`;
  rise.style.setProperty("--sun-marker-angle", `${sunriseAzimuth}deg`);
  const sPos = polarPosition(sunsetAzimuth, 44.5);
  set.style.left = `${sPos.x}%`;
  set.style.top = `${sPos.y}%`;
  set.style.setProperty("--sun-marker-angle", `${sunsetAzimuth}deg`);
}

function applyMeasurement() {
  if (measuringAreaIndex == null || measuredAzimuth == null || measuredTilt == null) return;
  state.areas[measuringAreaIndex].azimuth = measuredAzimuth;
  state.areas[measuringAreaIndex].tilt = measuredTilt;
  if (runtimeState.areaEditorDrafts[measuringAreaIndex]) {
    runtimeState.areaEditorDrafts[measuringAreaIndex].azimuth = measuredAzimuth;
    runtimeState.areaEditorDrafts[measuringAreaIndex].tilt = measuredTilt;
  }
  saveLocal();
  renderAreaEditor();
  closeMeasureModal();
  refresh();
}

async function refresh(options = {}) {
  readInputsToState();
  syncInputs();
  const includeForecast = options.includeForecast === true;
  if (!includeForecast && state.mainChartMode === "current") {
    state.mainChartMode = "yearly";
  }
  setStatus(includeForecast ? "Aktuelle Daten werden geladen …" : "Jahresdurchschnitt wird geladen …");
  if (includeForecast) {
    setCurrentForecastStatus("loading", "Daten werden geladen …");
    requestRender(["tabsOnly", "chartOnly", "financeOnly"]);
  } else {
    runtimeState.rawForecast = null;
    forecast = null;
    setCurrentForecastStatus("idle", "Aktuelle Erträge laden");
  }
  try {
    const areas = validAreas();
    if (!areas.length) throw new Error("Mindestens eine Fläche mit gültiger Leistung (> 0 kWp) ist erforderlich.");
    const annualRemote = await remoteService.refreshAnnualData(configState, areas);
    runtimeState.lastRefreshToken = annualRemote.requestId;
    runtimeState.rawAnnual = annualRemote.rawAnnual;
    if (includeForecast) {
      const forecastRemote = await remoteService.refreshForecastData(configState, areas);
      runtimeState.lastRefreshToken = forecastRemote.requestId;
      runtimeState.rawForecast = forecastRemote.rawForecast;
      setCurrentForecastStatus("ready", "");
    }
    runtimeState.refreshNonce += 1;
    invalidate(["remote", "forecast", "annual", "energy", "finance", "charts"]);
    const models = getDerivedModel();
    forecast = models.forecastModel;
    annual = models.annualModel;
    renderAll(true);
    setStatus(`${includeForecast ? "Aktuelle Daten" : "Jahresdurchschnitt"} aktualisiert: ${new Date().toLocaleString("de-DE", { dateStyle: "short", timeStyle: "short" })}`);
  } catch (err) {
    console.error(err);
    if (includeForecast) setCurrentForecastStatus("error", "Fehler beim Laden der aktuellen Daten");
    setStatus("Fehler beim Laden: " + err.message);
    requestRender(["tabsOnly", "chartOnly", "financeOnly"]);
  }
}

async function fetchForecast() {
  return buildForecastModel(runtimeState.rawForecast);
}

function groupByDay(time, energy, areaResults, base) {
  const by = {};
  time.forEach((t, idx) => {
    const d = t.slice(0, 10);
    if (!by[d]) by[d] = { date: d, idxs: [], energy: 0, areaEnergy: state.areas.map(() => 0) };
    by[d].idxs.push(idx);
    by[d].energy += energy[idx] || 0;
    areaResults.forEach((r, i) => by[d].areaEnergy[i] += r.energy[idx] || 0);
  });
  return Object.values(by).map((day) => {
    const dailyIndex = (base.daily.time || []).indexOf(day.date);
    day.sunshine = dailyIndex >= 0 ? (base.daily.sunshine_duration[dailyIndex] || 0) / 3600 : 0;
    day.sunrise = dailyIndex >= 0 ? base.daily.sunrise[dailyIndex] : null;
    day.sunset = dailyIndex >= 0 ? base.daily.sunset[dailyIndex] : null;
    return day;
  });
}

async function fetchAnnualForecast() {
  return buildAnnualModel(runtimeState.rawAnnual, forecast);
}

async function fetchPVGISAnnual() {
  if (runtimeState.rawAnnual?.error) throw new Error(runtimeState.rawAnnual.error);
  return runtimeState.rawAnnual;
}

function profileShares() {
  const arr = [...(LOAD_PROFILES[state.loadProfile] || LOAD_PROFILES.berufstaetig)];
  const s = Math.max(0.0001, sum(arr));
  return arr.map((v) => v / s);
}

function batteryFlowLimitWatts() {
  let limit = configuredBatteryOutputWatts();
  if (state.batteryMode && batteryTypeNormalized() !== "all_in_one") limit = Math.min(limit, configuredInverterLimitWatts());
  return limit;
}

function simulateEnergyFlow(idxs, pvPowerSeriesW, withBattery, rawPvSeriesW = pvPowerSeriesW, forecastContext = forecast) {
  if (!forecastContext) return normalizePowerFlow({ pv: 0, loadTotal: 0, direct: 0, battChargeIn: 0, battToLoad: 0, exportKwh: 0, gridImport: 0, totalValue: 0, soc: 0, cap: 0 });
  const cacheKey = `${runtimeState.invalidationVersion}|${withBattery ? 1 : 0}|${idxs.join(",")}`;
  if (runtimeState.flowCache?.has(cacheKey)) return runtimeState.flowCache.get(cacheKey);
  const { etaIn, etaOut } = batteryEfficiencyModel();
  const cap = Math.max(0.2, state.batteryCapacityKwh);
  const chargeLimitW = batteryChargeLimitWatts();
  const dischargeLimitW = batteryDischargeLimitWatts();
  const outputLimitW = batteryOutputLimitWatts();
  const inverterExportLimitW = inverterLimitWatts();
  const smartMeterFactor = state.smartMeterInstalled ? 1 : 0.55;
  const smartMeterChargeFactor = state.smartMeterInstalled ? 1 : 0.7;
  let soc = batteryInitialSocKwh(cap);
  let pvTotal = 0;
  let loadTotal = 0;
  let directUse = 0;
  let battChargeIn = 0;
  let battToLoad = 0;
  let exportKwh = 0;
  let gridImport = 0;
  let smartDayKey = "";
  let smartRemainingKwh = 0;
  const smartEnabled = evSmartModeActive();

  idxs.forEach((idx) => {
    const time = forecastContext.time[idx];
    const info = dateContext(time || new Date());
    const dayKey = info.dateIso;
    if (smartEnabled && dayKey !== smartDayKey) {
      smartDayKey = dayKey;
      smartRemainingKwh = evDailyEnergyTargetKwh(dayKey);
    }
    const loadSeries = totalLoadForDate(dayKey);
    const loadKwh = Math.max(0, Number(loadSeries[info.hour || 0] || 0));
    const rawPvW = Math.max(0, Number(rawPvSeriesW[idx] || pvPowerSeriesW[idx] || 0));
    const flow = applyBatteryHourFlow(rawPvW / 1000, loadKwh, soc, withBattery, cap, etaIn, etaOut, chargeLimitW, dischargeLimitW, outputLimitW, inverterExportLimitW, smartMeterFactor, smartMeterChargeFactor);
    soc = flow.soc;
    pvTotal += flow.harvestablePvKwh;
    loadTotal += loadKwh;
    directUse += flow.direct;
    battChargeIn += flow.battChargeIn;
    battToLoad += flow.battToLoad;
    let smartSurplus = Math.max(0, flow.exportKwh);
    if (smartEnabled && smartRemainingKwh > 0 && smartSurplus > 0) {
      const smartChargeKwh = evSmartChargeFromSurplus(smartSurplus, smartRemainingKwh);
      if (smartChargeKwh > 0) {
        smartRemainingKwh -= smartChargeKwh;
        loadTotal += smartChargeKwh;
        directUse += smartChargeKwh;
        smartSurplus -= smartChargeKwh;
      }
    }
    exportKwh += smartSurplus;
    gridImport += flow.gridImport;
  });
  const selfUsed = Math.max(0, loadTotal - gridImport);
  const result = normalizePowerFlow({ pv: pvTotal, loadTotal, direct: directUse, battChargeIn, battToLoad, exportKwh, gridImport, selfUsed, autarky: loadTotal > 0 ? (selfUsed / loadTotal) : 0, selfConsumption: pvTotal > 0 ? ((pvTotal - exportKwh) / pvTotal) : 0, totalValue: selfUsed * state.electricityPrice + exportKwh * activeFeedInTariff(), soc, cap });
  if (!runtimeState.flowCache) runtimeState.flowCache = new Map();
  runtimeState.flowCache.set(cacheKey, result);
  return result;
}

function simulateEnergyFlowDetailed(idxs, pvPowerSeriesW, withBattery, rawPvSeriesW = pvPowerSeriesW, forecastContext = forecast) {
  if (!forecastContext) return { labels: [], values: [], totalValue: 0 };
  const { etaIn, etaOut } = batteryEfficiencyModel();
  const cap = Math.max(0.2, state.batteryCapacityKwh);
  const chargeLimitW = batteryChargeLimitWatts();
  const dischargeLimitW = batteryDischargeLimitWatts();
  const outputLimitW = batteryOutputLimitWatts();
  const inverterExportLimitW = inverterLimitWatts();
  const smartMeterFactor = state.smartMeterInstalled ? 1 : 0.55;
  const smartMeterChargeFactor = state.smartMeterInstalled ? 1 : 0.7;
  const smartEnabled = evSmartModeActive();
  let soc = batteryInitialSocKwh(cap);
  let smartDayKey = "";
  let smartRemainingKwh = 0;
  const labels = [];
  const values = [];

  idxs.forEach((idx) => {
    const time = forecastContext.time[idx];
    const info = dateContext(time);
    if (smartEnabled && info.dateIso !== smartDayKey) {
      smartDayKey = info.dateIso;
      smartRemainingKwh = evDailyEnergyTargetKwh(info.dateIso);
    }
    const loadSeries = totalLoadForDate(info.dateIso);
    let loadKwh = Math.max(0, Number(loadSeries[info.hour || 0] || 0));
    const rawPvW = Math.max(0, Number(rawPvSeriesW[idx] || pvPowerSeriesW[idx] || 0));
    const flow = applyBatteryHourFlow(rawPvW / 1000, loadKwh, soc, withBattery, cap, etaIn, etaOut, chargeLimitW, dischargeLimitW, outputLimitW, inverterExportLimitW, smartMeterFactor, smartMeterChargeFactor);
    soc = flow.soc;
    let smartSurplus = Math.max(0, flow.exportKwh);
    let smartDirect = 0;
    if (smartEnabled && smartRemainingKwh > 0 && smartSurplus > 0) {
      const smartChargeKwh = evSmartChargeFromSurplus(smartSurplus, smartRemainingKwh);
      if (smartChargeKwh > 0) {
        smartRemainingKwh -= smartChargeKwh;
        loadKwh += smartChargeKwh;
        smartDirect = smartChargeKwh;
        smartSurplus -= smartChargeKwh;
      }
    }
    const selfUsed = Math.max(0, Math.min(loadKwh, loadKwh - flow.gridImport));
    labels.push(time.slice(11, 16));
    values.push((selfUsed * state.electricityPrice) + (smartSurplus * activeFeedInTariff()));
  });
  return { labels, values, totalValue: sum(values) };
}

function batteryMetrics() {
  return getDerivedModel().energyFlowModel?.batteryMetrics || null;
}

function financials() {
  return getDerivedModel().financeModel;
}

function renderAll(updateTabs) {
  ensureSeriesState();
  renderSystemSummary();
  renderChips();
  if (!forecast && !annual) { renderEmpty(); return; }
  if (updateTabs) {
    if (forecast?.days?.length) {
      state.selectedDayIndex = Math.min(state.selectedDayIndex, forecast.days.length - 1);
      if (forecast.days.length > 1 && state.selectedDayIndex === 0) state.selectedDayIndex = 1;
    }
  }
  renderDayTabs();
  renderTopSavings();
  renderSavingsForecast();
  renderCharts();
  renderFinance();
  renderHourStrip();
}

function renderEmpty() {
  ["dayTabs", "powerChart", "irradianceChart", "weekChart", "yearChart", "savingsYearsChart", "paybackChart", "financeKpis", "hourStrip", "savingsForecastChart", "batteryRuntimeChart", "evBestTimesChart", "evSavingsShiftChart", "evShiftDailyChart"].forEach((id) => $(id).innerHTML = "");
  if ($("batteryRuntimeCard")) $("batteryRuntimeCard").hidden = true;
}
function renderChips() {
  const combinedChip = `<button class="oce-chip" type="button" data-series="combined" aria-pressed="${activeSeries.combined}" style="--chip-color:${COMBINED_COLOR}"><i style="background:${COMBINED_COLOR}"></i>Kombiniert</button>`;
  const areaChips = state.areas.map((a, i) => `<button class="oce-chip" type="button" data-series="area-${i}" aria-pressed="${activeSeries.areas[i] !== false}" style="--chip-color:${a.color}"><i style="background:${a.color}"></i>${escapeHtml(a.name)} · ${a.kwp} kWp · ${a.azimuth}° ${compassLabel(a.azimuth)} · ${a.tilt}°</button>`).join("");
  $("areaChips").innerHTML = combinedChip + areaChips;
}

function toggleSeries(key) {
  ensureSeriesState();
  if (key === "combined") {
    const allAreasActive = activeSeries.areas.length > 0 && activeSeries.areas.every(Boolean);
    if (activeSeries.combined && !activeSeries.areas.some(Boolean)) {
      activeSeries.combined = true;
      activeSeries.areas = activeSeries.areas.map(() => true);
    } else if (activeSeries.combined && allAreasActive) {
      activeSeries.combined = false;
      activeSeries.areas = activeSeries.areas.map(() => true);
    } else {
      activeSeries.combined = true;
      activeSeries.areas = activeSeries.areas.map(() => false);
    }
  } else {
    const idx = Number(key.split("-")[1]);
    if (!Number.isFinite(idx)) return;
    if (activeSeries.combined) {
      activeSeries.combined = false;
      activeSeries.areas = activeSeries.areas.map((_, areaIndex) => areaIndex === idx);
    } else {
      const next = !activeSeries.areas[idx];
      activeSeries.areas[idx] = next;
      if (!activeSeries.areas.some(Boolean)) activeSeries.combined = true;
    }
  }
  saveLocal();
  requestRender(["chipsOnly", "chartOnly"]);
}

function renderDayTabs() {
  const host = $("dayTabs");
  if (!host) return;
  const show = state.mainChartMode === "current" && Boolean(forecast?.days?.length);
  host.hidden = !show;
  if (!show) {
    host.innerHTML = "";
    return;
  }
  const todayIso = zonedNowParts().isoDate;
  const yesterdayIso = addDaysIso(todayIso, -1);
  host.innerHTML = forecast.days.map((d, i) => {
    let label = weekdayLabelFromIsoDate(d.date);
    if (d.date === todayIso) label = "Heute";
    else if (d.date === yesterdayIso) label = "Gestern";
    return `<button class="oce-day ${i === state.selectedDayIndex ? "oce-active" : ""}" data-day="${i}" type="button"><div class="oce-day-label">${label}</div><div class="oce-day-meta">${de(d.energy, 1)} kWh</div></button>`;
  }).join("");
}

function chartInlineControlsMarkup(showLoadCurveBase) {
  const loadProfileOptions = $("loadProfile")?.innerHTML || "";
  const loadToggleClass = showLoadCurveBase && state.loadCurveVisible ? "" : " is-muted";
  const visibleAnnual = evEnabled() && state.evAddOnTop ? annualTotalConsumptionKwh() : annualHouseConsumptionKwh();
  return `<span class="oce-subline"><span class="oce-subline-group"><img class="oce-subline-icon" src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/energy-home.svg" alt="" aria-hidden="true" draggable="false"><span class="oce-subline-label">Jahresverbrauch</span><span class="oce-subline-input-wrap"><input id="chartAnnualConsumptionInput" class="oce-subline-input" type="text" inputmode="decimal" value="${escapeHtml(de0(visibleAnnual))}"><img class="oce-subline-input-icon" src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/edit.svg" alt="" aria-hidden="true" draggable="false"></span><span>kWh</span></span><span class="oce-subline-sep">·</span><span class="oce-subline-group"><img class="oce-subline-icon" src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/energy-adjustments.svg" alt="" aria-hidden="true" draggable="false"><button id="chartLoadProfileToggle" class="oce-subline-label oce-subline-label-toggle${loadToggleClass}" type="button" aria-pressed="${state.loadCurveVisible ? "true" : "false"}">Lastprofil</button><select id="chartLoadProfileSelect" class="oce-subline-select">${loadProfileOptions}</select></span></span>`;
}

function isoCalendarWeek(date = new Date()) {
  const value = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const day = value.getUTCDay() || 7;
  value.setUTCDate(value.getUTCDate() + 4 - day);
  const yearStart = new Date(Date.UTC(value.getUTCFullYear(), 0, 1));
  return Math.ceil((((value - yearStart) / 86400000) + 1) / 7);
}

function savingsTitleMarkup(label, meta) {
  return `${label} <span class="oce-tile-title-meta">${escapeHtml(meta)}</span>`;
}

function setSavingsTileTitles(today, week, month, year) {
  if ($("saveTodayTitle")) $("saveTodayTitle").innerHTML = today;
  if ($("saveWeekTitle")) $("saveWeekTitle").innerHTML = week;
  if ($("saveMonthTitle")) $("saveMonthTitle").innerHTML = month;
  if ($("saveYearTitle")) $("saveYearTitle").innerHTML = year;
}

function bindChartInlineControls() {
  const annualInput = $("chartAnnualConsumptionInput");
  if (annualInput) {
    const commitAnnualInput = () => {
      state.annualConsumptionEdited = true;
      const typed = Math.max(0, localeNumber(annualInput.value, annualInputConsumptionKwh() || DEFAULT_ANNUAL_CONSUMPTION_KWH));
      const settingsAnnual = $("annualConsumption");
      if (settingsAnnual) {
        settingsAnnual.value = de0(typed);
        settingsAnnual.dispatchEvent(new Event("input", { bubbles: true }));
        settingsAnnual.dispatchEvent(new Event("change", { bubbles: true }));
      } else {
        if (evEnabled() && state.evAddOnTop) {
          state.annualConsumptionHouseKwh = Math.max(0, typed - annualEvConsumptionKwh());
        } else {
          state.annualConsumptionHouseKwh = typed;
        }
        refreshAnnualConsumptionDerivedFields();
        normalizeAnnualConsumptionState();
        saveLocal();
        requestRender(["financeOnly", "chartOnly"], { invalidate: ["energy", "finance", "charts"] });
      }
    };
    annualInput.addEventListener("change", commitAnnualInput);
    annualInput.addEventListener("blur", commitAnnualInput);
  }
  const loadToggle = $("chartLoadProfileToggle");
  if (loadToggle) {
    loadToggle.addEventListener("click", () => {
      if (($("chartLoadProfileSelect")?.value || state.loadProfile) === "-") return;
      state.loadCurveVisible = !state.loadCurveVisible;
      saveLocal();
      renderCharts();
    });
  }
  const loadProfileSelect = $("chartLoadProfileSelect");
  if (loadProfileSelect) {
    loadProfileSelect.value = state.loadProfile;
    loadProfileSelect.addEventListener("change", () => {
      state.loadProfile = loadProfileSelect.value;
      setValue("loadProfile", state.loadProfile);
      updateLoadProfileHint();
      saveLocal();
      requestRender(["chartOnly", "financeOnly"], { invalidate: ["energy", "finance", "charts"] });
    });
  }
}

function renderEnergyFlowPanel() {
  const panel = $("energyFlowPanel");
  const host = $("energyFlow");
  if (!panel || !host) return;
  const visible = state.expertMode && state.showEnergyFlow;
  panel.hidden = !visible;
  if (!visible) {
    host.innerHTML = "";
    return;
  }
  const plugActive = state.plugSolarLimit || (usesBatteryIntegratedInverter() && state.batteryPlugIn);
  const inverterLabel = usesBatteryIntegratedInverter() ? "System" : "Wechselrichter";
  const inverterIcon = usesBatteryIntegratedInverter() ? "https://cdn.shopify.com/s/files/1/0868/2169/9918/files/battery.svg" : "https://cdn.shopify.com/s/files/1/0868/2169/9918/files/electric_meter.svg";
  const meterNode = state.smartMeterInstalled ? `<span class="oce-energyflow-line is-output"></span><span class="oce-energyflow-node"><img src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/electric_meter.svg" alt="" aria-hidden="true" draggable="false"><span>Smart Meter</span></span>` : "";
  const batteryRow = state.batteryMode ? `<div class="oce-energyflow-row"><span class="oce-energyflow-node"><img src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/battery.svg" alt="" aria-hidden="true" draggable="false"><span>Speicher <small>${escapeHtml(batteryTypeLabel())}</small></span></span><span class="oce-energyflow-line is-storage"></span><span class="oce-energyflow-node"><img src="${escapeHtml(inverterIcon)}" alt="" aria-hidden="true" draggable="false"><span>${escapeHtml(inverterLabel)}</span>${plugActive ? `<img class="oce-energyflow-node-plug" src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/plug.svg" alt="" aria-hidden="true" draggable="false">` : ""}</span></div>` : "";
  const evRow = state.evMode ? `<div class="oce-energyflow-row"><span class="oce-energyflow-node"><img src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/energy-home.svg" alt="" aria-hidden="true" draggable="false"><span>Haus</span></span><span class="oce-energyflow-line is-output"></span><span class="oce-energyflow-node"><img src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/electric_car.svg" alt="" aria-hidden="true" draggable="false"><span>Wallbox / EV</span></span></div>` : "";
  host.innerHTML = `<div class="oce-energyflow-row"><span class="oce-energyflow-node oce-energyflow-node-main"><img src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/Panels.svg" alt="" aria-hidden="true" draggable="false"><span>PV ${escapeHtml(de(totalKwp(), 2))} kWp</span></span><span class="oce-energyflow-line is-solar"></span><span class="oce-energyflow-node"><img src="${escapeHtml(inverterIcon)}" alt="" aria-hidden="true" draggable="false"><span>${escapeHtml(inverterLabel)} <small>${escapeHtml(de(activeSystemKw(), 1))} kW</small></span>${plugActive ? `<img class="oce-energyflow-node-plug" src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/plug.svg" alt="" aria-hidden="true" draggable="false">` : ""}</span>${meterNode}<span class="oce-energyflow-line is-output"></span><span class="oce-energyflow-node oce-energyflow-node-system"><img src="https://cdn.shopify.com/s/files/1/0868/2169/9918/files/energy-home.svg" alt="" aria-hidden="true" draggable="false"><span>Hausverbrauch</span></span></div>${batteryRow}${evRow}<div class="oce-energyflow-caption">Visualisierung des aktiven Systempfads. Farben: Solar = gelb, Versorgung = grün, Speicher = blau.</div>`;
}

function renderTopSavings() {
  const f = financials();
  const annualFlow = state.batteryMode ? f.battery?.annualFlow : f.baseline?.annualFlow;
  const currentMonth = zonedNowParts().month - 1;
  const nowLabel = new Intl.DateTimeFormat("de-DE", { month: "long", timeZone: state.tz || "Europe/Berlin" }).format(new Date());
  if (state.mainChartMode === "yearly") {
    normalizeYearlyChartMode();
    const dayModel = buildAverageDayChartData(state.yearlyChartMode);
    const dayValue = dayModel.flow.totalValue;
    const modeledDayFactorMonth = 365 / 12;
    const weekValue = dayValue * 7;
    const monthValue = Number(annualFlow?.monthly?.[currentMonth]?.totalValue || (dayValue * modeledDayFactorMonth));
    const weekKwh = dayModel.lossLimitedKwh * 7;
    const monthKwh = Number(annualFlow?.monthly?.[currentMonth]?.monthPv || (dayModel.lossLimitedKwh * modeledDayFactorMonth));
    const yearKwh = f.yearKwh;
    const yearValue = f.yearlyTotal;
    const seasonLabel = state.yearlyChartMode === "summer" ? "Sommer" : state.yearlyChartMode === "winter" ? "Winter" : null;
    const avgTagMeta = seasonLabel ? `Ø (${seasonLabel})` : "Ø";
    const avgWocheMeta = seasonLabel ? `Ø (${seasonLabel})` : "Ø";
    const avgMonatMeta = seasonLabel ? `Ø (${seasonLabel})` : "Ø";
    setSavingsTileTitles(
      savingsTitleMarkup("Ersparnis", avgTagMeta),
      savingsTitleMarkup("Ersparnis Woche", avgWocheMeta),
      savingsTitleMarkup("Ersparnis Monat", avgMonatMeta),
      savingsTitleMarkup("Ersparnis Jahr", "Ø")
    );
    $("saveToday").innerHTML = euroHtml(dayValue);
    $("saveWeek").innerHTML = euroHtml(weekValue);
    $("saveMonth").innerHTML = euroHtml(monthValue);
    $("saveYear").innerHTML = euroHtml(yearValue);
    $("energyToday").textContent = `${de(dayModel.lossLimitedKwh, 1)} kWh pro Tag`;
    $("energyWeek").textContent = `${de(weekKwh, 1)} kWh pro Woche`;
    $("energyMonth").textContent = `${de(monthKwh, 1)} kWh pro Monat`;
    $("energyYear").textContent = `${de(yearKwh, 1)} kWh pro Jahr`;
    return;
  }
  if (!forecast) {
    $("saveToday").innerHTML = euroHtml(0);
    $("saveWeek").innerHTML = euroHtml(0);
    $("saveMonth").innerHTML = euroHtml(Number(annualFlow?.monthly?.[currentMonth]?.totalValue || 0) || Number(f.monthlyTotal || 0));
    $("saveYear").innerHTML = euroHtml(Number(f.yearlyTotal || 0));
    $("energyToday").textContent = "Aktuelle Daten nicht geladen";
    $("energyWeek").textContent = "Aktuelle Daten nicht geladen";
    $("energyMonth").textContent = `${de(Number(annualFlow?.monthly?.[currentMonth]?.monthPv || f.monthKwh || 0), 1)} kWh`;
    $("energyYear").textContent = `${de(f.yearKwh, 1)} kWh`;
    return;
  }
  const todayDay = forecastCurrentDay(forecast?.days || []);
  const weekDays = forecastCurrentWeekDays(forecast?.days || []);
  const weekIdxs = weekDays.flatMap((d) => d.idxs || []);
  const selectedDayKwh = todayDay?.energy || 0;
  const selectedIdxs = todayDay?.idxs || [];
  const weekKwh = sum(weekDays.map((d) => d.energy || 0));
  const monthKwh = Number(annualFlow?.monthly?.[currentMonth]?.monthPv || f.monthKwh || 0) || (weekKwh * 4.345);
  const selectedDayValue = selectedIdxs.length
    ? simulateEnergyFlow(selectedIdxs, forecast.combinedPower, state.batteryMode, forecast.combinedDcPower).totalValue
    : 0;
  const weekValue = weekIdxs.length
    ? simulateEnergyFlow(weekIdxs, forecast.combinedPower, state.batteryMode, forecast.combinedDcPower).totalValue
    : 0;
  const monthValue = Number(annualFlow?.monthly?.[currentMonth]?.totalValue || 0) || (monthKwh * valuePerKwh());
  const yearValue = f.yearlyTotal;
  const todayIso = zonedNowParts().isoDate;
  setSavingsTileTitles(
    savingsTitleMarkup("Ersparnis", "Heute"),
    savingsTitleMarkup("Ersparnis Woche", `KW ${isoWeekNumberFromIsoDate(todayIso)}`),
    savingsTitleMarkup("Ersparnis Monat", nowLabel),
    savingsTitleMarkup("Ersparnis Jahr", String(zonedNowParts().year))
  );
  $("saveToday").innerHTML = euroHtml(selectedDayValue);
  $("saveWeek").innerHTML = euroHtml(weekValue);
  $("saveMonth").innerHTML = euroHtml(monthValue);
  $("saveYear").innerHTML = euroHtml(yearValue);
  $("energyToday").textContent = `${de(selectedDayKwh, 1)} kWh`;
  $("energyWeek").textContent = `${de(weekKwh, 1)} kWh`;
  $("energyMonth").textContent = `${de(monthKwh, 1)} kWh geschätzt`;
  $("energyYear").textContent = `${de(f.yearKwh, 1)} kWh`;
}

function renderSavingsForecast() {
  if (!forecast && !annual) return;
  $("forecastTabs").querySelectorAll("[data-forecast]").forEach((button) => {
    button.classList.toggle("oce-active", button.dataset.forecast === state.savingsForecastMode);
  });
  const f = financials();
  const annualFlow = state.batteryMode ? f.battery?.annualFlow : f.baseline?.annualFlow;
  const currentMonth = zonedNowParts().month - 1;
  let labels = [];
  let values = [];
  let kwhValues = [];
  const densify = (baseLabels, baseValues, subdivisions) => {
    if (subdivisions <= 1 || baseValues.length < 2) return { labels: baseLabels, values: baseValues };
    const outLabels = [];
    const outValues = [];
    for (let i = 0; i < baseValues.length - 1; i++) {
      const v0 = baseValues[i];
      const v1 = baseValues[i + 1];
      for (let s = 0; s < subdivisions; s++) {
        const ratio = s / subdivisions;
        outLabels.push(s === 0 ? baseLabels[i] : "·");
        outValues.push(v0 + (v1 - v0) * ratio);
      }
    }
    outLabels.push(baseLabels[baseLabels.length - 1]);
    outValues.push(baseValues[baseValues.length - 1]);
    return { labels: outLabels, values: outValues };
  };
  if (!forecast && (state.savingsForecastMode === "day" || state.savingsForecastMode === "week")) {
    $("forecastHeadline").textContent = runtimeState.currentForecastStatus === "loading" ? "Aktuelle Daten werden geladen …" : "Aktuelle Erträge laden, um Tages- und Wochenwerte anzuzeigen";
    $("savingsForecastChart").innerHTML = `<div class="oce-data-loading">${runtimeState.currentForecastStatus === "loading" ? `<div class="oce-data-loading-spinner" aria-hidden="true"></div>` : `<div class="oce-data-loading-icon" aria-hidden="true"></div>`}<div class="oce-data-loading-text">${escapeHtml(runtimeState.currentForecastStatus === "loading" ? "Daten werden geladen …" : "Aktuelle Erträge laden")}</div></div>`;
    return;
  }
  if (state.savingsForecastMode === "day") {
    const today = forecastCurrentDay(forecast.days);
    const valueDetail = simulateEnergyFlowDetailed(today.idxs, forecast.combinedPower, state.batteryMode, forecast.combinedDcPower);
    const quarterValues = interpolateQuarterData(today.idxs, [forecast.combinedPower, valueDetail.values]);
    labels = quarterValues.labels;
    kwhValues = quarterValues.series[0].map((w) => (w * 0.25 / 1000));
    values = quarterValues.series[1];
    const l = lossFromIdxs(today.idxs);
    $("forecastHeadline").textContent = state.inverterLimitEnabled ? `${de(sum(values), 2)} EUR heute · Verlust ${de(l.loss, 2)} kWh (${de(l.pct, 1)}%)` : `${de(sum(values), 2)} EUR heute`;
  } else if (state.savingsForecastMode === "week") {
    const weekDays = forecastCurrentWeekDays(forecast.days);
    labels = weekDays.map((d) => weekdayLabelFromIsoDate(d.date));
    kwhValues = weekDays.map((d) => d.energy);
    values = weekDays.map((day) => simulateEnergyFlow(day.idxs, forecast.combinedPower, state.batteryMode, forecast.combinedDcPower).totalValue);
    const l = lossFromIdxs(weekDays.flatMap((d) => d.idxs));
    $("forecastHeadline").textContent = state.inverterLimitEnabled ? `${de(sum(values), 2)} EUR diese Woche · Verlust ${de(l.loss, 2)} kWh (${de(l.pct, 1)}%)` : `${de(sum(values), 2)} EUR diese Woche`;
  } else if (state.savingsForecastMode === "month") {
    const todayParts = zonedNowParts();
    const monthDays = new Date(todayParts.year, todayParts.month, 0).getDate();
    const monthTotal = Number(annualFlow?.monthly?.[currentMonth]?.totalValue || 0) || ((annual ? annual.monthly[currentMonth] : f.monthKwh) * valuePerKwh());
    const shape = Array.from({ length: monthDays }, (_, idx) => 0.45 + 0.55 * Math.sin((idx / Math.max(1, monthDays - 1)) * Math.PI) ** 1.4);
    const shapedSum = sum(shape);
    labels = Array.from({ length: monthDays }, (_, i) => String(i + 1));
    values = shape.map((w) => monthTotal * (w / shapedSum));
    const monthKwh = Number(annualFlow?.monthly?.[currentMonth]?.monthPv || 0) || ((annual ? annual.monthly[currentMonth] : f.monthKwh) || 0);
    kwhValues = shape.map((w) => monthKwh * (w / shapedSum));
    const weekLoss = lossFromIdxs(forecastCurrentWeekDays(forecast.days).flatMap((d) => d.idxs));
    const ratio = weekLoss.raw > 0 ? weekLoss.loss / weekLoss.raw : 0;
    const estMonthLoss = ((annual ? annual.monthly[currentMonth] : f.monthKwh) || 0) * ratio;
    $("forecastHeadline").textContent = state.inverterLimitEnabled ? `${de(sum(values), 2)} EUR diesen Monat · Verlust geschätzt ${de(estMonthLoss, 2)} kWh` : `${de(sum(values), 2)} EUR diesen Monat`;
  } else {
    labels = MONTH_LABELS;
    kwhValues = annualFlow?.monthly?.map((month) => month.monthPv) || (annual ? annual.monthly : MONTH_WEIGHTS_DE.map((w) => f.yearKwh * w));
    values = annualFlow?.monthly?.map((month) => month.totalValue) || kwhValues.map((kwh) => kwh * valuePerKwh());
    const weekLoss = lossFromIdxs(forecastCurrentWeekDays(forecast.days).flatMap((d) => d.idxs));
    const ratio = weekLoss.raw > 0 ? weekLoss.loss / weekLoss.raw : 0;
    const estYearLoss = ((annual ? annual.yearly : f.yearKwh) || 0) * ratio;
    $("forecastHeadline").textContent = state.inverterLimitEnabled ? `${de(sum(values), 2)} EUR dieses Jahr · Verlust geschätzt ${de0(estYearLoss)} kWh` : `${de(sum(values), 2)} EUR dieses Jahr`;
  }
  forecastBars($("savingsForecastChart"), labels, values, state.savingsForecastMode, { kwhValues });
}

function chartWindowIndexes(day) {
  if (!day.sunrise || !day.sunset) return day.idxs;
  const riseHour = Number(day.sunrise.slice(11, 13));
  const setHour = Number(day.sunset.slice(11, 13)) + (Number(day.sunset.slice(14, 16)) > 0 ? 1 : 0);
  const start = Math.max(0, riseHour - 1);
  const end = Math.min(23, setHour + 1);
  return day.idxs.filter((i) => { const h = Number(forecast.time[i].slice(11, 13)); return h >= start && h <= end; });
}
function shortTime(iso) { return iso ? iso.slice(11, 16) : "–"; }
function hmFromDate(d) { return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`; }
function lossFromIdxs(idxs) {
  const raw = sum(idxs.map((i) => (forecast?.combinedDcPower?.[i] || 0) / 1000));
  const limited = sum(idxs.map((i) => (forecast?.combinedPower?.[i] || 0) / 1000));
  const loss = Math.max(0, raw - limited);
  const pct = raw > 0 ? (loss / raw) * 100 : 0;
  return { raw, limited, loss, pct };
}
function interpolateQuarterData(idxs, hourlySeriesArrays, extendTail = true) {
  const labels = [];
  const series = hourlySeriesArrays.map(() => []);
  if (!idxs.length) return { labels, series };
  for (let i = 0; i < idxs.length - 1; i++) {
    const i0 = idxs[i];
    const i1 = idxs[i + 1];
    const t0 = new Date(forecast.time[i0]);
    const t1 = new Date(forecast.time[i1]);
    labels.push(hmFromDate(t0));
    series.forEach((arr, sIdx) => arr.push(hourlySeriesArrays[sIdx][i0] || 0));
    for (let step = 1; step < 4; step++) {
      const t = new Date(t0.getTime() + step * 15 * 60 * 1000);
      if (t >= t1) break;
      const ratio = (t.getTime() - t0.getTime()) / Math.max(1, t1.getTime() - t0.getTime());
      labels.push(hmFromDate(t));
      series.forEach((arr, sIdx) => {
        const v0 = hourlySeriesArrays[sIdx][i0] || 0;
        const v1 = hourlySeriesArrays[sIdx][i1] || 0;
        arr.push(v0 + (v1 - v0) * ratio);
      });
    }
  }
  const lastIdx = idxs[idxs.length - 1];
  labels.push(forecast.time[lastIdx].slice(11, 16));
  series.forEach((arr, sIdx) => arr.push(hourlySeriesArrays[sIdx][lastIdx] || 0));
  if (extendTail) {
    const lastTime = new Date(forecast.time[lastIdx]);
    for (let step = 1; step <= 3; step++) {
      const t = new Date(lastTime.getTime() + step * 15 * 60 * 1000);
      labels.push(hmFromDate(t));
      series.forEach((arr) => arr.push(arr[arr.length - 1] || 0));
    }
  }
  if (labels[labels.length - 1] !== "24:00") {
    labels.push("24:00");
    series.forEach((arr) => arr.push(arr[arr.length - 1] || 0));
  }
  return { labels, series };
}

function interpolateHalfHourData(idxs, hourlySeriesArrays) {
  const labels = [];
  const series = hourlySeriesArrays.map(() => []);
  if (!idxs.length) return { labels, series };
  for (let i = 0; i < idxs.length - 1; i++) {
    const i0 = idxs[i];
    const i1 = idxs[i + 1];
    const t0 = new Date(forecast.time[i0]);
    const t1 = new Date(forecast.time[i1]);
    labels.push(hmFromDate(t0));
    series.forEach((arr, sIdx) => arr.push(hourlySeriesArrays[sIdx][i0] || 0));
    const tHalf = new Date(t0.getTime() + 30 * 60 * 1000);
    if (tHalf < t1) {
      const ratio = (tHalf.getTime() - t0.getTime()) / Math.max(1, t1.getTime() - t0.getTime());
      labels.push(hmFromDate(tHalf));
      series.forEach((arr, sIdx) => {
        const v0 = hourlySeriesArrays[sIdx][i0] || 0;
        const v1 = hourlySeriesArrays[sIdx][i1] || 0;
        arr.push(v0 + (v1 - v0) * ratio);
      });
    }
  }
  const lastIdx = idxs[idxs.length - 1];
  labels.push(forecast.time[lastIdx].slice(11, 16));
  series.forEach((arr, sIdx) => arr.push(hourlySeriesArrays[sIdx][lastIdx] || 0));
  if (labels[labels.length - 1] === "23:00") {
    labels.push("23:30");
    series.forEach((arr) => arr.push(arr[arr.length - 1] || 0));
  }
  if (labels[labels.length - 1] !== "24:00") {
    labels.push("24:00");
    series.forEach((arr) => arr.push(arr[arr.length - 1] || 0));
  }
  return { labels, series };
}

function interpolateHalfHourSeries(hourlySeriesArrays) {
  const labels = [];
  const series = hourlySeriesArrays.map(() => []);
  if (!hourlySeriesArrays.length) return { labels, series };
  const len = Math.max(0, hourlySeriesArrays[0]?.length || 0);
  if (len === 0) return { labels, series };
  for (let i = 0; i < len - 1; i++) {
    labels.push(`${String(i).padStart(2, "0")}:00`);
    series.forEach((arr, sIdx) => arr.push(Number(hourlySeriesArrays[sIdx][i] || 0)));
    labels.push(`${String(i).padStart(2, "0")}:30`);
    series.forEach((arr, sIdx) => {
      const v0 = Number(hourlySeriesArrays[sIdx][i] || 0);
      const v1 = Number(hourlySeriesArrays[sIdx][i + 1] || 0);
      arr.push(v0 + (v1 - v0) * 0.5);
    });
  }
  const lastIdx = len - 1;
  labels.push(`${String(lastIdx).padStart(2, "0")}:00`);
  series.forEach((arr, sIdx) => arr.push(Number(hourlySeriesArrays[sIdx][lastIdx] || 0)));
  if (lastIdx === 23) {
    labels.push("23:30");
    series.forEach((arr) => arr.push(arr[arr.length - 1] || 0));
  }
  if (labels[labels.length - 1] !== "24:00") {
    labels.push("24:00");
    series.forEach((arr) => arr.push(arr[arr.length - 1] || 0));
  }
  return { labels, series };
}

function hourlyAverageFromForecastSeries(series) {
  const buckets = Array.from({ length: 24 }, () => []);
  forecast.time.forEach((time, idx) => {
    const hour = Number((time || "00:00").slice(11, 13));
    if (!Number.isFinite(hour) || hour < 0 || hour > 23) return;
    buckets[hour].push(Math.max(0, Number(series[idx] || 0)));
  });
  return buckets.map((bucket) => bucket.length ? sum(bucket) / bucket.length : 0);
}

function averageDailyLoadSeriesKwh() {
  const totals = Array(24).fill(0);
  const year = new Date().getFullYear();
  let days = 0;
  for (let date = new Date(year, 0, 1); date.getFullYear() === year; date.setDate(date.getDate() + 1)) {
    const load = totalLoadForDate(new Date(date));
    for (let hour = 0; hour < 24; hour++) totals[hour] += Math.max(0, Number(load[hour] || 0));
    days += 1;
  }
  return totals.map((value) => value / Math.max(1, days));
}

function simulateAverageEnergyFlow(pvPowerSeriesW, loadSeriesKwh, withBattery) {
  const { etaIn, etaOut } = batteryEfficiencyModel();
  const cap = Math.max(0.2, state.batteryCapacityKwh);
  const chargeLimitW = batteryChargeLimitWatts();
  const dischargeLimitW = batteryDischargeLimitWatts();
  const outputLimitW = batteryOutputLimitWatts();
  const exportLimitW = inverterLimitWatts();
  const smartMeterFactor = state.smartMeterInstalled ? 1 : 0.55;
  const smartMeterChargeFactor = state.smartMeterInstalled ? 1 : 0.7;
  const initialSoc = batteryInitialSocKwh(cap);
  let soc = initialSoc;
  let pvTotal = 0;
  let loadTotal = 0;
  let directUse = 0;
  let battChargeIn = 0;
  let battToLoad = 0;
  let exportKwh = 0;
  let gridImport = 0;

  for (let hour = 0; hour < 24; hour++) {
    const loadKwh = Math.max(0, Number(loadSeriesKwh[hour] || 0));
    const rawPvKwh = Math.max(0, Number(pvPowerSeriesW[hour] || 0)) / 1000;
    const flow = applyBatteryHourFlow(rawPvKwh, loadKwh, soc, withBattery, cap, etaIn, etaOut, chargeLimitW, dischargeLimitW, outputLimitW, exportLimitW, smartMeterFactor, smartMeterChargeFactor);
    soc = flow.soc;
    pvTotal += flow.harvestablePvKwh;
    loadTotal += loadKwh;
    directUse += flow.direct;
    battChargeIn += flow.battChargeIn;
    battToLoad += flow.battToLoad;
    exportKwh += flow.exportKwh;
    gridImport += flow.gridImport;
  }
  if (withBattery) {
    const socDelta = soc - initialSoc;
    if (socDelta > 0) {
      exportKwh += socDelta / Math.max(0.0001, etaIn);
    } else if (socDelta < 0) {
      gridImport += (-socDelta) * etaOut;
    }
  }
  const totalValue = Math.max(0, loadTotal - gridImport) * state.electricityPrice + exportKwh * activeFeedInTariff();
  return normalizePowerFlow({ pv: pvTotal, loadTotal, direct: directUse, battChargeIn, battToLoad, exportKwh, gridImport, totalValue, soc, cap });
}

function buildAverageDayChartData(mode = "average") {
  if (!annual) return null;
  const labels = Array.from({ length: 24 }, (_, hour) => `${String(hour).padStart(2, "0")}:00`);
  const totalAreaKwp = Math.max(totalKwp(), 0.01);
  const summerMonths = [3, 4, 5, 6, 7, 8, 9]; // April-Oktober
  const winterMonths = [10, 11, 0, 1, 2]; // November-Maerz
  const seasonalDailyTotal = (monthIndexes) => {
    const totalKwh = sum(monthIndexes.map((m) => annual.monthly[m] || 0));
    const totalDays = sum(monthIndexes.map((m) => DAYS_IN_MONTH_DE[m] || 0));
    return totalDays > 0 ? (totalKwh / totalDays) : 0;
  };
  const seasonalAreaDailyTotal = (monthIndexes, areaIndex) => {
    const areaMonthly = annual.areaMonthly?.[areaIndex];
    if (!Array.isArray(areaMonthly)) return null;
    const totalKwh = sum(monthIndexes.map((m) => areaMonthly[m] || 0));
    const totalDays = sum(monthIndexes.map((m) => DAYS_IN_MONTH_DE[m] || 0));
    return totalDays > 0 ? (totalKwh / totalDays) : 0;
  };
  const targetDailyTotal = mode === "summer"
    ? seasonalDailyTotal(summerMonths)
    : mode === "winter"
      ? seasonalDailyTotal(winterMonths)
      : annual.yearly / 365;
  const targetAreaDailyKwh = state.areas.map((area, areaIndex) => {
    const directAreaTotal = mode === "summer"
      ? seasonalAreaDailyTotal(summerMonths, areaIndex)
      : mode === "winter"
        ? seasonalAreaDailyTotal(winterMonths, areaIndex)
        : (annual.areaMonthly?.[areaIndex] ? sum(annual.areaMonthly[areaIndex]) / 365 : null);
    return Number.isFinite(directAreaTotal) ? directAreaTotal : (targetDailyTotal * (area.kwp / totalAreaKwp));
  });
  const monthsForMode = mode === "summer" ? summerMonths : mode === "winter" ? winterMonths : MONTH_LABELS.map((_, index) => index);
  const totalDaysForMode = Math.max(1, sum(monthsForMode.map((monthIndex) => DAYS_IN_MONTH_DE[monthIndex] || 0)));
  const scaledRawByArea = targetAreaDailyKwh.map((_, areaIdx) => {
    const hourlyEnergy = Array(24).fill(0);
    monthsForMode.forEach((monthIndex) => {
      const days = DAYS_IN_MONTH_DE[monthIndex] || 0;
      const dailyShape = areaDailyPvShape(new Date(Date.UTC(2024, monthIndex, 15)), state.areas[areaIdx]);
      const areaMonthlyKwh = annual.areaMonthly?.[areaIdx]?.[monthIndex];
      const dailyTotalKwh = Number.isFinite(areaMonthlyKwh)
        ? (areaMonthlyKwh / Math.max(1, days))
        : targetAreaDailyKwh[areaIdx];
      dailyShape.forEach((share, hour) => {
        hourlyEnergy[hour] += share * dailyTotalKwh * days;
      });
    });
    return hourlyEnergy.map((value) => (value / totalDaysForMode) * 1000);
  });
  const rawCombined = labels.map((_, hour) => sum(scaledRawByArea.map((series) => series[hour] || 0)));
  const physicalCapW = inverterLimitWatts() + batteryChargeHeadroomWatts();
  const limitedCombined = rawCombined.map((value) => Math.min(value, physicalCapW));
  const limitedRatio = rawCombined.map((value, hour) => value > 0 ? limitedCombined[hour] / value : 1);
  const limitedByArea = scaledRawByArea.map((series) => series.map((value, hour) => value * limitedRatio[hour]));
  const loadSeriesKwh = averageDailyLoadSeriesKwh();
  const loadSeriesW = loadSeriesKwh.map((value) => value * 1000);
  const flow = simulateAverageEnergyFlow(limitedCombined, loadSeriesKwh, state.batteryMode);
  const lossRawKwh = sum(rawCombined) / 1000;
  const lossLimitedKwh = sum(limitedCombined) / 1000;
  const lossKwh = Math.max(0, lossRawKwh - lossLimitedKwh);
  const lossPct = lossRawKwh > 0 ? (lossKwh / lossRawKwh) * 100 : 0;
  return {
    labels,
    rawCombined,
    rawByArea: scaledRawByArea,
    limitedCombined,
    limitedByArea,
    loadSeriesW,
    flow,
    lossLimitedKwh,
    lossKwh,
    lossPct,
    pvCoverPct: flow.loadTotal > 0 ? Math.min(100, (flow.pvTotal / flow.loadTotal) * 100) : 0,
    mode
  };
}

function batterySupportSeries(idxs, pvPowerSeriesW, rawPvSeriesW = pvPowerSeriesW) {
  const { etaIn, etaOut } = batteryEfficiencyModel();
  const cap = Math.max(0.2, state.batteryCapacityKwh);
  const chargeLimitW = batteryChargeLimitWatts();
  const dischargeLimitW = batteryDischargeLimitWatts();
  const outputLimitW = batteryOutputLimitWatts();
  const smartMeterFactor = state.smartMeterInstalled ? 1 : 0.55;
  const smartMeterChargeFactor = state.smartMeterInstalled ? 1 : 0.7;
  let soc = batteryInitialSocKwh(cap);
  const socPctByIdx = [];
  const autarkyPctByIdx = [];
  const loadWByIdx = [];
  const servedWByIdx = [];
  const dischargeWByIdx = [];
  const chargeWByIdx = [];
  const chargeStoredWByIdx = [];
  const exportWByIdx = [];
  const socPctValues = [];
  const autarkyPctValues = [];
  const smartEnabled = evSmartModeActive();
  let smartDayKey = "";
  let smartRemainingKwh = 0;

  idxs.forEach((idx) => {
    const time = forecast.time[idx];
    const info = dateContext(time || new Date());
    const dayKey = info.dateIso;
    if (smartEnabled && dayKey !== smartDayKey) {
      smartDayKey = dayKey;
      smartRemainingKwh = evDailyEnergyTargetKwh(dayKey);
    }
    let loadKwh = Math.max(0, Number(totalLoadForDate(dayKey)[info.hour || 0] || 0));
    let smartDirect = 0;
    const rawPvKwh = Math.max(0, Number(rawPvSeriesW[idx] || pvPowerSeriesW[idx] || 0)) / 1000;
    const flow = applyBatteryHourFlow(rawPvKwh, loadKwh, soc, true, cap, etaIn, etaOut, chargeLimitW, dischargeLimitW, outputLimitW, inverterLimitWatts(), smartMeterFactor, smartMeterChargeFactor);
    soc = flow.soc;
    let smartSurplus = Math.max(0, flow.exportKwh);
    if (smartEnabled && smartRemainingKwh > 0 && smartSurplus > 0) {
      const smartChargeKwh = evSmartChargeFromSurplus(smartSurplus, smartRemainingKwh);
      if (smartChargeKwh > 0) {
        smartRemainingKwh -= smartChargeKwh;
        loadKwh += smartChargeKwh;
        smartDirect += smartChargeKwh;
        smartSurplus -= smartChargeKwh;
      }
    }
    chargeWByIdx[idx] = Math.max(0, flow.battChargeIn * 1000);
    chargeStoredWByIdx[idx] = Math.max(0, flow.battChargeIn * etaIn * 1000);
    const servedByBattery = Math.max(0, flow.battToLoad);
    const servedTotal = Math.min(loadKwh, flow.direct + smartDirect + servedByBattery);
    const servedW = servedTotal * 1000;
    const loadW = loadKwh * 1000;
    const autarkyNowPct = loadKwh > 0 ? ((flow.direct + smartDirect + servedByBattery) / loadKwh) * 100 : 100;
    const autarkyClamped = Math.max(0, Math.min(100, autarkyNowPct));
    const socClamped = Math.max(0, Math.min(100, (soc / cap) * 100));
    loadWByIdx[idx] = loadW;
    servedWByIdx[idx] = servedW;
    dischargeWByIdx[idx] = servedByBattery * 1000;
    exportWByIdx[idx] = Math.max(0, smartSurplus * 1000);
    autarkyPctByIdx[idx] = autarkyClamped;
    socPctByIdx[idx] = socClamped;
    autarkyPctValues.push(autarkyClamped);
    socPctValues.push(socClamped);
  });
  return { loadWByIdx, servedWByIdx, dischargeWByIdx, chargeWByIdx, chargeStoredWByIdx, exportWByIdx, socPctByIdx, autarkyPctByIdx, socPctValues, autarkyPctValues };
}

function batterySupportSeriesModeled(pvPowerSeriesW, loadWSeries, rawPvSeriesW = pvPowerSeriesW) {
  const { etaIn, etaOut } = batteryEfficiencyModel();
  const cap = Math.max(0.2, state.batteryCapacityKwh);
  const chargeLimitW = batteryChargeLimitWatts();
  const dischargeLimitW = batteryDischargeLimitWatts();
  const outputLimitW = batteryOutputLimitWatts();
  const smartMeterFactor = state.smartMeterInstalled ? 1 : 0.55;
  const smartMeterChargeFactor = state.smartMeterInstalled ? 1 : 0.7;
  const len = Math.max(0, pvPowerSeriesW?.length || 0);
  let soc = batteryInitialSocKwh(cap);
  const socPctByIdx = Array(len).fill(0);
  const autarkyPctByIdx = Array(len).fill(0);
  const servedWByIdx = Array(len).fill(0);
  const dischargeWByIdx = Array(len).fill(0);
  const chargeWByIdx = Array(len).fill(0);
  const chargeStoredWByIdx = Array(len).fill(0);
  const exportWByIdx = Array(len).fill(0);
  const socPctValues = [];
  const autarkyPctValues = [];
  const smartEnabled = evSmartModeActive();
  let smartRemainingKwh = smartEnabled ? evDailyEnergyTargetKwh(new Date()) : 0;

  for (let hour = 0; hour < len; hour++) {
    let loadKwh = Math.max(0, Number(loadWSeries?.[hour] || 0)) / 1000;
    let smartDirect = 0;
    const rawPvKwh = Math.max(0, Number(rawPvSeriesW?.[hour] || pvPowerSeriesW?.[hour] || 0)) / 1000;
    const flow = applyBatteryHourFlow(rawPvKwh, loadKwh, soc, true, cap, etaIn, etaOut, chargeLimitW, dischargeLimitW, outputLimitW, inverterLimitWatts(), smartMeterFactor, smartMeterChargeFactor);
    soc = flow.soc;
    let smartSurplus = Math.max(0, flow.exportKwh);
    if (smartEnabled && smartRemainingKwh > 0 && smartSurplus > 0) {
      const smartChargeKwh = evSmartChargeFromSurplus(smartSurplus, smartRemainingKwh);
      if (smartChargeKwh > 0) {
        smartRemainingKwh -= smartChargeKwh;
        loadKwh += smartChargeKwh;
        smartDirect += smartChargeKwh;
        smartSurplus -= smartChargeKwh;
      }
    }
    chargeWByIdx[hour] = Math.max(0, flow.battChargeIn * 1000);
    chargeStoredWByIdx[hour] = Math.max(0, flow.battChargeIn * etaIn * 1000);
    const servedByBattery = Math.max(0, flow.battToLoad);
    const servedTotal = Math.min(loadKwh, flow.direct + smartDirect + servedByBattery);
    servedWByIdx[hour] = servedTotal * 1000;
    dischargeWByIdx[hour] = servedByBattery * 1000;
    exportWByIdx[hour] = Math.max(0, smartSurplus * 1000);
    const autarkyNowPct = loadKwh > 0 ? ((flow.direct + smartDirect + servedByBattery) / loadKwh) * 100 : 100;
    const autarkyClamped = Math.max(0, Math.min(100, autarkyNowPct));
    const socClamped = Math.max(0, Math.min(100, (soc / cap) * 100));
    autarkyPctByIdx[hour] = autarkyClamped;
    socPctByIdx[hour] = socClamped;
    autarkyPctValues.push(autarkyClamped);
    socPctValues.push(socClamped);
  }
  return { loadWByIdx: loadWSeries, servedWByIdx, dischargeWByIdx, chargeWByIdx, chargeStoredWByIdx, exportWByIdx, socPctByIdx, autarkyPctByIdx, socPctValues, autarkyPctValues };
}

function lerp(a, b, t) { return a + (b - a) * t; }
function mixHex(c1, c2, t) {
  const a = c1.replace("#", "");
  const b = c2.replace("#", "");
  const r = Math.round(lerp(parseInt(a.slice(0, 2), 16), parseInt(b.slice(0, 2), 16), t));
  const g = Math.round(lerp(parseInt(a.slice(2, 4), 16), parseInt(b.slice(2, 4), 16), t));
  const bl = Math.round(lerp(parseInt(a.slice(4, 6), 16), parseInt(b.slice(4, 6), 16), t));
  return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${bl.toString(16).padStart(2, "0")}`;
}
function socToColor(socPct) {
  const s = Math.max(0, Math.min(100, socPct || 0));
  if (s <= 10) return mixHex("#dc2626", "#ef4444", s / 10);
  if (s <= 40) return mixHex("#ef4444", "#f97316", (s - 10) / 30);
  if (s <= 69) return mixHex("#f97316", "#f59e0b", (s - 40) / 29);
  if (s <= 90) return mixHex("#f59e0b", "#22c55e", (s - 69) / 21);
  return mixHex("#22c55e", "#10b981", (s - 90) / 10);
}

function socHasGlow(socPct) {
  const s = Math.max(0, Math.min(100, socPct || 0));
  return s <= 5 || s >= 91;
}

function batterySupportChart(el, labels, loadW, servedW, socPct, autarkyPct, dischargeW, chargeW, chargeStoredW, exportW) {
  const mobileCompact = window.matchMedia("(max-width: 820px)").matches;
  const w = mobileCompact ? 820 : 1260;
  const h = mobileCompact ? 360 : 300;
  const pad = mobileCompact ? { top: 20, right: 24, bottom: 64, left: 18 } : { top: 20, right: 36, bottom: 56, left: 18 };
  const rawMax = Math.max(1, ...loadW, ...servedW, ...chargeW, ...exportW);
  const step = rawMax <= 1000 ? 100 : rawMax <= 3000 ? 200 : 500;
  const max = Math.max(step, Math.ceil(rawMax / step) * step);
  const x = (i) => pad.left + i * ((w - pad.left - pad.right) / Math.max(1, labels.length - 1));
  const y = (v) => h - pad.bottom - (Math.max(0, v) / max) * (h - pad.top - pad.bottom);
  const tickVals = [];
  for (let v = 0; v <= max + step * 0.5; v += step) tickVals.push(v);
  const gridH = tickVals.map((v) => `<line class="oce-chart-grid" x1="${pad.left}" y1="${y(v)}" x2="${w - pad.right}" y2="${y(v)}"></line>`).join("");
  const gridV = labels.map((_, i) => i).filter((i) => i % (mobileCompact ? 4 : 2) === 0).map((i) => `<line class="oce-chart-grid-v" x1="${x(i)}" y1="${pad.top}" x2="${x(i)}" y2="${h - pad.bottom}"></line>`).join("");
  const loadPts = loadW.map((v, i) => ({ x: x(i), y: y(v) }));
  const loadD = linearPath(loadPts);
  const chargePts = chargeW.map((v, i) => ({ x: x(i), y: y(v) }));
  const chargeD = linearPath(chargePts);
  const exportPts = exportW.map((v, i) => ({ x: x(i), y: y(v) }));
  const exportD = linearPath(exportPts);
  const servedSegments = [];
  for (let i = 0; i < servedW.length - 1; i++) {
    const segSoc = (socPct[i] + socPct[i + 1]) / 2;
    const c = socToColor(segSoc);
    const glow = socHasGlow(segSoc)
      ? ` filter="drop-shadow(0 0 0.35px ${c}) drop-shadow(0 0 0.8px ${c})"`
      : "";
    servedSegments.push(`<line x1="${x(i)}" y1="${y(servedW[i])}" x2="${x(i + 1)}" y2="${y(servedW[i + 1])}" stroke="${c}" stroke-width="3.4" stroke-linecap="round"${glow}></line>`);
  }
  const divisor = mobileCompact ? 4 : 6; // wie Ersparnisübersicht (Tag)
  const xTicks = labels.map((l, i) => ({ l, i }))
    .filter((_, i) => i % divisor === 0 || i === labels.length - 1)
    .map(({ l, i }) => {
      const tx = x(i);
      const ty = h - 14;
      return `<text class="forecast-x-label" x="${tx}" y="${ty}" text-anchor="middle">${escapeHtml(l)}</text>`;
    }).join("");
  const yTicks = tickVals.map((v) => `<text class="oce-chart-label in-chart" x="${pad.left + 4}" y="${y(v) - 4}" text-anchor="start">${de0(v)} W</text>`).join("");
  el.innerHTML = `<svg viewBox="0 0 ${w} ${h}" width="100%" height="100%" role="img">${gridH}${gridV}<path d="${loadD}" fill="none" stroke="${getCss("--muted")}" stroke-width="2.6" stroke-dasharray="5 6" opacity="0.85"></path><path d="${chargeD}" fill="none" stroke="#06b6d4" stroke-width="2.2" opacity="0.92"></path><path d="${exportD}" fill="none" stroke="#f59e0b" stroke-width="2.2" opacity="0.92"></path>${servedSegments.join("")}${yTicks}${xTicks}<g class="oce-chart-hover-layer"></g></svg><div class="oce-chart-hover-tip" hidden></div>`;

  const svg = el.querySelector("svg");
  const hoverLayer = el.querySelector(".oce-chart-hover-layer");
  const tip = el.querySelector(".oce-chart-hover-tip");
  const hideTip = () => { tip.hidden = true; hoverLayer.innerHTML = ""; };
  const showAt = (clientX, clientY) => {
    const rect = svg.getBoundingClientRect();
    const vX = ((clientX - rect.left) / rect.width) * w;
    const idx = Math.max(0, Math.min(labels.length - 1, Math.round((vX - pad.left) / ((w - pad.left - pad.right) / Math.max(1, labels.length - 1)))));
    const px = x(idx);
    const socColor = socToColor(socPct[idx] || 0);
    const socGlow = socHasGlow(socPct[idx] || 0)
      ? ` filter="drop-shadow(0 0 0.35px ${socColor}) drop-shadow(0 0 0.8px ${socColor})"`
      : "";
    hoverLayer.innerHTML = `<line class="oce-chart-hover-line" x1="${px}" y1="${pad.top}" x2="${px}" y2="${h - pad.bottom}"></line>
      <circle class="oce-chart-dot" cx="${px}" cy="${y(loadW[idx] || 0)}" r="4" stroke="${getCss("--muted")}"></circle>
      <circle class="oce-chart-dot" cx="${px}" cy="${y(servedW[idx] || 0)}" r="4" stroke="${socColor}"${socGlow}></circle>
      <circle class="oce-chart-dot" cx="${px}" cy="${y(chargeW[idx] || 0)}" r="3.5" stroke="#06b6d4"></circle>
      <circle class="oce-chart-dot" cx="${px}" cy="${y(exportW[idx] || 0)}" r="3.5" stroke="#f59e0b"></circle>`;
    tip.innerHTML = `<strong>${labels[idx]}</strong>
      <div class="row"><span class="key"><i style="background:${getCss("--muted")}"></i>Aktuelle Last</span><span>${de0(loadW[idx] || 0)} W</span></div>
      <div class="row"><span class="key"><i style="background:${socColor};${socHasGlow(socPct[idx] || 0) ? `box-shadow:0 0 1px ${socColor};` : ""}"></i>Versorgt</span><span>${de0(servedW[idx] || 0)} W</span></div>
      <div class="row"><span class="key"><i style="background:#3b82f6"></i>SOC</span><span>${de(socPct[idx] || 0, 1)}%</span></div>
      <div class="row"><span class="key"><i style="background:#10b981"></i>Autarkie jetzt</span><span>${de(autarkyPct[idx] || 0, 1)}%</span></div>
      <div class="row"><span class="key"><i style="background:#f59e0b"></i>Entladeleistung</span><span>${de0(dischargeW[idx] || 0)} W</span></div>
      <div class="row"><span class="key"><i style="background:#06b6d4"></i>Ladeleistung (PV→Akku)</span><span>${de0(chargeW[idx] || 0)} W</span></div>
      <div class="row"><span class="key"><i style="background:#0ea5e9"></i>Gespeichert (im Akku)</span><span>${de0(chargeStoredW[idx] || 0)} W</span></div>
      <div class="row"><span class="key"><i style="background:#f59e0b"></i>Einspeisung</span><span>${de0(exportW[idx] || 0)} W</span></div>`;
    tip.hidden = false;
    let left = clientX - rect.left + 12;
    let top = clientY - rect.top - 16;
    if (left + tip.offsetWidth > el.clientWidth - 8) left = Math.max(8, el.clientWidth - tip.offsetWidth - 8);
    if (top + tip.offsetHeight > el.clientHeight - 8) top = Math.max(8, el.clientHeight - tip.offsetHeight - 8);
    if (top < 8) top = 8;
    tip.style.left = `${left}px`;
    tip.style.top = `${top}px`;
  };
  svg.addEventListener("mousemove", (e) => showAt(e.clientX, e.clientY));
  svg.addEventListener("mouseleave", hideTip);
  svg.addEventListener("touchstart", (e) => { const t = e.touches[0]; if (!t) return; e.preventDefault(); showAt(t.clientX, t.clientY); }, { passive: false });
  svg.addEventListener("touchmove", (e) => { const t = e.touches[0]; if (!t) return; e.preventDefault(); showAt(t.clientX, t.clientY); }, { passive: false });
  svg.addEventListener("touchend", hideTip);
}

function greedyFromSurplus(evNeedKwh, surplusSlots) {
  let remaining = Math.max(0, evNeedKwh);
  let covered = 0;
  const ordered = [...surplusSlots].sort((a, b) => b.surplus - a.surplus);
  for (const slot of ordered) {
    if (remaining <= 0) break;
    const usable = evSmartChargeFromSurplus(slot.surplus, remaining);
    const used = Math.min(remaining, Math.max(0, usable));
    covered += used;
    remaining -= used;
  }
  return covered;
}

function evWeekInsights() {
  if (!evEnabled() || !forecast) return null;
  const days = forecastCurrentWeekDays(forecast.days);
  if (!days.length) return null;

  const hourSurplusSum = Array(24).fill(0);
  const hourCount = Array(24).fill(0);
  const weekSlots = [];
  const dailyCurrentCovered = [];
  const dailyOptimalCovered = [];
  const weekEvNeed = Math.max(0, annualEvConsumptionKwh() / 52);
  const chargingDays = days.filter((d) => isEvChargingDay(d.date));
  const dailyEvNeed = chargingDays.length ? (weekEvNeed / chargingDays.length) : 0;

  days.forEach((day) => {
    const dateIso = day.date;
    const isChargeDay = isEvChargingDay(dateIso);
    const planShares = evPatternShares(dateIso);
    const daySlots = [];
    let currentCovered = 0;

    day.idxs.forEach((idx) => {
      const info = dateContext(forecast.time[idx]);
      const hour = info.hour || 0;
      const pvKwh = Math.max(0, Number(forecast.combinedPower[idx] || 0)) / 1000;
      const houseLoadKwh = Math.max(0, Number(annualLoadForDate(info.dateIso)[hour] || 0));
      const surplus = Math.max(0, pvKwh - houseLoadKwh);
      const usableSurplus = evSmartChargeFromSurplus(surplus, Number.POSITIVE_INFINITY);
      hourSurplusSum[hour] += usableSurplus;
      hourCount[hour] += 1;
      weekSlots.push({ surplus: usableSurplus, day: day.date, hour });
      daySlots.push({ surplus: usableSurplus, hour });
      if (isChargeDay && dailyEvNeed > 0) {
        const planned = dailyEvNeed * (planShares[hour] || 0);
        currentCovered += Math.min(planned, usableSurplus);
      }
    });

    if (!isChargeDay || dailyEvNeed <= 0) {
      dailyCurrentCovered.push(0);
      dailyOptimalCovered.push(0);
      return;
    }
    dailyCurrentCovered.push(currentCovered);
    dailyOptimalCovered.push(greedyFromSurplus(dailyEvNeed, daySlots));
  });

  const hourAvgSurplus = hourSurplusSum.map((v, h) => v / Math.max(1, hourCount[h]));
  const currentCoveredWeek = sum(dailyCurrentCovered);
  const optimalCoveredWeek = greedyFromSurplus(weekEvNeed, weekSlots);
  const tariffDelta = Math.max(0, state.electricityPrice - activeFeedInTariff());
  const currentSaved = currentCoveredWeek * tariffDelta;
  const optimalSaved = optimalCoveredWeek * tariffDelta;
  const extraPotential = Math.max(0, optimalSaved - currentSaved);
  const dayLabels = days.map((d) => weekdayLabelFromIsoDate(d.date));
  const extraPerDay = dailyOptimalCovered.map((v, i) => Math.max(0, (v - (dailyCurrentCovered[i] || 0)) * tariffDelta));

  const topHours = hourAvgSurplus
    .map((v, h) => ({ h, v }))
    .sort((a, b) => b.v - a.v)
    .slice(0, 3)
    .map((x) => `${String(x.h).padStart(2, "0")}:00`)
    .join(" · ");

  return {
    hourAvgSurplus,
    currentSaved,
    optimalSaved,
    extraPotential,
    dayLabels,
    extraPerDay,
    topHours,
    weekEvNeed,
    currentCoveredWeek,
    optimalCoveredWeek
  };
}

function renderEvInsights() {
  const card = $("evInsightsCard");
  if (!card) return;
  const insights = evWeekInsights();
  const visible = Boolean(insights);
  card.hidden = !visible;
  if (!visible) {
    ["evBestTimesChart", "evSavingsShiftChart", "evShiftDailyChart"].forEach((id) => { if ($(id)) $(id).innerHTML = ""; });
    return;
  }
  const mobileCompact = window.matchMedia("(max-width: 820px)").matches;
  const hourLabels = Array.from({ length: 24 }, (_, h) => `${String(h).padStart(2, "0")}:00`);
  lineChart(
    $("evBestTimesChart"),
    hourLabels,
    [{ name: "PV-Überschuss", color: "#10b981", values: insights.hourAvgSurplus, fill: true }],
    "kWh",
    { interactive: true, tickEvery: 2, denseGrid: false, smooth: true, mobileCompact }
  );
  simpleBars(
    $("evSavingsShiftChart"),
    ["Aktuell", "Optimal", "Mehrpotenzial"],
    [insights.currentSaved, insights.optimalSaved, insights.extraPotential],
    getCss("--primary"),
    "€",
    { mobileCompact }
  );
  simpleBars(
    $("evShiftDailyChart"),
    insights.dayLabels,
    insights.extraPerDay,
    "#10b981",
    "€",
    { mobileCompact }
  );
  const smartText = evSmartModeActive() ? "Smart: nur Überschuss" : "Smart aus";
  const phaseModeLabel = state.evPhaseMode === "single" ? "1‑phasig" : state.evPhaseMode === "three" ? "3‑phasig" : "Smart Hybrid";
  $("evBestTimesMeta").textContent = `Top-Slots: ${insights.topHours} · ${phaseModeLabel} · peak-cap = ${de(effectiveEvChargeSpeedKw(), 1)} kW`;
  $("evSavingsMeta").textContent = `${de(insights.currentCoveredWeek, 1)} / ${de(insights.optimalCoveredWeek, 1)} kWh aus PV‑Überschuss · ${smartText}`;
  $("evInsightsSummary").textContent = `EV-Bedarf Woche: ${de(insights.weekEvNeed, 1)} kWh · Ersparnis aktuell ${euro(insights.currentSaved)} · Potenzial ${euro(insights.extraPotential)} · Hybrid Peak-first`;
}

function renderCharts() {
  let yearlySupportModel = null;
  normalizeYearlyChartMode();
  const hasForecast = Boolean(forecast?.days?.length);
  const day = hasForecast ? (forecast.days[state.selectedDayIndex] || forecast.days[0]) : null;
  const fullDayIdxs = day?.idxs || [];
  const loadProfileValue = $("loadProfile")?.value || state.loadProfile;
  const showLoadCurveBase = loadProfileValue !== "-";
  const showInlineControls = true;
  const idxs = day ? (showLoadCurveBase ? fullDayIdxs : chartWindowIndexes(day)) : [];
  const physicalLimitW = Math.round(inverterLimitWatts());
  const limitW = state.inverterLimitEnabled ? physicalLimitW : null;
  const limitText = Number.isFinite(limitW) ? (limitW >= 1000 ? `${de(limitW / 1000, 1)} kW` : `${limitW} W`) : null;
  const dayLoss = day ? lossFromIdxs(fullDayIdxs) : { raw: 0, limited: 0, loss: 0, pct: 0 };
  const currentWeekDays = hasForecast ? forecastCurrentWeekDays(forecast.days) : [];
  const weekIdxs = currentWeekDays.flatMap((d) => d.idxs);
  const weekLoss = lossFromIdxs(weekIdxs);
  const weekLossRatio = weekLoss.raw > 0 ? (weekLoss.loss / weekLoss.raw) : 0;
  const yearLossEst = annual ? annual.yearly * weekLossRatio : 0;
  const yearLossPctEst = weekLossRatio * 100;
  const dayFlow = hasForecast ? simulateEnergyFlow(fullDayIdxs, forecast.combinedPower, state.batteryMode, forecast.combinedDcPower) : normalizePowerFlow({ pv: 0, loadTotal: 0, direct: 0, battChargeIn: 0, battToLoad: 0, exportKwh: 0, gridImport: 0, totalValue: 0, soc: 0, cap: 0 });
  const weekFlow = hasForecast ? simulateEnergyFlow(weekIdxs, forecast.combinedPower, state.batteryMode, forecast.combinedDcPower) : normalizePowerFlow({ pv: 0, loadTotal: 0, direct: 0, battChargeIn: 0, battToLoad: 0, exportKwh: 0, gridImport: 0, totalValue: 0, soc: 0, cap: 0 });
  const autarkyPct = weekFlow.autarky * 100;
  const currentPvCoverPct = dayFlow.loadTotal > 0 ? Math.min(100, (dayFlow.pvTotal / dayFlow.loadTotal) * 100) : 0;
  const mobileCompact = window.matchMedia("(max-width: 820px)").matches;
  const powerInterpolator = mobileCompact ? interpolateHalfHourData : interpolateQuarterData;
  const areaDcHourly = hasForecast ? forecast.areaResults.map((r) => r.dcPower) : [];
  const rawInterp = hasForecast ? powerInterpolator(idxs, [forecast.combinedDcPower], !state.batteryMode) : { labels: [], series: [[]] };
  const powerRawCombined = rawInterp.series[0] || [];
  const physicalCapW = physicalLimitW + batteryChargeHeadroomWatts();
  const powerLimitedCombined = powerRawCombined.map((v) => Math.min(v, physicalCapW));
  const powerAreaRaw = hasForecast ? powerInterpolator(idxs, areaDcHourly, !state.batteryMode).series : [];
  const powerAreaLimited = powerAreaRaw.map((areaSeries) => areaSeries.map((v, i) => {
    const raw = powerRawCombined[i] || 0;
    if (raw <= 0) return 0;
    return v * (powerLimitedCombined[i] / raw);
  }));
  const activeAreaCount = activeSeries.areas.filter(Boolean).length;
  const useSolidAreaLines = !activeSeries.combined && activeAreaCount === 1;
  const useFilledAreaLine = useSolidAreaLines;
  const hourlyLoadW = hasForecast ? forecast.time.map((t) => {
    const hour = Number((t || "00:00").slice(11, 13));
    const dayKey = String(t || "").slice(0, 10);
    return Math.max(0, Number(totalLoadForDate(dayKey)[hour] || 0)) * 1000;
  }) : [];
  const showLoadCurve = showLoadCurveBase && state.loadCurveVisible;
  const powerLoad = showLoadCurve && hasForecast ? powerInterpolator(idxs, [hourlyLoadW], !state.batteryMode).series[0] : null;
  const mainChartModeTabs = $("mainChartModeTabs");
  if (mainChartModeTabs) {
    mainChartModeTabs.querySelectorAll("[data-main-chart]").forEach((button) => button.classList.toggle("oce-active", button.dataset.mainChart === state.mainChartMode));
  }
  const mainChartControls = mainChartModeTabs?.closest(".oce-main-chart-controls");
  const yearlyChartModeTabs = $("yearlyChartModeTabs");
  if (yearlyChartModeTabs) {
    yearlyChartModeTabs.hidden = state.mainChartMode !== "yearly";
    yearlyChartModeTabs.querySelectorAll("[data-yearly-chart]").forEach((button) => button.classList.toggle("oce-active", button.dataset.yearlyChart === state.yearlyChartMode));
  }
  if (mainChartControls) mainChartControls.classList.toggle("is-single", state.mainChartMode !== "yearly");
  const sharedSubExtra = chartInlineControlsMarkup(showInlineControls);
  if (state.mainChartMode === "current") {
    if (!hasForecast) {
      if (runtimeState.currentForecastStatus === "loading") renderCurrentDataLoading(runtimeState.currentForecastMessage || "Daten werden geladen …");
      else renderCurrentDataIdle(runtimeState.currentForecastMessage || "Aktuelle Erträge laden");
      $("batteryRuntimeCard").hidden = true;
      ["irradianceChart", "weekChart", "batteryRuntimeChart", "hourStrip"].forEach((id) => { if ($(id)) $(id).innerHTML = ""; });
      renderChartLegend($("irradianceChartLegend"), []);
      renderChartLegend($("batteryRuntimeLegend"), []);
      $("weekTotal").textContent = "";
      $("irradianceInfo").textContent = "Aktuelle Daten werden erst nach Auswahl dieser Ansicht geladen";
      if (annual) {
        const safeTotal = Math.max(totalKwp(), 0.01);
        const monthlyByArea = Array.isArray(annual.areaMonthly) && annual.areaMonthly.length === state.areas.length
          ? annual.areaMonthly
          : state.areas.map((a) => annual.monthly.map((v) => v * (a.kwp / safeTotal)));
        const stacks = MONTH_LABELS.map((_, m) => monthlyByArea.map((row) => row[m]));
        stackedBars($("yearChart"), MONTH_LABELS, stacks, state.areas.map((a) => a.color), "kWh", { mobileCompact });
      }
      return;
    }
    $("mainChartTitle").textContent = "PV‑Leistung";
    if (state.batteryMode) {
      $("selectedDayInfo").textContent = `24h · Autarkie ${de(autarkyPct, 1)}% · PV/Verbrauch ${de(currentPvCoverPct, 1)}% · Netzbezug ${de(dayFlow.gridImport, 2)} kWh`;
    } else if (state.inverterLimitEnabled) {
      $("selectedDayInfo").textContent = `${shortTime(day.sunrise)} ↑ · ${shortTime(day.sunset)} ↓ · Autarkie ${de(autarkyPct, 1)}% · PV/Verbrauch ${de(currentPvCoverPct, 1)}% · Ertrag ${de(dayLoss.limited, 2)} kWh · Verlust ${de(dayLoss.loss, 2)} kWh (${de(dayLoss.pct, 1)}%)`;
    } else {
      $("selectedDayInfo").textContent = `${shortTime(day.sunrise)} ↑ · ${shortTime(day.sunset)} ↓ · Autarkie ${de(autarkyPct, 1)}% · PV/Verbrauch ${de(currentPvCoverPct, 1)}%`;
    }
    const subMain = limitText
      ? `Live‑Prognose mit Open‑Meteo GTI je Fläche und ${limitText} ${systemLimitDescriptor()}.`
      : "Live‑Prognose mit Open‑Meteo GTI je Fläche.";
    $("mainChartSubtitle").innerHTML = subMain + sharedSubExtra;
    const powerSeries = [];
    if (activeSeries.combined) powerSeries.push({ name: "Kombiniert", color: COMBINED_COLOR, values: powerLimitedCombined, projectedValues: state.inverterLimitEnabled ? powerRawCombined : null, fill: true });
    forecast.areaResults.forEach((r, i) => {
      if (activeSeries.areas[i] !== false) {
        powerSeries.push({
          name: r.area.name,
          color: state.areas[i].color,
          values: powerAreaLimited[i],
          projectedValues: useFilledAreaLine && state.inverterLimitEnabled ? powerAreaRaw[i] : null,
          dashed: !useSolidAreaLines,
          fill: useFilledAreaLine
        });
      }
    });
    if (showLoadCurve && powerLoad) {
      const loadColor = document.documentElement.dataset.theme === "dark" ? "#f8fafc" : "#111827";
      powerSeries.push({ name: "Verbrauch", color: loadColor, values: powerLoad, dashed: true });
    }
    lineChart($("powerChart"), rawInterp.labels, powerSeries, "W", { interactive: true, tickEvery: 2, denseGrid: true, limitW, smooth: true, mobileCompact });
    renderChartLegend($("powerChartLegend"), [
      ...powerSeries.map((series) => ({ label: series.name, color: series.color, dashed: series.dashed, thick: !series.dashed })),
      ...(state.inverterLimitEnabled ? [{ label: systemLimitDescriptor(), color: getCss("--chart-limit"), limit: true }] : [])
    ]);
  } else {
    const averageDay = buildAverageDayChartData(state.yearlyChartMode);
    const summerScaleReference = state.yearlyChartMode === "summer" ? averageDay : buildAverageDayChartData("summer");
    yearlySupportModel = averageDay;
    const averageFlow = averageDay.flow;
    const modeLabel = state.yearlyChartMode === "summer" ? "Sommer" : state.yearlyChartMode === "winter" ? "Winter" : "Durchschnitt";
    $("mainChartTitle").textContent = `PV‑Leistung · ${modeLabel}`;
    const infoPrefix = "Ø 24 h";
    if (state.batteryMode) {
      $("selectedDayInfo").textContent = `${infoPrefix} · Autarkie ${de(averageFlow.autarky * 100, 1)}% · PV/Verbrauch ${de(averageDay.pvCoverPct, 1)}% · Netzbezug ${de(averageFlow.gridImport, 2)} kWh`;
    } else if (state.inverterLimitEnabled) {
      $("selectedDayInfo").textContent = `${infoPrefix} · Autarkie ${de(averageFlow.autarky * 100, 1)}% · PV/Verbrauch ${de(averageDay.pvCoverPct, 1)}% · Ertrag ${de(averageDay.lossLimitedKwh, 2)} kWh · Verlust ${de(averageDay.lossKwh, 2)} kWh (${de(averageDay.lossPct, 1)}%)`;
    } else {
      $("selectedDayInfo").textContent = `${infoPrefix} · Autarkie ${de(averageFlow.autarky * 100, 1)}% · PV/Verbrauch ${de(averageDay.pvCoverPct, 1)}% · Ertrag ${de(averageDay.lossLimitedKwh, 2)} kWh`;
    }
    const yearlyPrefix = state.yearlyChartMode === "summer"
      ? "Sommerprofil aus dem Jahresmodell (April bis Oktober)."
      : state.yearlyChartMode === "winter"
        ? "Winterprofil aus dem Jahresmodell (November bis März)."
        : "Durchschnittsprofil aus dem Jahresmodell.";
    const subMain = limitText
      ? `${yearlyPrefix} Basis: ${annual.source}${annual.approximate ? " · grobe Schätzung" : ""} und ${limitText} ${systemLimitDescriptor()}.`
      : `${yearlyPrefix} Basis: ${annual.source}${annual.approximate ? " · grobe Schätzung" : ""}.`;
    $("mainChartSubtitle").innerHTML = subMain + sharedSubExtra;
    const averageSeriesMeta = [];
    const averageRawSeriesInputs = [];
    if (activeSeries.combined) {
      averageSeriesMeta.push({ name: "Kombiniert", color: COMBINED_COLOR, fill: true, dashed: false, hasProjected: state.inverterLimitEnabled });
      averageRawSeriesInputs.push(averageDay.rawCombined);
    }
    state.areas.forEach((result, i) => {
      if (activeSeries.areas[i] !== false) {
        averageSeriesMeta.push({
          name: result.name,
          color: state.areas[i].color,
          dashed: !useSolidAreaLines,
          fill: useFilledAreaLine,
          hasProjected: useFilledAreaLine && state.inverterLimitEnabled,
          areaIndex: i
        });
        averageRawSeriesInputs.push(averageDay.rawByArea[i]);
      }
    });
    if (showLoadCurve) {
      const loadColor = document.documentElement.dataset.theme === "dark" ? "#f8fafc" : "#111827";
      averageSeriesMeta.push({ name: "Verbrauch", color: loadColor, dashed: true, hasProjected: false, isLoad: true });
      averageRawSeriesInputs.push(averageDay.loadSeriesW);
    }
    const averageHalfHourRaw = interpolateHalfHourSeries(averageRawSeriesInputs);
    const averageHalfHourRawCombined = interpolateHalfHourSeries([averageDay.rawCombined]).series[0] || [];
    const averageHalfHourLimitedCombined = averageHalfHourRawCombined.map((value) => Math.min(value, physicalCapW));
    const summerHalfHourRawCombined = interpolateHalfHourSeries([summerScaleReference.rawCombined]).series[0] || [];
    let averageSeriesCursor = 0;
    const averageSeries = averageSeriesMeta.map((seriesMeta) => {
      if (seriesMeta.fill) {
        averageSeriesCursor += 1;
        return {
          name: seriesMeta.name,
          color: seriesMeta.color,
          dashed: false,
          fill: true,
          values: averageHalfHourLimitedCombined,
          projectedValues: state.inverterLimitEnabled ? averageHalfHourRawCombined : null
        };
      }
      if (seriesMeta.isLoad) {
        const values = averageHalfHourRaw.series[averageSeriesCursor] || [];
        averageSeriesCursor += 1;
        return { name: seriesMeta.name, color: seriesMeta.color, dashed: true, values, projectedValues: null };
      }
      const rawAreaValues = averageHalfHourRaw.series[averageSeriesCursor] || [];
      averageSeriesCursor += 1;
      const values = rawAreaValues.map((value, idx) => {
        const rawCombined = averageHalfHourRawCombined[idx] || 0;
        if (rawCombined <= 0) return 0;
        return value * ((averageHalfHourLimitedCombined[idx] || 0) / rawCombined);
      });
      return {
        name: seriesMeta.name,
        color: seriesMeta.color,
        dashed: seriesMeta.dashed,
        fill: seriesMeta.fill === true,
        values,
        projectedValues: seriesMeta.hasProjected ? rawAreaValues : null
      };
    });
    const yearlyScaleMax = Math.max(
      1,
      ...summerHalfHourRawCombined,
      ...averageSeries.flatMap((series) => series.values || []),
      ...averageSeries.flatMap((series) => series.projectedValues || [])
    );
    lineChart($("powerChart"), averageHalfHourRaw.labels, averageSeries, "W", { interactive: true, tickEvery: 4, denseGrid: true, limitW, smooth: true, mobileCompact, yMaxOverride: yearlyScaleMax });
    renderChartLegend($("powerChartLegend"), [
      ...averageSeries.map((series) => ({ label: series.name, color: series.color, dashed: series.dashed, thick: !series.dashed })),
      ...(state.inverterLimitEnabled ? [{ label: systemLimitDescriptor(), color: getCss("--chart-limit"), limit: true }] : [])
    ]);
  }
  bindChartInlineControls();

  const hasAnnualConsumptionValue = annualTotalConsumptionKwh() > 0;
  const showRuntime = state.batteryMode && hasAnnualConsumptionValue;
  $("batteryRuntimeCard").hidden = !showRuntime;
  if (showRuntime) {
    const support = state.mainChartMode === "yearly" && yearlySupportModel
      ? batterySupportSeriesModeled(yearlySupportModel.limitedCombined, yearlySupportModel.loadSeriesW, yearlySupportModel.rawCombined)
      : batterySupportSeries(idxs, forecast.combinedPower, forecast.combinedDcPower);
    const supportQuarter = state.mainChartMode === "yearly"
      ? interpolateHalfHourSeries([support.loadWByIdx, support.servedWByIdx, support.socPctByIdx, support.autarkyPctByIdx, support.dischargeWByIdx, support.chargeWByIdx, support.chargeStoredWByIdx, support.exportWByIdx])
      : interpolateHalfHourData(idxs, [support.loadWByIdx, support.servedWByIdx, support.socPctByIdx, support.autarkyPctByIdx, support.dischargeWByIdx, support.chargeWByIdx, support.chargeStoredWByIdx, support.exportWByIdx]);
    const avgSoc = support.socPctValues.length ? sum(support.socPctValues) / support.socPctValues.length : 0;
    const avgAutarkyNow = support.autarkyPctValues.length ? sum(support.autarkyPctValues) / support.autarkyPctValues.length : 0;
    const runtimeModeLabel = state.mainChartMode === "yearly"
      ? (state.yearlyChartMode === "summer" ? "Sommerprofil" : state.yearlyChartMode === "winter" ? "Winterprofil" : "Durchschnittsprofil")
      : "Tagesprofil";
    $("batteryRuntimeInfo").textContent = `${batteryTypeLabel()} · ${runtimeModeLabel} · Basis = Lastkurve · Versorgung bis Ausgangsleistung · Ø SOC ${de(avgSoc, 1)}% · Ø Autarkie jetzt ${de(avgAutarkyNow, 1)}%`;
    batterySupportChart(
      $("batteryRuntimeChart"),
      supportQuarter.labels,
      supportQuarter.series[0],
      supportQuarter.series[1],
      supportQuarter.series[2],
      supportQuarter.series[3],
      supportQuarter.series[4],
      supportQuarter.series[5],
      supportQuarter.series[6],
      supportQuarter.series[7]
    );
    renderChartLegend($("batteryRuntimeLegend"), [
      { label: "Aktuelle Last", color: getCss("--muted"), dashed: true },
      { label: "Versorgt", color: "#22c55e", thick: true },
      { label: "Ladeleistung", color: "#06b6d4" },
      { label: "Einspeisung", color: "#f59e0b" }
    ]);
  } else {
    $("batteryRuntimeChart").innerHTML = "";
    renderChartLegend($("batteryRuntimeLegend"), []);
  }

  if (hasForecast) {
    const irradianceQuarter = interpolateQuarterData(idxs, forecast.areaResults.map((r) => r.gti));
    const irradianceSeries = forecast.areaResults.map((r, i) => ({ name: r.area.name, color: state.areas[i].color, values: irradianceQuarter.series[i], dashed: true }));
    lineChart($("irradianceChart"), irradianceQuarter.labels, irradianceSeries, "W/m²", { tickEvery: 4, denseGrid: false, mobileCompact });
    renderChartLegend($("irradianceChartLegend"), irradianceSeries.map((series) => ({ label: series.name, color: series.color, dashed: true })));
    stackedBars($("weekChart"), currentWeekDays.map((d) => weekdayLabelFromIsoDate(d.date)), currentWeekDays.map((d) => d.areaEnergy), state.areas.map((a) => a.color), "kWh", { mobileCompact });
    $("weekTotal").textContent = state.inverterLimitEnabled
      ? `${de(sum(currentWeekDays.map((d) => d.energy)), 1)} kWh · Verlust am ${systemLimitDescriptor()} ${de(weekLoss.loss, 2)} kWh (${de(weekLoss.pct, 1)}%)`
      : `${de(sum(currentWeekDays.map((d) => d.energy)), 1)} kWh gesamt`;
  } else {
    $("irradianceChart").innerHTML = "";
    $("weekChart").innerHTML = "";
    $("weekTotal").textContent = "";
    renderChartLegend($("irradianceChartLegend"), []);
  }
  if (annual) {
    const safeTotal = Math.max(totalKwp(), 0.01);
    const monthlyByArea = Array.isArray(annual.areaMonthly) && annual.areaMonthly.length === state.areas.length
      ? annual.areaMonthly
      : state.areas.map((a) => annual.monthly.map((v) => v * (a.kwp / safeTotal)));
    const stacks = MONTH_LABELS.map((_, m) => monthlyByArea.map((row) => row[m]));
    stackedBars($("yearChart"), MONTH_LABELS, stacks, state.areas.map((a) => a.color), "kWh", { mobileCompact });
    $("yearSource").textContent = state.inverterLimitEnabled
      ? `${de0(annual.yearly)} kWh/Jahr · Verlust am ${systemLimitDescriptor()} geschätzt ${de0(yearLossEst)} kWh (${de(yearLossPctEst, 1)}%) · ${annual.source}${annual.approximate ? " · grobe Schätzung" : ""}`
      : `${de0(annual.yearly)} kWh/Jahr · ${annual.source}${annual.approximate ? " · grobe Schätzung" : ""}`;
  }
  $("irradianceInfo").textContent = hasForecast
    ? (state.inverterLimitEnabled
      ? `GTI je Fläche · Tagesverlust am ${systemLimitDescriptor()} ${de(dayLoss.loss, 2)} kWh (${de(dayLoss.pct, 1)}%)`
      : "Unabhängige Open‑Meteo GTI‑Abfrage pro Fläche")
    : "Wird geladen, sobald Aktuelle Erträge geöffnet werden";
  $("savingsYearsInfo").textContent = state.inverterLimitEnabled
    ? `1 / 5 / 10 / 20 / 25 Jahre · Verlust am ${systemLimitDescriptor()} geschätzt ${de0(yearLossEst)} kWh/Jahr`
    : "1 / 5 / 10 / 20 / 25 Jahre";
  renderSavingsYearsChart();
  renderPaybackChart();
  renderEvInsights();
}

function renderSavingsYearsChart() { const f = financials(); const years = [1, 5, 10, 20, 25]; const mobileCompact = window.matchMedia("(max-width: 820px)").matches; simpleBars($("savingsYearsChart"), years.map((y) => `${y}J`), years.map((y) => f.accum(y)), getCss("--primary"), "€", { mobileCompact }); }

function renderPaybackChart() {
  const f = financials();
  const labels = []; const savings = [];
  for (let y = 0; y <= 25; y++) { labels.push(String(y)); savings.push(f.accum(y)); }
  let paybackYear = null;
  let paybackExact = null;
  for (let y = 0; y <= 25; y++) {
    if (savings[y] >= state.systemCost) {
      paybackYear = y;
      const prev = y === 0 ? 0 : savings[y - 1];
      const delta = Math.max(0.0001, savings[y] - prev);
      const share = y === 0 ? 0 : clamp((state.systemCost - prev) / delta, 0, 1);
      paybackExact = y === 0 ? 0 : (y - 1 + share);
      break;
    }
  }
  if (paybackYear === null) {
    $("paybackText").textContent = state.batteryMode ? "Neue Amortisation: nach 25 Jahren noch nicht erreicht" : "Nach 25 Jahren noch nicht amortisiert";
  } else {
    const yearsInt = Math.floor(paybackExact);
    let months = Math.round((paybackExact - yearsInt) * 12);
    let yearsShown = yearsInt;
    if (months >= 12) { yearsShown += 1; months = 0; }
    const yearPart = `${yearsShown} ${yearsShown === 1 ? "Jahr" : "Jahre"}`;
    const monthPart = `${months} ${months === 1 ? "Monat" : "Monate"}`;
    $("paybackText").textContent = state.batteryMode
      ? `Neue Amortisation ca. ${yearPart} ${monthPart}`
      : `Amortisation ca. ${yearPart} ${monthPart}`;
  }
  const mobileCompact = window.matchMedia("(max-width: 820px)").matches;
  paybackBars($("paybackChart"), labels, savings, state.systemCost, { mobileCompact });
}

function renderFinance() {
  const f = financials();
  const battery = f.battery;
  const annualFlow = state.batteryMode ? battery?.annualFlow : f.baseline?.annualFlow;
  const totalSystemCost = Math.max(0, Number(state.systemCost || 0));
  const batteryCostRaw = Math.max(0, Number(state.batterySystemCost || 0));
  const batteryCost = state.batteryMode ? Math.min(batteryCostRaw, totalSystemCost) : 0;
  const pvComponentCost = Math.max(0, totalSystemCost - batteryCost);
  const batteryAnnualSavings = state.batteryMode && battery ? Math.max(0, Number(battery.annualExtraSavings || 0)) : 0;
  const batteryPaybackYears = state.batteryMode && batteryAnnualSavings > 0 ? (batteryCost / batteryAnnualSavings) : null;
  const hasFlowBasis = Boolean(forecast) && (state.batteryMode || state.annualConsumptionEdited || state.evMode);
  const currentWeekDays = forecastCurrentWeekDays(forecast?.days || []);
  const flowBase = hasFlowBasis
    ? simulateEnergyFlow(
        currentWeekDays.flatMap((d) => d.idxs),
        forecast.combinedPower,
        state.batteryMode,
        forecast.combinedDcPower
      )
    : null;
  const annualGridImport = Number.isFinite(annualFlow?.gridImport)
    ? annualFlow.gridImport
    : (flowBase ? (flowBase.gridImport * (365 / Math.max(1, currentWeekDays.length))) : null);
  const autarkyPct = state.batteryMode && battery
    ? (Number.isFinite(battery.annualAutarkyPct) ? battery.annualAutarkyPct : battery.autarkyPct)
    : (Number.isFinite(annualFlow?.autarky) ? annualFlow.autarky * 100 : (flowBase ? flowBase.autarky * 100 : null));
  const selfUsePct = state.batteryMode && battery
    ? (Number.isFinite(battery.annualSelfConsumptionPct) ? battery.annualSelfConsumptionPct : battery.selfConsumptionPct)
    : (Number.isFinite(annualFlow?.selfConsumption) ? annualFlow.selfConsumption * 100 : (flowBase ? flowBase.selfConsumption * 100 : null));
  const extraCard = state.expertMode ? `<div class="oce-money"><div class="oce-money-value">${euroHtml(f.yearlyFeed)}</div><div class="oce-money-label">Einspeisung / Jahr</div></div>` : `<div class="oce-money"><div class="oce-money-value">100%</div><div class="oce-money-label">Eigenverbrauch Standard</div></div>`;
  const evShareCard = state.evMode
    ? `<div class="oce-money"><div class="oce-money-value">${de((annualEvConsumptionKwh() / Math.max(0.0001, annualTotalConsumptionKwh())) * 100, 1)}%</div><div class="oce-money-label">EV-Strom am Jahresverbrauch</div></div>`
    : "";
  const batteryCostCards = state.batteryMode
    ? `<div class="oce-money"><div class="oce-money-value">${euroHtml(totalSystemCost)}</div><div class="oce-money-label">Systemkosten gesamt</div></div>
       <div class="oce-money"><div class="oce-money-value">${euroHtml(pvComponentCost)}</div><div class="oce-money-label">PV-Komponenten</div></div>
       <div class="oce-money"><div class="oce-money-value">${euroHtml(batteryCost)}</div><div class="oce-money-label">Speichersystem</div></div>
       <div class="oce-money"><div class="oce-money-value">${batteryPaybackYears !== null ? `${de(batteryPaybackYears, 1)} J` : "–"}</div><div class="oce-money-label">Speicher-Amortisation</div></div>`
    : "";
  const flowCards = (flowBase || annualFlow)
    ? `<div class="oce-money"><div class="oce-money-value">${de(autarkyPct, 1)}%</div><div class="oce-money-label">Autarkiegrad</div></div>
       <div class="oce-money"><div class="oce-money-value">${de(selfUsePct, 1)}%</div><div class="oce-money-label">Eigenverbrauchsquote</div></div>
       <div class="oce-money"><div class="oce-money-value">${de0(state.batteryMode && battery ? battery.annualGridImportKwh : annualGridImport)} kWh</div><div class="oce-money-label">Netzbezug / Jahr</div></div>
       ${state.batteryMode && battery ? `<div class="oce-money"><div class="oce-money-value">${euroHtml(batteryAnnualSavings)}</div><div class="oce-money-label">${batteryTypeLabel()} spart / Jahr</div></div>` : ""}`
    : "";
  $("financeKpis").innerHTML = `<div class="oce-money"><div class="oce-money-value">${euroHtml(f.yearlyTotal)}</div><div class="oce-money-label">pro Jahr</div></div><div class="oce-money"><div class="oce-money-value">${euroHtml(f.monthlyTotal)}</div><div class="oce-money-label">Ø monatlich</div></div><div class="oce-money"><div class="oce-money-value">${euroHtml(f.yearlySaved)}</div><div class="oce-money-label">Eigenverbrauch / Jahr</div></div>${evShareCard}${extraCard}${batteryCostCards}${flowCards}`;
}

function renderHourStrip() {
  if (!forecast?.days?.length) {
    $("hourStrip").innerHTML = "";
    return;
  }
  const day = forecast.days[state.selectedDayIndex];
  const idxs = chartWindowIndexes(day);
  $("hourStrip").innerHTML = idxs.map((i) => {
    const areaVals = forecast.areaResults.map((r) => r.energy[i] || 0);
    const max = Math.max(0.01, ...areaVals);
    return `<div class="oce-hour"><div class="oce-hour-time">${forecast.time[i].slice(11, 16)}</div><div class="oce-hour-meta">${de0(forecast.weather.temperature_2m[i])}° · ${de0(forecast.combinedPower[i])} W</div><div class="oce-mini-bars">${areaVals.map((v, j) => `<i style="height:${Math.max(3, 28 * v / max)}px;background:${state.areas[j].color}"></i>`).join("")}</div></div>`;
  }).join("");
}

function getCss(name) { return getComputedStyle(document.documentElement).getPropertyValue(name).trim(); }

function smoothPath(points) {
  if (!points.length) return "";
  if (points.length === 1) return `M${points[0].x} ${points[0].y}`;
  let d = `M${points[0].x} ${points[0].y}`;
  for (let i = 0; i < points.length - 1; i++) {
    const p0 = points[i - 1] || points[i];
    const p1 = points[i];
    const p2 = points[i + 1];
    const p3 = points[i + 2] || p2;
    const c1x = p1.x + (p2.x - p0.x) / 6;
    const c1y = p1.y + (p2.y - p0.y) / 6;
    const c2x = p2.x - (p3.x - p1.x) / 6;
    const c2y = p2.y - (p3.y - p1.y) / 6;
    d += ` C${c1x} ${c1y},${c2x} ${c2y},${p2.x} ${p2.y}`;
  }
  return d;
}

function linearPath(points) {
  if (!points.length) return "";
  return points.map((p, i) => `${i ? "L" : "M"}${p.x} ${p.y}`).join(" ");
}

function renderChartLegend(el, items) {
  if (!el) return;
  const visibleItems = Array.isArray(items) ? items.filter((item) => item && item.label) : [];
  if (!visibleItems.length) {
    el.hidden = true;
    el.innerHTML = "";
    return;
  }
  el.hidden = false;
  el.innerHTML = visibleItems.map((item) => `
    <span class="oce-chart-legend-item">
      <span class="oce-chart-legend-line${item.dashed ? " is-dashed" : ""}${item.thick ? " is-thick" : ""}${item.limit ? " is-limit" : ""}" style="color:${escapeHtml(item.color)}"></span>
      <span>${escapeHtml(item.label)}</span>
    </span>
  `).join("");
}

function lineChart(el, labels, series, unit, opts = {}) {
  const { interactive = false, tickEvery = null, denseGrid = false, limitW = null, smooth = true, mobileCompact = false, yMaxOverride = null } = opts;
  const w = mobileCompact ? 820 : 1260;
  const h = mobileCompact ? 450 : 400;
  const pad = mobileCompact
    ? { top: 18, right: 14, bottom: 54, left: 18 }
    : { top: 22, right: 26, bottom: denseGrid ? 72 : 44, left: 58 };
  if (!series.length) {
    el.innerHTML = `<svg viewBox="0 0 ${w} ${h}" width="100%" height="100%" role="img"><text class="oce-chart-label" x="${pad.left}" y="${h / 2}">Keine Reihe aktiv</text></svg>`;
    return;
  }
  const rawMax = Math.max(
    1,
    ...series.flatMap((s) => s.values || []),
    ...series.flatMap((s) => s.projectedValues || []),
    Number(yMaxOverride || 0)
  );
  const axisStep = rawMax <= 1000 ? 50 : rawMax <= 3000 ? 100 : 250;
  const max = Math.max(axisStep, Math.ceil(rawMax / axisStep) * axisStep);
  runtimeState.chartRenderNonce += 1;
  const nonce = runtimeState.chartRenderNonce;
  const x = (i) => pad.left + i * ((w - pad.left - pad.right) / Math.max(1, labels.length - 1));
  const y = (v) => h - pad.bottom - (v / max) * (h - pad.top - pad.bottom);
  const buildPath = (points) => smooth ? smoothPath(points) : linearPath(points);
  const tickValues = [];
  for (let v = 0; v <= max + axisStep * 0.5; v += axisStep) tickValues.push(v);
  const horizontalGrid = tickValues.map((v) => `<line class="oce-chart-grid" x1="${pad.left}" y1="${y(v)}" x2="${w - pad.right}" y2="${y(v)}"/>`).join("");
  const parseHourLabel = (label) => {
    if (!/:00$/.test(label)) return null;
    const hour = Number(label.slice(0, 2));
    return Number.isFinite(hour) ? hour : null;
  };
  const isHourLabel = (label) => parseHourLabel(label) != null;
  const isMobileMajorHourLabel = (label) => {
    const hour = parseHourLabel(label);
    return hour != null && hour % 3 === 0;
  };
  const verticalStep = mobileCompact ? null : (denseGrid ? 1 : Math.max(2, Math.round(labels.length / 20)));
  const verticalGrid = labels.map((label, i) => ({ label, i }))
    .filter(({ label, i }) => mobileCompact ? isMobileMajorHourLabel(label) || i === labels.length - 1 : i % verticalStep === 0)
    .map(({ i }) => `<line class="oce-chart-grid-v" x1="${x(i)}" y1="${pad.top}" x2="${x(i)}" y2="${h - pad.bottom}"/>`).join("");
  let defs = "";
  const hasLimit = Number.isFinite(limitW) && limitW > 0 && limitW < max;
  const limitY = hasLimit ? y(limitW) : null;
  const clipId = hasLimit ? `overLimitClip_${nonce}` : null;
  if (hasLimit) defs += `<clipPath id="${clipId}"><rect x="${pad.left}" y="${pad.top}" width="${w - pad.left - pad.right}" height="${Math.max(0, limitY - pad.top)}"></rect></clipPath>`;
  const lines = series.map((s, idx) => {
    const isDashed = s.dashed === true;
    const hasFill = s.fill === true;
    const points = s.values.map((v, i) => ({ x: x(i), y: y(v), v }));
    const d = buildPath(points);
    const firstX = x(0);
    const lastX = x(Math.max(0, s.values.length - 1));
    let fill = "";
    if (hasFill) {
      const gradId = `chartGrad_${nonce}_${idx}`;
      defs += `<linearGradient id="${gradId}" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="${s.color}" stop-opacity="0.32"></stop><stop offset="65%" stop-color="${s.color}" stop-opacity="0.14"></stop><stop offset="100%" stop-color="${s.color}" stop-opacity="0.03"></stop></linearGradient>`;
      fill = `<path class="oce-chart-fill" fill="url(#${gradId})" d="${d} L ${lastX} ${h - pad.bottom} L ${firstX} ${h - pad.bottom} Z"></path>`;
    }
    const line = isDashed
      ? `<path class="oce-chart-line area area-fade" stroke="${s.color}" d="${d}"></path>`
      : `<path class="oce-chart-line reveal combined" stroke="${s.color}" d="${d}" pathLength="1" style="animation-delay:${Math.min(0.24, idx * 0.05)}s"></path>`;
    let projected = "";
    if (hasLimit && Array.isArray(s.projectedValues) && s.projectedValues.length === labels.length) {
      const projectedPoints = s.projectedValues.map((v, i) => ({ x: x(i), y: y(v), v }));
      const projectedD = buildPath(projectedPoints);
      projected = `<path class="oce-chart-line projected-base" stroke="${s.color}" d="${projectedD}"></path><path class="oce-chart-line projected-over" stroke="${s.color}" d="${projectedD}" clip-path="url(#${clipId})"></path>`;
    }
    return `${fill}${line}${projected}`;
  }).join("");
  const step = tickEvery || Math.max(2, Math.ceil(labels.length / 20));
  const tickAngle = denseGrid && !mobileCompact ? -50 : 0;
  const ticks = labels.map((l, i) => ({ l, i }))
    .filter(({ l, i }) => (mobileCompact ? isMobileMajorHourLabel(l) : i % step === 0) || i === labels.length - 1)
    .map(({ l, i }) => {
      const tx = x(i);
      const ty = h - 16;
      const displayLabel = mobileCompact ? l.slice(0, 2) : l;
      return `<text class="oce-chart-label" x="${tx}" y="${ty}" text-anchor="middle" transform="${tickAngle ? `rotate(${tickAngle} ${tx} ${ty})` : ""}">${displayLabel}</text>`;
    }).join("");
  const timeDots = mobileCompact
    ? labels.map((l, i) => isHourLabel(l) ? "" : `<circle class="oce-chart-time-dot" cx="${x(i)}" cy="${h - 22}" r="1.9"></circle>`).join("")
    : "";
  const yTicksForLabels = mobileCompact ? tickValues.filter((_, i, a) => i === 0 || i === a.length - 1 || i === Math.floor(a.length / 2)) : tickValues;
  const yAxisTicks = yTicksForLabels.map((v) => {
    const yy = y(v);
    const above = hasLimit && v > limitW;
    return mobileCompact
      ? `<text class="oce-chart-label in-chart${above ? " over-limit-axis" : ""}" x="${pad.left + 3}" y="${yy - 4}" text-anchor="start">${de0(v)} ${unit}</text>`
      : `<text class="oce-chart-label${above ? " over-limit-axis" : ""}" x="${pad.left - 8}" y="${yy + 4}" text-anchor="end">${de0(v)}</text>`;
  }).join("");
  const limitGuide = hasLimit ? `<line class="oce-chart-limit-line" x1="${pad.left}" y1="${limitY}" x2="${w - pad.right}" y2="${limitY}"></line><text class="oce-chart-label oce-chart-limit-label" x="${pad.left + 4}" y="${Math.max(16, limitY - 6)}">${escapeHtml(systemLimitDescriptor())} ${de0(limitW)} W</text>` : "";
  el.innerHTML = `<svg viewBox="0 0 ${w} ${h}" width="100%" height="100%" role="img"><defs>${defs}</defs>${horizontalGrid}${verticalGrid}${limitGuide}${yAxisTicks}${lines}${timeDots}<g class="oce-chart-hover-layer"></g>${ticks}</svg><div class="oce-chart-hover-tip" hidden></div>`;
  if (!interactive) return;
  const svg = el.querySelector("svg");
  const hoverLayer = el.querySelector(".oce-chart-hover-layer");
  const tip = el.querySelector(".oce-chart-hover-tip");
  let touchScrubActive = false;
  const hideTip = () => { tip.hidden = true; hoverLayer.innerHTML = ""; };
  const showAt = (clientX, clientY) => {
    const rect = svg.getBoundingClientRect();
    const vX = ((clientX - rect.left) / rect.width) * w;
    const idx = Math.round((vX - pad.left) / ((w - pad.left - pad.right) / Math.max(1, labels.length - 1)));
    const safeIdx = Math.max(0, Math.min(labels.length - 1, idx));
    if (!labels.length) return;
    const px = x(safeIdx);
    const rows = series.map((s) => ({ name: s.name, color: s.color, value: s.values[safeIdx] || 0, projected: Array.isArray(s.projectedValues) ? (s.projectedValues[safeIdx] || 0) : null }));
    const marker = rows.map((row) => `<circle class="oce-chart-dot" cx="${px}" cy="${y(row.value)}" r="4" stroke="${row.color}"></circle>`).join("");
    hoverLayer.innerHTML = `<line class="oce-chart-hover-line" x1="${px}" y1="${pad.top}" x2="${px}" y2="${h - pad.bottom}"></line>${marker}`;
    tip.innerHTML = `<strong>${labels[safeIdx]}</strong>${rows.map((row) => `<div class="row"><span class="key"><i style="background:${row.color}"></i>${escapeHtml(row.name)}</span><span>${de(row.value, 2)} ${unit}</span></div>${row.projected != null && row.projected > row.value ? `<div class="row"><span class="key"><i style="background:${row.color};opacity:0.45"></i>Ohne ${escapeHtml(systemLimitDescriptor())}</span><span>${de(row.projected, 2)} ${unit}</span></div>` : ""}`).join("")}`;
    tip.hidden = false;
    let left = clientX - rect.left + 12;
    let top = clientY - rect.top - 16;
    if (left + tip.offsetWidth > el.clientWidth - 8) left = Math.max(8, el.clientWidth - tip.offsetWidth - 8);
    if (top + tip.offsetHeight > el.clientHeight - 8) top = Math.max(8, el.clientHeight - tip.offsetHeight - 8);
    if (top < 8) top = 8;
    tip.style.left = `${left}px`;
    tip.style.top = `${top}px`;
  };
  svg.addEventListener("mousemove", (event) => showAt(event.clientX, event.clientY));
  svg.addEventListener("mouseleave", hideTip);
  svg.addEventListener("touchstart", (event) => {
    const t = event.touches[0];
    if (!t) return;
    touchScrubActive = true;
    event.preventDefault();
    showAt(t.clientX, t.clientY);
  }, { passive: false });
  svg.addEventListener("touchmove", (event) => {
    const t = event.touches[0];
    if (!t) return;
    if (touchScrubActive) event.preventDefault();
    showAt(t.clientX, t.clientY);
  }, { passive: false });
  svg.addEventListener("touchend", () => { touchScrubActive = false; hideTip(); });
  svg.addEventListener("touchcancel", () => { touchScrubActive = false; hideTip(); });
}

function forecastBars(el, labels, values, mode, meta = {}) {
  const mobileCompact = window.matchMedia("(max-width: 820px)").matches;
  const w = mobileCompact ? 880 : 1260;
  const h = mobileCompact ? 340 : 300;
  const p = mobileCompact ? { top: 18, right: 14, bottom: 54, left: 16 } : { top: 20, right: 20, bottom: 56, left: 26 };
  const max = Math.max(0.01, ...values);
  const usableW = w - p.left - p.right;
  const usableH = h - p.top - p.bottom;
  const slot = usableW / Math.max(1, labels.length);
  const barW = mode === "day" ? Math.min(9, Math.max(3, slot * 0.42)) : Math.min(16, Math.max(5, slot * 0.42));
  let bars = "";
  const rects = [];
  values.forEach((v, i) => {
    const bh = Math.max(2, (v / max) * usableH);
    const x = p.left + i * slot + (slot - barW) / 2;
    const y = h - p.bottom - bh;
    rects.push({ x, y, w: barW, h: bh, i });
    bars += `<rect class="forecast-bar" data-i="${i}" x="${x}" y="${y}" width="${barW}" height="${bh}" style="animation-delay:${Math.min(0.5, i * 0.008)}s"></rect>`;
  });
  const yTicks = [0, 0.25, 0.5, 0.75, 1].map((t) => {
    const yy = p.top + (1 - t) * usableH;
    const val = de(max * t, 2);
    return `<line class="forecast-grid" x1="${p.left}" y1="${yy}" x2="${w - p.right}" y2="${yy}"></line><text class="forecast-y-label" x="${p.left - 2}" y="${yy - 4}" text-anchor="start">${val}</text>`;
  }).join("");
  const divisor = mode === "day" ? (mobileCompact ? 4 : 6) : mode === "month" ? (mobileCompact ? 6 : 4) : mode === "year" ? (mobileCompact ? 3 : 1) : 1;
  const xTicks = labels.map((label, i) => ({ label, i })).filter((_, i) => i % divisor === 0 || i === labels.length - 1).map(({ label, i }) => {
    const xx = p.left + i * slot + slot / 2;
    return `<text class="forecast-x-label" x="${xx}" y="${h - 16}" text-anchor="middle">${escapeHtml(label)}</text>`;
  }).join("");
  el.innerHTML = `<svg viewBox="0 0 ${w} ${h}" width="100%" height="100%" role="img">${yTicks}${bars}${xTicks}</svg><div class="oce-chart-hover-tip" hidden></div>`;
  const tip = el.querySelector(".oce-chart-hover-tip");
  const svg = el.querySelector("svg");
  if (!tip || !svg) return;
  const hide = () => { tip.hidden = true; };
  el.querySelectorAll(".forecast-bar").forEach((bar) => {
    bar.addEventListener("mousemove", (event) => {
      const idx = Number(bar.dataset.i);
      const kwh = Array.isArray(meta.kwhValues) ? (meta.kwhValues[idx] || 0) : 0;
      tip.innerHTML = `<strong>${escapeHtml(labels[idx] || "")}</strong><div class="row"><span>Ersparnis</span><span>${de(values[idx] || 0, 2)} €</span></div><div class="row"><span>Erzeugung</span><span>${de(kwh, 2)} kWh</span></div>`;
      tip.hidden = false;
      const r = svg.getBoundingClientRect();
      let left = event.clientX - r.left + 10;
      let top = event.clientY - r.top - 12;
      if (left + tip.offsetWidth > el.clientWidth - 8) left = el.clientWidth - tip.offsetWidth - 8;
      if (top + tip.offsetHeight > el.clientHeight - 8) top = el.clientHeight - tip.offsetHeight - 8;
      if (top < 8) top = 8;
      tip.style.left = `${Math.max(8, left)}px`;
      tip.style.top = `${top}px`;
    });
    bar.addEventListener("mouseleave", hide);
  });
}

function stackedBars(el, labels, stacks, colors, unit, opts = {}) {
  const { mobileCompact = false } = opts;
  const w = mobileCompact ? 840 : 520;
  const h = mobileCompact ? 320 : 250;
  const p = mobileCompact ? 24 : 36;
  const totals = stacks.map((s) => sum(s));
  const max = Math.max(1, ...totals);
  const slot = (w - 2 * p) / labels.length;
  const bw = slot * 0.58;
  let bars = "";
  stacks.forEach((s, i) => {
    let y0 = h - p;
    const x = p + i * slot + (slot - bw) / 2;
    s.forEach((v, j) => { const bh = (v / max) * (h - 2 * p); y0 -= bh; bars += `<rect class="oce-chart-bar" x="${x}" y="${y0}" width="${bw}" height="${Math.max(1, bh)}" fill="${colors[j % colors.length]}"></rect>`; });
    const showLabel = !mobileCompact || i % 2 === 0 || i === labels.length - 1;
    if (showLabel) bars += `<text class="oce-chart-label" x="${x + bw / 2}" y="${h - 8}" text-anchor="middle">${labels[i]}</text>`;
  });
  const grid = [0, 0.5, 1].map((g) => `<line class="oce-chart-grid" x1="${p}" y1="${p + g * (h - 2 * p)}" x2="${w - p}" y2="${p + g * (h - 2 * p)}"/>`).join("");
  el.innerHTML = `<svg viewBox="0 0 ${w} ${h}" width="100%" height="100%" role="img">${grid}<text class="oce-chart-label" x="${p}" y="18">${de(max, 1)} ${unit}</text>${bars}</svg>`;
}

function simpleBars(el, labels, values, color, unit, opts = {}) {
  const { mobileCompact = false } = opts;
  const w = mobileCompact ? 840 : 520;
  const h = mobileCompact ? 320 : 250;
  const p = mobileCompact ? 24 : 38;
  const max = Math.max(1, ...values);
  const slot = (w - 2 * p) / values.length;
  const bw = slot * 0.56;
  const grid = [0, 0.5, 1].map((g) => `<line class="oce-chart-grid" x1="${p}" y1="${p + g * (h - 2 * p)}" x2="${w - p}" y2="${p + g * (h - 2 * p)}"/>`).join("");
  const bars = values.map((v, i) => { const bh = (v / max) * (h - 2 * p); const x = p + i * slot + (slot - bw) / 2; const y = h - p - bh; return `<rect class="oce-chart-bar" x="${x}" y="${y}" width="${bw}" height="${Math.max(1, bh)}" fill="${color}"></rect><text class="oce-chart-value" x="${x + bw / 2}" y="${Math.max(16, y - 6)}" text-anchor="middle">${de0(v)}</text><text class="oce-chart-label" x="${x + bw / 2}" y="${h - 8}" text-anchor="middle">${labels[i]}</text>`; }).join("");
  el.innerHTML = `<svg viewBox="0 0 ${w} ${h}" width="100%" height="100%" role="img">${grid}<text class="oce-chart-label" x="${p}" y="18">${de0(max)} ${unit}</text>${bars}</svg>`;
}

function paybackBars(el, labels, savings, systemCost, opts = {}) {
  const { mobileCompact = false } = opts;
  const w = mobileCompact ? 840 : 520;
  const h = mobileCompact ? 320 : 250;
  const p = mobileCompact ? 24 : 38;
  const axisPad = mobileCompact ? 40 : 54;
  const maxYears = 20;
  const cumulative = savings.slice(1, maxYears + 1).map((v) => v - systemCost);
  const values = [-systemCost, ...cumulative];
  const allMin = Math.min(0, ...values);
  const allMax = Math.max(0, ...values);
  const range = Math.max(1, allMax - allMin);
  const innerH = h - 2 * p;
  const zeroY = p + ((allMax / range) * innerH);
  const barCount = values.length;
  const plotLeft = p + axisPad;
  const plotRight = w - p;
  const plotW = plotRight - plotLeft;
  const slot = plotW / Math.max(1, barCount);
  const bw = slot * 0.62;
  const yFor = (v) => p + ((allMax - v) / range) * innerH;
  const gridVals = [allMin, (allMin + allMax) / 2, allMax];
  const grid = gridVals.map((v) => {
    const y = yFor(v);
    return `<line class="oce-chart-grid" x1="${plotLeft}" y1="${y}" x2="${plotRight}" y2="${y}"/><text class="oce-chart-label" x="${p}" y="${Math.max(16, y - 4)}" text-anchor="start">${de0(v)} €</text>`;
  }).join("");
  const zeroLine = `<line class="oce-chart-grid" x1="${plotLeft}" y1="${zeroY}" x2="${plotRight}" y2="${zeroY}" stroke="${getCss("--border")}"/>`;
  const bars = values.map((v, i) => {
    const x = plotLeft + i * slot + (slot - bw) / 2;
    const y = v >= 0 ? yFor(v) : zeroY;
    const barH = Math.max(1, Math.abs(zeroY - yFor(v)));
    const fill = v < 0 ? getCss("--accent") : getCss("--primary");
    const label = String(i);
    return `<rect class="oce-chart-bar payback-bar" data-i="${i}" x="${x}" y="${v >= 0 ? y : zeroY}" width="${bw}" height="${barH}" fill="${fill}"></rect><text class="oce-chart-label" x="${x + bw / 2}" y="${h - 8}" text-anchor="middle">${label}</text>`;
  }).join("");
  const yearTicks = labels.slice(0, maxYears + 1).map((_, i) => `<text class="oce-chart-label" x="${plotLeft + i * slot + slot / 2}" y="${h - 8}" text-anchor="middle">${i}</text>`).join("");
  el.innerHTML = `<svg viewBox="0 0 ${w} ${h}" width="100%" height="100%" role="img">${grid}${zeroLine}${bars}${yearTicks}</svg><div class="oce-chart-hover-tip" hidden></div>`;
  const tip = el.querySelector(".oce-chart-hover-tip");
  const svg = el.querySelector("svg");
  if (!tip || !svg) return;
  const hide = () => { tip.hidden = true; };
  el.querySelectorAll(".payback-bar").forEach((bar) => {
    bar.addEventListener("mousemove", (event) => {
      const idx = Number(bar.dataset.i);
      const value = values[idx] || 0;
      const title = String(idx);
      tip.innerHTML = `<strong>${escapeHtml(title)}</strong><div class="row"><span>${idx === 0 ? "Kosten" : "Kumuliert"}</span><span>${idx === 0 ? `-${de0(systemCost)} €` : `${value >= 0 ? "+" : ""}${de0(value)} €`}</span></div>`;
      tip.hidden = false;
      const r = svg.getBoundingClientRect();
      let left = event.clientX - r.left + 10;
      let top = event.clientY - r.top - 12;
      if (left + tip.offsetWidth > el.clientWidth - 8) left = el.clientWidth - tip.offsetWidth - 8;
      if (top + tip.offsetHeight > el.clientHeight - 8) top = el.clientHeight - tip.offsetHeight - 8;
      if (top < 8) top = 8;
      tip.style.left = `${Math.max(8, left)}px`;
      tip.style.top = `${top}px`;
    });
    bar.addEventListener("mouseleave", hide);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  try {
    loadLocal();
    loadFromUrl();
    runtimeState.wasIntegratedInverter = usesBatteryIntegratedInverter();
    runtimeState.previousPlugSolarLimit = null;
    runtimeState.previousInverterPower = null;
    applyTheme();
    buildCompassRose();
    bindInputs();
    syncInputs();
    readInputsToState({ allowEvPrompt: false });
    updateSystemCostBreakdownUi({ normalizeSource: true });
    syncInputs();
    renderAll(false);
    refresh();
  } catch (err) {
    console.error(err);
    const status = $("apiStatus");
    if (status) status.textContent = `Init-Fehler: ${err.message}`;
  }
});

window.addEventListener("error", (event) => {
  const status = $("apiStatus");
  if (status) status.textContent = `Runtime-Fehler: ${event.message}`;
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = event?.reason?.message || String(event?.reason || "Unbekannter Promise-Fehler");
  const status = $("apiStatus");
  if (status) status.textContent = `Promise-Fehler: ${reason}`;
});
